<template>
  <div class="page">
    <div class="header">
      <img
        src="@/assets/aiTeacher/ic-back.png"
        class="ic-back"
        @click="handleBackClick"
      />
      <div class="historyTitle" v-if="showHistoryPage">
        英语陪练
      </div>
      <div class="header-right">
        <div class="ic-grade" @click="showGradeDialog = true" v-if="!showHistoryPage">{{ gradeName }} <div class="ic-grade-arrow"></div></div>

        <div class="ic-history" @click="showHistoryDialog = true" v-if="!showHistoryPage">历史对话</div>
      </div>
    </div>

    <template v-if="!showHistoryPage">
      <div 
      v-if="!showDialogBox" 
      class="teacher-container" 
      @click="currentChatId ? openDialogBox() : null"
    >
      <img class="teacher" :src="currentFrameSrc" alt="" />
    </div>

    <div class="dialog-box" v-if="showDialogBox">
      <img
        :src="currentFrameSrc"
        class="teacher-pic"
        @click="showDialogBox = false"
      />
      <div class="box">
        <!-- 标题 -->
        <div class="box-title">英语陪练</div>

        <!-- 聊天消息区域 -->
        <div class="box-chat-list" ref="boxChatListRef">
          <div
            v-for="(item, index) in filteredChatList"
            :key="index"
            :class="['box-message-item', item.role === 'user' ? 'user' : 'ai']"
          >
            <div class="box-message-wrapper">
              <img
                class="user_avatar"
                v-if="item.role === 'user'"
                src="@/assets/aiTeacher/default-avatar.png"
              />
              <img
                class="ai_avatar"
                v-if="item.role === 'ai'"
                src="@/assets/aiTeacher/teacher-avatar.png"
              />
              <div class="box-message-content">
                <div
                  v-if="item.renderedContent"
                  class="selectable-text"
                  v-html="item.renderedContent"
                ></div>
                <div v-else-if="item.content">{{ item.content }}</div>
                <!-- AI 加载状态（在气泡内部） -->
                <div v-if="item.loading" class="ai-loading-container">
                  <div class="loading-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 只在用户消息时显示评分提示 -->
            <div v-if="item.role === 'user'" class="toast-box">
              <div v-if="item.errorStatus === 0" class="correct-box" @click="showCorrection(index)">纠正</div>
              <div v-if="item.errorStatus === 1 && item.score !== undefined" class="point-box">发音{{ item.score }}分</div>
            </div>
          </div>
        </div>

        <!-- 收起按钮 -->
        <div class="box-collapse" @click="showDialogBox = false">收起</div>
      </div>
    </div>
    <div class="bottom">
      <div class="tabList" v-if="!showDialogBox">
        <div
          v-for="item in promptList"
          :key="item.promptId"
          class="tab-item"
          :class="{ active: promptId === item.promptId }"
          @click="handleSelectPrompt(item)"
        >
          {{ item.label }}
        </div>
      </div>

      <!-- 底部输入区 -->
      <div v-if="!isShowVoice" class="input-area">

        <div>
          <!-- 录音状态指示器：根据音频播放、录音和自动监听状态动态显示 -->
          <div v-if="showRecordingIndicator" class="recording-controls">
            <div class="recording-indicator" :class="{ thinking: isResponding && !isPlayingAudioRef && audioQueueLengthRef === 0 && !isInSession }">
              {{ recordingIndicatorText }}
              <span v-if="isResponding && !isPlayingAudioRef && audioQueueLengthRef === 0 && !isInSession" class="thinking-dots">
                <span>.</span><span>.</span><span>.</span>
              </span>
            </div>
          </div>
        </div>
        <!-- ✅ 修改：条件显示"进入对话"按钮或声波可视化器 -->
        <!-- ✅ 切换模版修复：切换中不显示进入对话按钮，用主内容区（加载状态）代替 -->
        <div v-if="!isReadyToEnterConversation || (!currentChatId && !isEnteringConversation && !isTemplateSwitching)" class="sound-wave-container">
          <div v-if="isReadyToEnterConversation" class="enter-conversation-btn" @click="handleEnterConversation">
            进入对话
          </div>
          <div v-else class="loading-text">加载中...</div>
        </div>
        
        <div v-else class="sound-wave-container">
          <!-- 加载中：调用接口等待数据但没开始播放音频时显示 -->
          <!-- ✅ 两个模版修复：接口返回后、TTS 音频到达前也显示加载（避免短暂显示可录音状态） -->
          <!-- ✅ 切换模版修复：切换模版中显示加载，避免短暂显示进入对话按钮 -->
          <div 
            v-show="(isResponding || isTtsTextAllSent || isTemplateSwitching) && !isPlayingAudioRef && audioQueueLengthRef === 0 && !isInSession"
            class="isLoading"
          >
            <img src="@/assets/aiTeacher/loading.png" alt="" class="loading-icon">
            <span>正在加载中<span class="thinking-dots"><span>.</span><span>.</span><span>.</span></span></span>
          </div>

          <!-- 原来的sound-wave：播放音频时显示 -->
          <div 
            class="sound-wave" 
            v-show="!isInSession && (isPlayingAudioRef || audioQueueLengthRef > 0)"
          >
            <div
              v-for="(bar, index) in 8"
              :key="index"
              class="wave-bar"
              :class="{ 
                active: isPlayingAudioRef || audioQueueLengthRef > 0,
                'playing': (isPlayingAudioRef || audioQueueLengthRef > 0)
              }"
            ></div>
          </div>

          <!-- 录音按钮：不播放音频且不录音且不在响应中且非等待 TTS 音频时显示，可以长按开始录音 -->
          <!-- ✅ 两个模版修复：等待 TTS 音频时也隐藏麦克风，避免短暂显示可录音状态 -->
          <!-- ✅ 切换模版修复：切换模版中隐藏麦克风，显示加载状态 -->
          <img 
            v-show="!isInSession && !isPlayingAudioRef && audioQueueLengthRef === 0 && !isResponding && !isTtsTextAllSent && !isTemplateSwitching"
            src="@/assets/aiTeacher/mic.png" 
            alt="" 
            class="mic-icon"
            @touchstart.prevent="handleMicPressStart"
            @touchend.prevent="handleMicPressEnd"
            @mousedown.prevent="handleMicPressStart"
            @mouseup.prevent="handleMicPressEnd"
            @mouseleave.prevent="handleMicPressEnd"
          >

          <!-- 录音时的波浪可视化（参考VoicePop.vue） -->
          <div v-show="isInSession" class="recording-wave-container">
            <div class="recwave">
              <canvas
                ref="recordingWaveCanvas"
                class="recwave-WaveView"
                width="253"
                height="100"
              ></canvas>
            </div>
          </div>
        </div>
        <!-- 如果可以暂停输出，显示停止图标；否则显示发送按钮（互斥显示） -->
         <div class="tips-btn" @click="showTipsDialog = true" v-if="promptContent && !isDialogueEnded && !isTemplateSwitching && promptId == 17">
          <img src="@/assets/ic-light-blue.png" alt="">
          提示一下
         </div>
        <template v-if="!isshowSpeakIcon">
          <div v-if="canStopResponse" class="stop-icon">
            <img src="@/assets/ic-stop1.png" @click="stopAudioOnly" />
            <div>中断 Miya 说话</div>
          </div>
        </template>
        <div class="ai-tips">内容由AI生成</div>
      </div>
    </div>
    </template>

    <div v-if="showHistoryPage" class="history-box">
      <!-- 聊天消息区域 -->
      <div class="box-chat-list" ref="historyChatListRef">
        <div
          v-for="(item, index) in historyChatList"
          :key="index"
          :class="['box-message-item', item.role === 'user' ? 'user' : 'ai']"
        >
          <div class="box-message-wrapper">
            <img
              class="user_avatar"
              v-if="item.role === 'user'"
              src="@/assets/aiTeacher/default-avatar.png"
            />
            <img
              class="ai_avatar"
              v-if="item.role === 'ai'"
              src="@/assets/aiTeacher/teacher-avatar.png"
            />
            <div class="box-message-content">
              <div
                v-if="item.renderedContent"
                class="selectable-text"
                v-html="item.renderedContent"
              ></div>
              <div v-else-if="item.content">{{ item.content }}</div>
            </div>
          </div>

          <!-- 只在用户消息时显示评分提示（与对话内气泡同布局） -->
          <div v-if="item.role === 'user'" class="toast-box">
            <div v-if="item.errorStatus === 0" class="correct-box" @click="showHistoryCorrection(index)">纠正</div>
            <div v-if="item.errorStatus === 1 && item.score !== undefined" class="point-box">发音{{ item.score }}分</div>
          </div>
        </div>
      </div>
    </div>
    

    

    <!-- 语音录音弹窗组件 -->
    <VoicePop
      :showPopUp="isShowVoice"
      :isCanceling="isCanceling"
      @close="handleVoiceClose"
      @saveVoice="saveVoice"
    />
    
    <TipsDialog
      :showTipsDialog="showTipsDialog"
      :promptContent="promptContent"
      @close="showTipsDialog = false"
    />
    <AdviceDialog
      :showAdviceDialog="showAdviceDialog"
      :adviceContent="adviceContent"
      :reasonContent="reasonContent"
      @close="showAdviceDialog = false"
    />
    <!-- 历史对话弹窗 -->
    <HistoryDialog
      :visible="showHistoryDialog"
      :current-chat-id="currentChatId"
      :ai-token="aiToken"
      :prompt-id="promptId"
      @close="showHistoryDialog = false"
      @select="handleSelectHistory"
      @delete="handleDeleteHistory"
      @toHistory="handleToHistory"
    />
    <!-- 切换年级弹窗 -->
    <ChangeGrade
      :visible="showGradeDialog"
      :current-grade-id="gradeId"
      :grade-list="gradeListData"
      @close="showGradeDialog = false"
      @confirm="handleGradeChangeConfirm"
    />
    <!-- 切换确认弹窗 -->
    <SwitchConfirmDialog
      :visible="showSwitchConfirmDialog"
      @close="showSwitchConfirmDialog = false"
      @confirm="handleSwitchConfirm"
      @cancel="handleSwitchCancel"
    />
    <!-- 调试快捷发送（本地无麦克风时使用，用 showDebugButtons 控制显示） -->
    <DebugSendButtons :visible="showDebugButtons" @send="handleDebugSend" />
  </div>

</template>

<script>
export default {
  name: "AiTeacher",
};
</script>

<script setup>
/* eslint-disable no-unused-vars, no-empty */
import { ref, onMounted, nextTick, onUnmounted, computed, watch } from "vue";
import { useRouter } from "vue-router";
import HistoryDialog from "./components/HistoryDialog.vue";
import TipsDialog from "./components/TipsDialog.vue";
import AdviceDialog from "./components/AdviceDialog.vue";
import ChangeGrade from "./components/ChangeGrade.vue";
import SwitchConfirmDialog from "./components/SwitchConfirmDialog.vue";
import DebugSendButtons from "./components/DebugSendButtons.vue";
import {
  getPromptList,
  newChat,
  resultByTextToTTs,
  audioClose,
  closeChat,
  sendSpokenChatCompletionsStream,
  newThemeChat,
  confirmTheme,
  sendThemeChatMessage,
  scoreSentence,
  selectGrades,
} from "@/api/aiTeacher.js";
import { mp3ToText, aiAuth } from "@/api/chat.js";
import { blobToBase64 } from "@/utils/audio.js";
import VoicePop from "@/components/voice/VoicePop.vue";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from "@ffmpeg/util";
import { createTtsWebSocketManager } from "@/api/ttsWebsocket.js";
import { showToast } from "vant";
import { marked } from "marked";
// 提示音频文件路径（使用 public 目录下的文件，避免 webpack 编译错误）
// 注意：public 目录下的文件可以直接通过绝对路径访问，不需要 webpack 处理
const audio1 = "/audio1.opus";
const audio2 = "/audio2.opus";
const audio3 = "/audio3.opus";
const audio4 = "/audio4.opus";
const showTipsDialog = ref(false);
const showAdviceDialog = ref(false);
const showHistoryPage = ref(false);

// 历史对话假数据
const historyChatList = ref([
  {
    role: "user",
    content: "Hello, how are you today?",
    renderedContent: "",
    score: 92,
  },
  {
    role: "ai",
    content: "Hello! I'm doing great, thank you for asking. How about you? How has your day been so far?",
    renderedContent: "",
  },
  {
    role: "user",
    content: "I'm learning English. Can you help me practice?",
    renderedContent: "",
    score: 85,
  },
  {
    role: "ai",
    content: "Of course! I'd be happy to help you practice English. What would you like to work on today? We can practice conversation, grammar, vocabulary, or pronunciation.",
    renderedContent: "",
  },
  {
    role: "user",
    content: "I want to improve my pronunciation.",
    renderedContent: "",
    score: 78,
  },
  {
    role: "ai",
    content: "Great choice! Pronunciation is very important for clear communication. Let's start with some basic sounds. Can you try saying these words: 'think', 'this', 'three', and 'that'?",
    renderedContent: "",
  },
  {
    role: "user",
    content: "Think, this, three, that.",
    renderedContent: "",
    score: 90,
  },
  {
    role: "ai",
    content: "Excellent! Your pronunciation is getting better. The 'th' sound can be tricky, but you're doing well. Keep practicing!",
    renderedContent: "",
  },
]);

// 初始化历史数据的 renderedContent
const initHistoryChatList = () => {
  if (typeof renderMath === 'function') {
    historyChatList.value.forEach((item) => {
      if (item.content && !item.renderedContent) {
        item.renderedContent = renderMath(item.content);
      }
    });
  }
};
// 音频处理 Worker
let audioWorker = null;
const workerResultMap = new Map();
let workerTaskIdCounter = 0;
let isTabletDeviceFlag = false; // 平板设备标识

// ✅ 新增：标记是否正在等待更多音频（用于模板17两段音频的情况）
let isWaitingForMoreAudio = false;

// ✅ 新增：模板17的音频接收超时定时器（3秒无新音频则finish）
let template17AudioTimeoutTimer = null;
let lastAudioReceiveTime = 0; // 最后一次接收音频的时间

// ✅ 新增：标记对话是否已结束（shouldSummarizeNow为true时设置）
const isDialogueEnded = ref(false);

// ✅ 新增：音频缓存机制（减少重复解码开销）
const audioBufferCache = new Map(); // Map<audioHash, AudioBuffer>
const MAX_CACHE_SIZE = 50; // 最多缓存50个音频

// 获取缓存的音频
function getCachedAudio(audioHash) {
  return audioBufferCache.get(audioHash);
}

// 添加音频到缓存
function addToAudioCache(audioHash, audioBuffer) {
  if (audioBufferCache.size >= MAX_CACHE_SIZE) {
    // 删除最早的缓存项
    const firstKey = audioBufferCache.keys().next().value;
    audioBufferCache.delete(firstKey);
  }
  audioBufferCache.set(audioHash, audioBuffer);
}

// 生成音频哈希（简单实现：使用音频大小和前100字节）
async function generateAudioHash(blob) {
  try {
    const arrayBuffer = await blob.slice(0, 100).arrayBuffer();
    const bytes = new Uint8Array(arrayBuffer);
    let hash = blob.size.toString();
    for (let i = 0; i < bytes.length; i++) {
      hash += bytes[i].toString(16);
    }
    return hash;
  } catch (e) {
    return blob.size.toString() + Date.now();
  }
}

function initAudioWorker() {
  // ✅ 平板部署：统一使用主线程，不使用 Worker
  isTabletDeviceFlag = true;
  audioWorker = null;
}

// Base64转Blob（优化：平板设备优先主线程，提高阈值）
function base64ToBlobByWorker(audioBase64, callback) {
  if (!audioBase64) {
    callback(null, "音频数据为空");
    return;
  }

  // ✅ 平板部署：直接主线程解码（避免 Worker 异步导致合并时 chunk 未就绪）
  try {
    const byteCharacters = atob(audioBase64);
    const byteLength = byteCharacters.length;
    const byteNumbers = new Uint8Array(byteLength);
    for (let i = 0; i < byteLength; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([byteNumbers], { type: "audio/opus; codecs=opus" });
    callback(blob);
  } catch (e) {
    callback(null, e);
  }
}

// Blob合并（优化：平板设备优先主线程）
function mergeBlobsByWorker(blobs, callback) {
  if (!blobs || blobs.length === 0) {
    callback(null, "Blob数组为空");
    return;
  }

  if (blobs.length === 1) {
    callback(blobs[0]);
    return;
  }

  // ✅ 平板部署：直接主线程合并
  try {
    const mergedBlob = new Blob(blobs, { type: "audio/opus; codecs=opus" });
    callback(mergedBlob);
  } catch (e) {
    callback(null, e);
  }
}

// 将 WebM 音频转换为 16k 采样率、16bit、单声道的 WAV 格式
async function convertAudioToWav16k(audioBlob) {
  try {
    
    // 1. 创建 AudioContext 用于解码和重采样
    // ✅ 修复：明确指定为播放模式，避免被识别为通话应用
    const audioContext = new (window.AudioContext || window.webkitAudioContext)({
      latencyHint: "playback", // 播放模式，使用媒体音量通道
      sampleRate: 16000 // 目标采样率 16k
    });
    
    // 2. 将 Blob 转换为 ArrayBuffer
    const arrayBuffer = await audioBlob.arrayBuffer();
    
    // 3. 解码音频数据
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
    
    // 4. 获取单声道数据（如果是多声道，取第一个声道）
    const channelData = audioBuffer.getChannelData(0);
    
    // 5. 如果原始采样率不是 16k，需要重采样
    let resampledData;
    if (audioBuffer.sampleRate !== 16000) {
      // 创建离线音频上下文进行重采样
      const offlineContext = new OfflineAudioContext(1, audioBuffer.duration * 16000, 16000);
      const source = offlineContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(offlineContext.destination);
      source.start(0);
      const resampledBuffer = await offlineContext.startRendering();
      resampledData = resampledBuffer.getChannelData(0);
    } else {
      resampledData = channelData;
    }
    
    // 6. 将 Float32Array 转换为 16bit PCM (Int16Array)
    const pcmData = new Int16Array(resampledData.length);
    for (let i = 0; i < resampledData.length; i++) {
      // 将 [-1, 1] 范围的浮点数转换为 [-32768, 32767] 范围的整数
      const s = Math.max(-1, Math.min(1, resampledData[i]));
      pcmData[i] = s < 0 ? s * 0x8000 : s * 0x7FFF;
    }
    
    // 7. 构建 WAV 文件头
    const wavHeader = createWavHeader(pcmData.length * 2, 16000, 1, 16);
    
    // 8. 合并 WAV 头和 PCM 数据
    const wavBuffer = new ArrayBuffer(wavHeader.byteLength + pcmData.byteLength);
    const wavView = new Uint8Array(wavBuffer);
    wavView.set(new Uint8Array(wavHeader), 0);
    wavView.set(new Uint8Array(pcmData.buffer), wavHeader.byteLength);
    
    
    // 9. 转换为 Base64
    const base64 = arrayBufferToBase64(wavBuffer);
    
    // 清理 AudioContext
    audioContext.close();
    
    return base64;
  } catch (error) {
    
    // ✅ 降级方案：如果转换失败，直接返回原始音频的 Base64
    try {
      const base64 = await blobToBase64(audioBlob);
      return base64;
    } catch (fallbackError) {
      throw error; // 抛出原始错误
    }
  }
}

// 创建 WAV 文件头
function createWavHeader(dataLength, sampleRate, numChannels, bitsPerSample) {
  const buffer = new ArrayBuffer(44);
  const view = new DataView(buffer);
  
  // RIFF 标识符
  writeString(view, 0, 'RIFF');
  // 文件长度
  view.setUint32(4, 36 + dataLength, true);
  // WAVE 标识符
  writeString(view, 8, 'WAVE');
  // fmt 子块
  writeString(view, 12, 'fmt ');
  // fmt 子块大小
  view.setUint32(16, 16, true);
  // 音频格式 (1 = PCM)
  view.setUint16(20, 1, true);
  // 声道数
  view.setUint16(22, numChannels, true);
  // 采样率
  view.setUint32(24, sampleRate, true);
  // 字节率 (采样率 * 声道数 * 每样本字节数)
  view.setUint32(28, sampleRate * numChannels * (bitsPerSample / 8), true);
  // 块对齐 (声道数 * 每样本字节数)
  view.setUint16(32, numChannels * (bitsPerSample / 8), true);
  // 每样本位数
  view.setUint16(34, bitsPerSample, true);
  // data 子块
  writeString(view, 36, 'data');
  // data 子块大小
  view.setUint32(40, dataLength, true);
  
  return buffer;
}

// 写入字符串到 DataView
function writeString(view, offset, string) {
  for (let i = 0; i < string.length; i++) {
    view.setUint8(offset + i, string.charCodeAt(i));
  }
}

// ArrayBuffer 转 Base64
function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

const promptId = ref(17);
const router = useRouter();
const showHistoryDialog = ref(false);
const showGradeDialog = ref(false);
const showSwitchConfirmDialog = ref(false);
// 调试快捷发送按钮（本地无麦克风时使用，已关闭）
const showDebugButtons = ref(false);
const pendingGradeChange = ref(null); // 待处理的年级切换信息
const pendingPromptChange = ref(null); // 待处理的模板切换信息
const pendingDialogueEndedRecord = ref(false); // 五轮结束后点击录音，待确认是否开始新对话
const currentChatId = ref("");
const userInfo = ref({});
// 接口联调相关状态
const gradeId = ref("1"); // 默认年级ID
const gradeName = ref("一年级"); // 默认年级名称
const gradeListMap = ref(new Map()); // 年级ID到名称的映射
const gradeListData = ref([]); // 年级列表数据（用于传递给 ChangeGrade 组件）

// ✅ 获取年级列表（页面初始化时调用）
const fetchGradeListData = async () => {
  try {
    const res = await selectGrades();

    if (res && res.code === 200 && res.data && Array.isArray(res.data)) {
      // 更新映射表
      res.data.forEach(item => {
        gradeListMap.value.set(String(item.gradeId), item.gradeName);
      });
      
      // 更新年级列表数据（用于传递给 ChangeGrade 组件）
      gradeListData.value = res.data
        .map((item) => ({
          id: String(item.gradeId || ""),
          name: item.gradeName || "",
          gradeSort: item.gradeSort || 0,
        }))
        .sort((a, b) => (a.gradeSort || 0) - (b.gradeSort || 0));
      
      
      // ✅ 如果已经有 gradeId，更新对应的 gradeName
      if (gradeId.value) {
        updateGradeNameById(gradeId.value);
      }
    } else {
    }
  } catch (error) {
  }
};

// 根据 gradeId 更新 gradeName（从 gradeListMap 中获取）
const updateGradeNameById = (id) => {
  if (!id) {
    gradeName.value = "一年级";
    return;
  }
  
  // 从映射中获取年级名称
  const name = gradeListMap.value.get(String(id));
  if (name) {
    gradeName.value = name;
  } else {
    // 如果找不到，使用默认值
    gradeName.value = "一年级";
  }
};
const planId = ref("");
const tutoringId = ref("");
const aiToken = ref("");
// ✅ 上次存储的 ttsSessionId（从安卓读取）
const lastTtsSessionIdFromAndroid = ref(null);
// ✅ 已 finish 过的 ttsSessionId（从安卓读取），用于判断新建对话时是否需补发 finish
const lastFinishedTtsSessionIdFromAndroid = ref(null);
// ✅ 新增：主题对话相关状态
const isThemeChat = ref(false); // 是否是主题对话模式
const isFirstUserMessage = ref(true); // 是否是用户的第一条消息
// ✅ 新增：保存用户音频 base64（用于句子评分）
let currentUserAudioBase64 = null;
// 固定的 aiToken（用于开发环境和生产环境兜底）
const FALLBACK_AI_TOKEN =
  "eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoiY2QyZmJjNDcwMDI0NGM2Y2EwZmI5YTI3YmVhYzRmOTIiLCJ1c2VyX2tleSI6ImNkMmZiYzQ3MDAyNDRjNmNhMGZiOWEyN2JlYWM0ZjkyIiwidXVpZCI6IjUwNzBkMDY4LTA0N2EtNDJiOC04YWZmLTc5YWZiYTcyOTVmNSIsImxldmVsX3NvcnQiOm51bGx9.KxKq8BbYvGQAJmvihtID2z4FUcp8cZ1ZIY3xhHe7ZOs1IGeTRB3hW0vy7IYNSldcbp6KeqilKgqnuvAjRJC51A"
const promptList = ref([]); // 模板列表
const showDialogBox = ref(false);
const boxChatListRef = ref(null);
// 自动监听状态（用于UI显示）
const isAutoVolumeMonitoringRef = ref(false);
// 是否准备好进入对话（模板已加载完成）
const isReadyToEnterConversation = ref(false);
// 是否正在进入对话（点击按钮后，接口调用中）
const isEnteringConversation = ref(false);
// 提示音频相关状态
// ✅ 修改：分为两种提示音频，各自独立管理索引
// 1. 欢迎提示音频（进入页面时随机播放）
const welcomeTipAudioIndex = ref(0); // 欢迎提示音频索引（用于循环播放）
const getWelcomeTipAudioFiles = () => {
  return [audio1, audio2];
};

// 2. 15秒无操作提示音频（进入对话后，录音15秒未发送时播放）
const noActionTipAudioIndex = ref(0); // 15秒提示音频索引（用于循环播放）
const getNoActionTipAudioFiles = () => {
  return [audio3, audio4];
};
// ✅ 修改：使用对象数组保存音频片段及其排序信息（参考AI消息的处理逻辑）
let tipAudioBlobs = []; // 用于收集提示音频片段，格式: [{sentCount, serverTimestamp, receiveTimestamp, sortTimestamp, index, blob}, ...]
let isPlayingTipAudio = false; // 标记是否正在播放提示音频
let isTipAudioMode = false; // 标记当前是否处于提示音频模式
let currentTipAudioType = null; // 当前提示音频类型：'welcome' 或 'noAction'
// ✅ 新增：提示音频相关定时器（用于清理）
let tipAudioPlaybackTimer = null; // 提示音频播放完成定时器
let tipAudioTimeoutTimer = null; // 提示音频超时定时器
let tipAudioErrorLogCount = 0; // 提示音频错误日志计数（防止重复打印）
let tipAudioErrorLastLogTime = 0; // 上次打印错误日志的时间

// 人物动画帧相关
const peopleFramesContext = require.context(
  "@/assets/people",
  false,
  /全身_\d+\.png$/
);
const peopleFrames = peopleFramesContext
  .keys()
  .sort((a, b) => {
    // 提取数字并排序
    const numA = parseInt(a.match(/\d+/)[0]);
    const numB = parseInt(b.match(/\d+/)[0]);
    return numA - numB;
  })
  .map((key) => peopleFramesContext(key));

const currentFrameIndex = ref(0);
let frameAnimationTimer = null;
let lastFrameTime = 0;
let isAnimating = false; // 动画运行标志
// 平板设备降低帧率（60ms≈16fps），减少主线程负担和 Vue 响应式更新频率，缓解卡顿
const FRAME_DURATION = 40; // 每帧40ms，约25fps
const FRAME_DURATION_TABLET = 60; // 平板每帧60ms，约16fps

// 计算当前帧的图片路径
const currentFrameSrc = computed(() => {
  return peopleFrames[currentFrameIndex.value] || peopleFrames[0];
});

// 预加载所有图片
function preloadImages() {
  peopleFrames.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
}

// 启动动画
function startFrameAnimation() {
  // 先停止之前的动画
  stopFrameAnimation();
  // 重置到第一帧
  currentFrameIndex.value = 0;
  lastFrameTime = performance.now();
  isAnimating = true;

  const frameDuration = FRAME_DURATION_TABLET; // 平板部署统一

  // 使用 requestAnimationFrame 实现更流畅的动画
  function animateFrame(currentTime) {
    if (!isAnimating) return; // 如果动画已停止，退出

    const elapsed = currentTime - lastFrameTime;

    if (elapsed >= frameDuration) {
      currentFrameIndex.value =
        (currentFrameIndex.value + 1) % peopleFrames.length;
      lastFrameTime = currentTime;
    }

    frameAnimationTimer = requestAnimationFrame(animateFrame);
  }

  frameAnimationTimer = requestAnimationFrame(animateFrame);
}

// 停止动画
function stopFrameAnimation() {
  isAnimating = false;
  if (frameAnimationTimer) {
    cancelAnimationFrame(frameAnimationTimer);
    frameAnimationTimer = null;
  }
  // 重置到第一帧
  currentFrameIndex.value = 0;
  lastFrameTime = 0;
}
const isInSession = ref(false);
const errorMsg = ref("");
const chatList = ref([]);

let mediaRecorder = null;
let audioChunks = [];
let recordingStream = null; // 录音音频流（页面加载时初始化，保持连接）
let persistentRecordingStream = null; // 持久化的录音流（页面加载时初始化，不销毁）
let persistentAudioContext = null; // 持久化的音频上下文（用于音量检测）
let persistentAnalyser = null; // 持久化的音频分析器
let currentSpokenStream = null; // 当前流式请求句柄
let activeResponseEpoch = 0; // 流式响应代次：用于丢弃暂停前旧回调
let activeVoiceChainId = null; // 当前语音链路ID（语音->转文本->AI->TTS）
let voiceChainSeq = 0;
let currentTtsChainId = null; // 当前 TTS 发送对应的链路ID
let microphoneInitialized = false; // 麦克风是否已初始化
let initMicrophonePromise = null; // 麦克风初始化中的 Promise（避免并发重复初始化）
const isResponding = ref(false); // AI 是否正在响应
// ✅ 接口超时定时器（流式请求5分钟，其他10秒）
let apiTimeoutTimer = null;
let currentMp3ToTextAbortController = null; // mp3ToText 当前请求控制器
let currentThemeChatAbortController = null; // sendThemeChatMessage 当前请求控制器
const API_TIMEOUT_DURATION = 10000; // 10秒超时（主题消息等非流式接口）
const STREAM_REQUEST_TIMEOUT = 300000; // 5分钟超时（流式请求接口）
const isConvertingVoiceToText = ref(false); // 是否正在转换语音为文本
let shouldSaveRecording = true; // 标记是否应该保存录音（参考 VoicePop）

function isAbortError(error) {
  const msg = error?.message || "";
  return error?.name === "AbortError" || msg.includes("aborted") || msg.includes("中断");
}

function logChain(message, extra = {}) {
  const payload = { time: new Date().toISOString(), message, ...extra };
  try {
    console.log(`[AI-Teacher][chain] ${message}`, payload);
  } catch (e) {
    // ignore
  }
  try {
    if (!window.__aiTeacherChainLogs) {
      window.__aiTeacherChainLogs = [];
    }
    window.__aiTeacherChainLogs.push(payload);
    if (window.__aiTeacherChainLogs.length > 200) {
      window.__aiTeacherChainLogs.shift();
    }
    window.__aiTeacherActiveChainId = activeVoiceChainId || "";
  } catch (e) {
    // ignore
  }
}

function createAbortError(message = "chain aborted") {
  const err = new Error(message);
  err.name = "AbortError";
  return err;
}

function createVoiceChainId(source = "voice") {
  voiceChainSeq += 1;
  return `${Date.now()}_${voiceChainSeq}_${source}`;
}

function activateVoiceChain(source = "voice") {
  const chainId = createVoiceChainId(source);
  activeVoiceChainId = chainId;
  logChain("activate", { chainId, source });
  return chainId;
}

function isVoiceChainActive(chainId) {
  return !!chainId && activeVoiceChainId === chainId;
}

function invalidateVoiceChain() {
  if (activeVoiceChainId) {
    logChain("invalidate", { chainId: activeVoiceChainId });
  }
  activeVoiceChainId = null;
  currentTtsChainId = null;
}

function abortMp3ToTextRequest() {
  if (currentMp3ToTextAbortController) {
    if (process.env.NODE_ENV === "development") {
      console.log("[AI-Teacher][Abort] mp3ToText -> abort()");
    }
    try {
      currentMp3ToTextAbortController.abort();
    } catch (e) {
      // ignore
    }
    currentMp3ToTextAbortController = null;
  }
}

async function requestMp3ToText(base64, token, chainId = null) {
  if (chainId && !isVoiceChainActive(chainId)) {
    logChain("mp3ToText skipped", { chainId, reason: "inactive before request" });
    throw createAbortError("voice chain invalid before mp3ToText");
  }
  abortMp3ToTextRequest();
  currentMp3ToTextAbortController = new AbortController();
  try {
    const res = await mp3ToText(
      { base64 },
      token,
      { signal: currentMp3ToTextAbortController.signal }
    );
    if (chainId && !isVoiceChainActive(chainId)) {
      logChain("mp3ToText dropped", { chainId, reason: "inactive after response" });
      throw createAbortError("voice chain invalid after mp3ToText");
    }
    return res;
  } finally {
    currentMp3ToTextAbortController = null;
  }
}

function abortThemeChatRequest() {
  if (currentThemeChatAbortController) {
    if (process.env.NODE_ENV === "development") {
      console.log("[AI-Teacher][Abort] sendThemeChatMessage -> abort()");
    }
    try {
      currentThemeChatAbortController.abort();
    } catch (e) {
      // ignore
    }
    currentThemeChatAbortController = null;
  }
}

function removeEmptyAiLoadingMessages() {
  for (let i = chatList.value.length - 1; i >= 0; i--) {
    const item = chatList.value[i];
    if (!item || item.role !== "ai") continue;
    const hasContent = !!(item.content || item.renderedContent || item.originalContent);
    if (item.loading && !hasContent) {
      chatList.value.splice(i, 1);
    }
  }
}

function clearAiLoadingStates() {
  for (let i = chatList.value.length - 1; i >= 0; i--) {
    const item = chatList.value[i];
    if (item?.role === "ai" && item.loading) {
      item.loading = false;
    }
  }
}

function bindAiMessageChain(aiMessageIndex, chainId, chatId) {
  if (!chatList.value[aiMessageIndex]) return;
  chatList.value[aiMessageIndex].chainId = chainId || "";
  chatList.value[aiMessageIndex].chatRecordId = chatId || "";
}

function isAiMessageChainMatched(aiMessageIndex, chainId, chatId) {
  const target = chatList.value[aiMessageIndex];
  if (!target) return false;
  // 有绑定则强校验；无绑定时保持兼容，避免历史消息结构导致误杀
  const msgChainId = target.chainId || "";
  const msgChatId = target.chatRecordId || "";
  if (msgChainId && chainId && msgChainId !== chainId) return false;
  if (msgChatId && chatId && msgChatId !== chatId) return false;
  return true;
}

async function requestThemeChatMessage(params, token) {
  abortThemeChatRequest();
  currentThemeChatAbortController = new AbortController();
  try {
    return await sendThemeChatMessage(
      params,
      token,
      { signal: currentThemeChatAbortController.signal }
    );
  } finally {
    currentThemeChatAbortController = null;
  }
}

// 底部输入区相关变量
const inputContent = ref("");
const isShowVoice = ref(false);
const isshowSpeakIcon = ref(false);
const isCanceling = ref(false);
const toBottom = ref("0");

// 3秒无操作提示弹窗相关（从录音开始计时）
let noActionTimer = null; // 15秒提示音频定时器（不显示弹窗，只播放音频）
let noActionTimerStartTime = 0; // 闲置语音计时器开始时间（用于熄屏暂停时计算剩余时间）
let noActionTimerDuration = 15000; // 闲置语音计时器当前时长（用于熄屏暂停时计算剩余时间）
let isRecordingStarted = false; // 标记是否已经开始录音
const NO_ACTION_TIMER_DURATION = 15000; // 闲置语音计时器默认时长（15秒）

// 熄屏时保存的音频状态（用于亮屏恢复）
let pausedForScreenOff = null; // { audioQueue, currentUrl, currentTime, webAudioQueue, isTipAudio }
const showTips = ref(true);
const imageUrl = ref("");
const promptContent = ref(""); // 提示内容（最新一条消息的）
const adviceContent = ref(""); // 纠错建议内容
const reasonContent = ref(""); // 纠错原因

function pickAdviceDisplay(val) {
  const s = val != null ? String(val).trim() : "";
  return s || "/";
}

// 显示纠正弹窗（模板17：小小建议用 correctedExample，每条消息独立存）
const showCorrection = (messageIndex) => {
  const message = chatList.value[messageIndex];
  if (message) {
    adviceContent.value = pickAdviceDisplay(message.correctedExample);
    reasonContent.value = pickAdviceDisplay(message.updateErrorContent);
    showAdviceDialog.value = true;
  }
};

// 历史详情页纠正弹窗（数据在 historyChatList）
const showHistoryCorrection = (messageIndex) => {
  const message = historyChatList.value[messageIndex];
  if (message) {
    adviceContent.value = pickAdviceDisplay(message.correctedExample);
    reasonContent.value = pickAdviceDisplay(message.updateErrorContent);
    showAdviceDialog.value = true;
  }
};

let audioContext = null;
let analyser = null; // 音频分析器
let volumeCheckTimer = null; // 音量检测定时器
let silenceTimer = null; // 静音检测定时器
let lastVoiceTime = 0; // 最后一次检测到声音的时间
const SILENCE_THRESHOLD = 0.09; // 音量阈值（低于此值视为静音，提高阈值减少环境噪音干扰）
const VOICE_THRESHOLD_WHEN_PLAYING = 0.15; // 播放音频时的语音阈值（需要更明显的语音输入才认为是用户说话）
const SILENCE_DURATION = 3000; // 静音持续时间（3秒）
const VOLUME_CHECK_INTERVAL = 100; // 音量检测间隔（100ms）
const MAX_RECORDING_DURATION = 120000; // ✅ 修改：最大录音时长改为120秒（2分钟），给用户更多时间

// 自动音量监听相关变量
let autoVolumeContext = null;
let autoVolumeAnalyser = null;
let autoVolumeSource = null;
let autoVolumeStream = null;
let autoVolumeCheckTimer = null;
let autoVolumeTimeoutTimer = null; // 3秒超时定时器
const AUTO_VOLUME_CHECK_INTERVAL = 100; // 100ms检查一次
const AUTO_START_THRESHOLD = 0.08; // 自动开始录音的音量阈值（比静音检测稍高）
const AUTO_TIMEOUT_DURATION = 3000; // 3秒超时，如果音量没达到阈值，自动调用语音转文本
let isAutoVolumeMonitoring = false; // 是否正在自动监听
let autoRecordingStartTime = 0; // 自动录音开始时间
let autoRecordingChunks = []; // 自动录音的音频片段
let autoRecordingMediaRecorder = null; // 自动录音的 MediaRecorder

let audioQueue = []; // 存储 Blob（MediaSource 模式）或 blob URL 字符串（降级模式）
let isPlayingAudio = false;
// ✅ MediaSource API 相关：当前正在播放的 Blob（用于熄屏保存）
let currentPlayingBlob = null;
let currentMediaSourceUrl = null; // MediaSource 的 object URL，用于 revoke
// ✅ 禁用 MediaSource：本地 .opus 为 Ogg 格式，MediaSource 仅支持 WebM，会导致闲置音频和 TTS 均无法播放
const USE_MEDIA_SOURCE = false;
let isAudioPlayingBlock = false; // 全局标志：音频播放期间禁止开启录音
let lastAudioEndedAt = 0; // 最后一帧音频结束时间，用于冷却期防误触
// ✅ 已移除 Web Audio TTS 分支，统一使用 HTML5 Audio 播放（更稳定，避免平板解码失败）
const playbackStatus = ref("🔈 未播放 | 队列 0 段");
const audioPlayer = ref(null);
let preloadAudio = null; // 预加载下一段，减少段间顿挫
const BUFFER_THRESHOLD = 0;
let consecutiveFailures = 0;
const MAX_CONSECUTIVE_FAILURES = 3;
let currentLoadTimeout = null;
let currentCanPlayHandler = null;
let currentTimeupdateHandler = null; // timeupdate 预加载，段结束时清理
// ✅ Howler.js 相关变量（可选，如果未安装会降级到 HTML5 Audio）
let Howl = null; // Howl 类（动态加载）
let howlerLoaded = false; // 是否已尝试加载
let currentHowlSound = null; // 当前播放的 Howl sound 实例

// ✅ 动态加载 Howler.js（如果未安装，会降级到 HTML5 Audio）
async function loadHowler() {
  if (howlerLoaded) return Howl;
  try {
    const howlerModule = await import("howler");
    Howl = howlerModule.Howl;
    howlerLoaded = true;
    return Howl;
  } catch (e) {
    howlerLoaded = true; // 标记为已尝试加载，避免重复尝试
    return null;
  }
}

// ✅ Android平板音频通道修复：激活媒体通道的无声音频
let mediaChannelActivator = null;
let mediaChannelActivated = false; // 媒体通道是否已激活
let needsMediaChannelReactivationAfterRecord = false; // 录音后需强制重新激活媒体通道（解决音量不可控，且避免每段都激活导致卡顿）

// 打印当前设备状态（用于排查平板跳过等问题）
function logDeviceStatus() {
  const ua = typeof navigator !== "undefined" ? (navigator.userAgent || navigator.userAgentData?.userAgent || "") : "";
  const w = typeof window !== "undefined" ? window.innerWidth : 0;
  const h = typeof window !== "undefined" ? window.innerHeight : 0;
  const isTabletUA = /iPad|Android(?!.*Mobile)|Tablet|PlayBook|Silk/i.test(ua);
  const hasTouch = typeof window !== "undefined" && ("ontouchstart" in window || (navigator.maxTouchPoints || 0) > 0);
  const isLarge = w >= 768 && h >= 768;
}

// 已移除 MERGE_THRESHOLD/MERGE_SIZE_THRESHOLD：不再提前 flush，仅 complete 或连续 sentCount 时入队，避免漏音
const ENABLE_MERGE = true;
let pendingAudioBlobs = [];
let pendingMergeCount = 0; // 合并中未入队的片段数，避免合并间隙显示麦克风
let pendingMergeTimeout = null; // 延迟合并定时器（片段不足时，200ms 后合并剩余片段，减少卡顿）
const MERGE_DELAY_MS = 80; // 无新片段时尽快合并，减少段间空隙
const PENDING_FLUSH_THRESHOLD = 25; // 长对话：累积到此数量才 flush
const FIRST_BATCH_THRESHOLD = 10; // 第一条降低起播门槛，减少首二段等待
const MERGE_BATCH_SIZE = 6; // 首批更小批次，优先连续播放
const SUBSEQUENT_BATCH_SIZE = 10; // 后续批次下调，避免段间等待过长
const PUNCTUATION_REGEX = /[。！？.!?]$/; // 句末标点，用于在标点处切分音频
const PLAY_START_THRESHOLD = 3; // 增加缓冲，等待更多音频
const QUEUE_MIN_LENGTH = 3; // 提高最小队列长度
let queueMonitorTimer = null;

// 合并队列中待播放的多个片段（播放中且队列有2+段时，合并为一个大片段减少播放切换）
let queueMergeInProgress = false;
let queueMergeTimeout = null;
function mergePendingQueueSegments() {
  if (!isPlayingAudio || audioQueue.length < 2 || queueMergeInProgress) return;
  const items = [...audioQueue];
  if (items.length < 2) return;
  const isBlobUrl = (x) => typeof x === "string" && x.startsWith("blob:");
  if (!items.every(isBlobUrl)) return;
  queueMergeInProgress = true;
  const itemSet = new Set(items);
  Promise.all(items.map((url) => fetch(url).then((r) => r.blob())))
    .then((blobs) => {
      queueMergeInProgress = false;
      if (!isPlayingAudio || audioQueue.length < 2) return;
      let removeCount = 0;
      for (let i = 0; i < audioQueue.length && itemSet.has(audioQueue[i]); i++) {
        try { URL.revokeObjectURL(audioQueue[i]); } catch (e) { /* ignore */ }
        removeCount++;
      }
      if (removeCount < 2) return;
      for (let i = 0; i < removeCount; i++) audioQueue.shift();
      const valid = blobs.slice(0, removeCount).filter((b) => b && b.size > 0);
      if (valid.length === 0) return;
      const merged = valid.length === 1 ? valid[0] : new Blob(valid, { type: "audio/opus; codecs=opus" });
      const newUrl = URL.createObjectURL(merged);
      audioQueue.unshift(newUrl);
      if (preloadAudio) {
        preloadAudio.src = newUrl;
        preloadAudio.load();
      }
      updateAudioStateRefs();
      updatePlaybackStatus();
    })
    .catch(() => {
      queueMergeInProgress = false;
      updateAudioStateRefs();
    });
}

// ✅ 统一使用 HTML5 Audio 播放 TTS（原 enqueueWebAudioTtsBlob 改为直接调用 enqueueWebAudioBlob）
// 避免 Web Audio 解码失败导致平板跳过片段，HTML5 Audio 由浏览器内核处理更稳定
function enqueueWebAudioTtsBlob(blob, _sortKey) {
  if (!blob || blob.size === 0 || isTemplateSwitching.value) return;
  if (isManualStop || isStoppingAudio) return;
  // ✅ 播放前释放录音对象
  clearNoActionTimer();
  forceReleaseRecordingStreamForPlayback();
  if (window.android && typeof window.android.callNative === "function") {
    try {
      window.android.callNative(JSON.stringify({ func: "getResetAudio" }));
    } catch (e) { /* ignore */ }
  }
  // 仅录音后需强制重新激活；平板不要每次 force，否则每段都播静音激活导致卡顿
  const forceReactivate = needsMediaChannelReactivationAfterRecord;
  const hadRecordingReactivate = needsMediaChannelReactivationAfterRecord;
  if (needsMediaChannelReactivationAfterRecord) {
    needsMediaChannelReactivationAfterRecord = false;
  }
  const doEnqueue = () => {
    // ✅ 关键修复：不阻塞在 ensureMediaChannelActive，避免平板激活失败/卡住导致无法播放
    // 直接入队播放，initAudioPlayer 内部会再次尝试激活；激活改为后台并行执行
    ensureMediaChannelActive(forceReactivate).catch(() => {});
    enqueueWebAudioBlob(blob);
  };
  if (hadRecordingReactivate) {
    setTimeout(doEnqueue, 2000); // 录音后延迟2秒再播放，给系统切换音频通道时间
  } else {
    doEnqueue();
  }
}

// 播放状态显示（注意：setup 时在 isPlayingAudioRef 声明前会调用，此处不调用 updateAudioStateRefs）
function updatePlaybackStatus() {
  const status = isPlayingAudio ? "🔊 播放中" : "🔈 未播放";
  const totalQueue = audioQueue.length + pendingAudioBlobs.length + pendingMergeCount;
  playbackStatus.value = `${status} | 队列 ${totalQueue} 段`;
}

// 更新播放状态并控制动画
function setPlayingAudioState(playing) {
  // ✅ 关键修复：仅当 audioQueue 有未播项时拒绝退出（pending 未合并不算；否则首段播完后 isPlayingAudio 卡住，后续合并入队时不会触发 playNextAudio）
  if (!playing && audioQueue.length > 0) {
    return;
  }

  const wasPlaying = isPlayingAudio;
  isPlayingAudio = playing;
  isAudioPlayingBlock = playing; // 同步设置全局阻塞标志，禁止播放期间开启录音

  // 同步更新响应式状态
  updateAudioStateRefs();

  // 控制动画：根据播放状态变化启动/停止动画
  if (playing && !wasPlaying) {
    // 从停止变为播放，启动动画
    startFrameAnimation();

    // ✅ 清除闲置语音定时器，避免暂停→获取下一条消息播放时误触发闲置音频
    clearNoActionTimer();
    // 音频开始播放时，强制停止任何录音并释放资源
    stopAnyRecording();
    // 停止自动监听（禁止监听和录音）
    stopAutoVolumeMonitoring();
  } else if (!playing && wasPlaying) {
    // 从播放变为停止，停止动画
    stopFrameAnimation();

    // ✅ 记录结束时间，用于冷却期防误触（避免「播一段后突然开启录音又关闭」）
    lastAudioEndedAt = Date.now();

    // 音频播放完毕，允许再次点击发送按钮
    isSendButtonProcessing.value = false;

    // 播放停止后才启动闲置语音定时器（播放时已清除，不会竞态）
    setTimeout(() => {
      if (isAudioBlockedWhileScreenOff) {
        // 熄屏期间禁止启动倒计时，但在亮屏后补偿启动一次
        const isReallyStopped = !isPlayingAudio && audioQueueLengthRef.value === 0 && !isWaitingForMoreAudio;
        if (!isReallyStopped) return;
        if (!isMicPressing && !isInSession.value && !isResponding.value && currentChatId.value && aiToken.value) {
          shouldScheduleNoActionTimerAfterScreenOff = true;
        }
        return;
      }
      if (isMicPressing || isInSession.value) return;
      const isReallyStopped = !isPlayingAudio && audioQueueLengthRef.value === 0 && !isWaitingForMoreAudio;
      if (isWaitingForMoreAudio) return;
      if (isReallyStopped && !isInSession.value && !isResponding.value && currentChatId.value && aiToken.value) {
        resetNoActionTimer();
      }
    }, 500);

    // 音频彻底停止后再执行麦克风重建，避免播放中 getUserMedia 抢占音频通道导致瞬时掉音
    if (shouldReloadRecordingWhenIdle) {
      shouldReloadRecordingWhenIdle = false;
      setTimeout(() => {
        const isReallyIdle =
          !isPlayingAudio &&
          audioQueueLengthRef.value === 0 &&
          pendingAudioBlobs.length === 0 &&
          pendingMergeCount === 0 &&
          !isInSession.value &&
          !isResponding.value;
        if (!isReallyIdle) return;
        reloadRecordingResources().catch(() => {});
      }, 200);
    }
  }

  updatePlaybackStatus();
}

// 声波可视化器激活状态：只有在录音中且不在播放音频时才激活
const isWaveActive = computed(() => {
  return isInSession.value && !isPlayingAudio;
});

// 响应式状态追踪（用于 computed）
const isPlayingAudioRef = ref(false);
const audioQueueLengthRef = ref(0);

// 录音波浪可视化相关
const recordingWaveCanvas = ref(null);
let recordingWaveAnimationId = null;
let recordingWaveAudioContext = null;
// ✅ 波形重试：若 500ms 内无音量数据，尝试再次 resume（解决平板/移动端偶尔不跳动）
let recordingWaveformStartTime = 0;
let recordingWaveformResumeRetryDone = false;
let recordingWaveAnalyser = null;

// 更新响应式状态追踪
function updateAudioStateRefs() {
  isPlayingAudioRef.value = isPlayingAudio;
  // ✅ 包含待合并的 TTS 片段，文本渲染完但音频未播完时仍显示波纹
  audioQueueLengthRef.value = audioQueue.length + pendingAudioBlobs.length + pendingMergeCount;
}

// 录音状态指示器文案：统一的状态计算逻辑
const recordingIndicatorText = computed(() => {
  // 0. 优先级最高：如果正在响应或等待 TTS 音频但没开始播放（显示加载中），不显示任何文案
  if ((isResponding.value || isTtsTextAllSent.value) && !isPlayingAudioRef.value && audioQueueLengthRef.value === 0 && !isInSession.value) {
    return "";
  }

  // 1. 优先级最高：正在播放音频或队列有内容 → "Miya在说话"
  const hasAudioPlaying =
    isPlayingAudioRef.value ||
    audioQueueLengthRef.value > 0;

  if (hasAudioPlaying) {
    return "Miya在说话";
  }

  // 2. 优先级第二：正在响应（流式请求中）
  // 区分两种情况：
  // - 如果正在转换语音为文本（isConvertingVoiceToText），显示"Miya正在思考"
  // - 如果AI已经开始回复（文本正在渲染），显示"Miya在说话"
  if (isResponding.value) {
    // 如果正在转换语音为文本，显示"正在思考"
    if (isConvertingVoiceToText.value) {
      return "Miya正在思考";
    }
    // 如果是手动暂停音频（只停止音频，文本继续），显示"Miya在说话"
    // 或者AI已经开始回复，显示"Miya在说话"
      return "Miya在说话";
  }

  // 3. 优先级第三：正在录音 → "Miya在听，请说话"
  if (isInSession.value) {
    return "Miya在听，请说话";
  }

  // 4. 优先级第四：自动监听中 → "按住说话"
  if (isAutoVolumeMonitoringRef.value) {
    return "按住说话";
  }

  // 5. 默认状态：没有对话时返回空字符串，有对话时显示"按住说话"
  if (!currentChatId.value) {
    return "";
  }

  return "按住说话";
});

// 录音状态指示器是否显示
const showRecordingIndicator = computed(() => {
  // ✅ 两个模版修复：如果正在响应或等待 TTS 音频但没开始播放（显示加载中），直接隐藏 recording-indicator
  if ((isResponding.value || isTtsTextAllSent.value) && !isPlayingAudioRef.value && audioQueueLengthRef.value === 0 && !isInSession.value) {
    return false;
  }
  // ✅ 修改：如果正在进入对话（点击按钮后），也要显示状态指示器
  if (isEnteringConversation.value) {
    return true;
  }
  // ✅ 修改：如果没有创建对话，不显示状态指示器
  if (!currentChatId.value) {
    return false;
  }
  // ✅ 修改：如果有对话，始终显示指示器（避免状态切换时文本消失）
  // 只要有任意一个状态为 true，或者有对话但所有状态都 false（状态切换间隙），都显示指示器
  return (
    isPlayingAudioRef.value ||
    audioQueueLengthRef.value > 0 ||
    isResponding.value ||
    isInSession.value ||
    isAutoVolumeMonitoringRef.value ||
    currentChatId.value // 有对话时始终显示，避免状态切换时消失
  );
});

// 状态文本：根据录音和播放状态动态切换
const statusText = computed(() => {
  // 如果没有创建对话，不显示文本
  if (!currentChatId.value) {
    return "";
  }

  // 如果正在播放音频，一直显示"Miya正在说话"
  if (isPlayingAudio || audioQueue.length > 0) {
    return "Miya正在说话";
  }

  // 如果 finish 成功，允许录音，显示"点击按钮录音"
  if (isFinishSuccess.value && !isInSession.value) {
    return "点击按钮录音";
  }

  // 如果正在录音，显示"Miya在听，请说话"
  if (isInSession.value) {
    return "Miya在听，请说话";
  }

  // 默认显示"点击按钮录音"（如果 finish 成功）或"按住说话"
  return isFinishSuccess.value ? "点击按钮录音" : "按住说话";
});

// 是否可以发送（有文本或有图片）
const canSend = computed(() => {
  return !!inputContent.value.trim() || !!imageUrl.value;
});

// 发送按钮是否正在处理中（点击后立即设置为 true，直到流式请求结束）
const isSendButtonProcessing = ref(false);

// 发送按钮是否禁用
const isSendButtonDisabled = computed(() => {
  // 如果正在处理中（点击后等待流式请求结束），禁用
  if (isSendButtonProcessing.value) {
    return true;
  }
  // 如果正在录音，不禁用（用户需要点击按钮来停止录音）
  if (isInSession.value) {
    return false;
  }
  // 正在播放音频时禁用
  if (
    isPlayingAudio ||
    audioQueueLengthRef.value > 0
  ) {
    return true;
  }
  // ✅ 修改：如果是手动暂停音频（只停止音频，文本继续），不禁用发送按钮
  // 这样用户可以在文本渲染时点击发送按钮开始录音
  if (isManualStopAudioOnly) {
    return false;
  }
  // 正在响应中（接口请求中）时禁用
  if (isResponding.value) {
    return true;
  }
  // 其他情况不禁用
  return false;
});

// 计算是否可以暂停输出（只要开始调用接口就显示，包括响应中和音频播放时）
const canStopResponse = computed(() => {
  // ✅ 修改：闲置的提示音频不显示暂停按钮
  // 判断逻辑：提示音频通常在以下情况播放：
  // 1. 没有对话ID（欢迎提示）
  // 2. 有对话ID但没有聊天记录（15秒无操作提示）
  // 所以只有当有对话ID且有聊天记录时，才显示暂停按钮
  const isTipAudio = !currentChatId.value || (currentChatId.value && chatList.value.length === 0);
  if (isTipAudio) {
    return false;
  }
  
  // ✅ 修改：只要开始调用接口（isResponding）或音频播放时，就显示中断按钮
  const hasAudioPlaying = isPlayingAudioRef.value || audioQueueLengthRef.value > 0;
  const isRespondingNow = isResponding.value;
  
  return (
    (hasAudioPlaying || isRespondingNow) &&
    chatList.value.length > 0 &&
    chatList.value[chatList.value.length - 1]?.role === "ai" &&
    !getText.value
    // ✅ 移除 chatList.value.length > 1 限制，允许第一条消息也显示暂停按钮
  );
});

// 过滤聊天列表，隐藏被打断且没有渲染任何文本的 AI 消息气泡
const filteredChatList = computed(() => {
  return chatList.value.filter((item) => {
    // 如果是 AI 消息且没有渲染任何文本且不在加载中，则不显示（被打断的空消息）
    if (item.role === 'ai' && !item.renderedContent && !item.content && !item.loading) {
      return false;
    }
    return true;
  });
});

// 快捷回复选择
const selectTip = (tip) => {
  inputContent.value = tip;
};

// 切换输入模式（键盘/语音）
const toggleInputMode = () => {
  isshowSpeakIcon.value = !isshowSpeakIcon.value;
  if (isshowSpeakIcon.value) {
    inputContent.value = "";
    isShowVoice.value = false;
  }
};

const showSpeckPop = () => {
  // 语音弹窗显示逻辑
};

const isLongPress = ref(false);
const startY = ref(0);
const moveY = ref(0);
let timer = null;

const startPress = (event) => {
  event?.stopPropagation();

  startY.value = event.type.includes("touch")
    ? event.touches[0].clientY
    : event.clientY;
  moveY.value = startY.value;
  isCanceling.value = false;

  timer = setTimeout(() => {
    isLongPress.value = true;
    isShowVoice.value = true;
    // 确认长按后才打断，避免轻触就中断流式文本
    interruptAudioAndText();
    // 语音弹窗组件会自动开始录音
    // 如果麦克风还未初始化，尝试初始化（用户长按表示交互）
    if (!microphoneInitialized) {
      initMicrophoneStream().catch(err => {
      });
    }
  }, 200);
};

const handleMove = (event) => {
  if (!isLongPress.value) return;
  const currentY = event.type.includes("touch")
    ? event.touches[0].clientY
    : event.clientY;
  moveY.value = currentY;
  const distance = startY.value - currentY;
  if (distance > 150) {
    isCanceling.value = true;
  } else {
    isCanceling.value = false;
  }
};

const cancelPress = (event) => {
  event?.stopPropagation();
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }

  // 如果还没有开始长按，直接返回
  if (!isLongPress.value && !isShowVoice.value) {
    return;
  }

  isLongPress.value = false;

  // 保存取消状态（在关闭弹窗前保存，确保组件能读取到）
  const shouldCancel = isCanceling.value;

  // 关闭弹窗，组件会根据 isCanceling 状态决定是否保存录音
  isShowVoice.value = false;

  // 重置状态
  startY.value = 0;
  moveY.value = 0;
  // 延迟重置 isCanceling，确保组件能正确读取到状态
  setTimeout(() => {
    isCanceling.value = false;
  }, 200);
};

const changefocus = function () {
  toBottom.value = "340px";
  const showBoard = JSON.stringify({
    func: "getCanShowKeyBoard",
    params: {
      canShow: true,
    },
  });
  if (window.android) {
    window.android.callNative(showBoard);
  }
};

const changeblur = function () {
  toBottom.value = "0";
  scrollBoxToBottom();
};
const getText = ref(false);
// 保存语音（语音转文本）
const saveVoice = async (val) => {
  if (!isCanceling.value) {
    getText.value = true;
    let toastInstance = null;
    
    try {
      // ✅ 添加1分钟超时处理
      const SAVE_VOICE_TIMEOUT = 60000; // 1分钟超时
      const timeoutPromise = new Promise((_, reject) => {
        apiTimeoutTimer = setTimeout(() => {
          apiTimeoutTimer = null;
          reject(new Error("接口超时（1分钟）"));
        }, SAVE_VOICE_TIMEOUT);
      });
      
      let res;
      try {
        res = await Promise.race([
          requestMp3ToText(val, aiToken.value),
          timeoutPromise
        ]);
        // 清除超时定时器
        if (apiTimeoutTimer) {
          clearTimeout(apiTimeoutTimer);
          apiTimeoutTimer = null;
        }
      } catch (error) {
        // 清除超时定时器
        if (apiTimeoutTimer) {
          clearTimeout(apiTimeoutTimer);
          apiTimeoutTimer = null;
        }
        
        if (isAbortError(error)) {
          getText.value = false;
          return;
        }
        // ✅ 超时或网络错误处理
        if (error.message && error.message.includes("超时")) {
          getText.value = false;
          showToast({
            message: "网络错误，请重试",
            type: "fail",
          });
          // ✅ 重置状态，让用户能再次调用
          isshowSpeakIcon.value = false;
          isShowVoice.value = false;
          return;
        }
        throw error; // 其他错误继续抛出
      }
      
      if (res.code === 200 && res.data) {
        // ✅ 成功时，重新加载所有录音相关的资源
        try {
          await reloadRecordingResources();
        } catch (reloadError) {
          // 即使重新加载失败，也继续执行后续逻辑
        }
        
        getText.value = false;
        // 成功获取文本数据
        inputContent.value = res.data;
        // 只有在成功保存语音后才切换回输入模式
        isshowSpeakIcon.value = false;
        isShowVoice.value = false;
      } else {
        // 返回格式错误：code为200但没有data字段
        toastInstance = showToast({
          message: "Miya没听清,请再说一遍",
          type: "fail",
          duration: 0, // ✅ 设置为0表示不自动关闭，一直显示
        });
        getText.value = false;
        
        // ✅ 修复：显示提示后，重新加载录音资源，加载完成后关闭提示
        try {
          await reloadRecordingResources();
          // 关闭 toast
          if (toastInstance && toastInstance.close) {
            toastInstance.close();
          }
        } catch (reloadError) {
          // 即使重新加载失败，也关闭提示（避免一直显示）
          if (toastInstance && toastInstance.close) {
            toastInstance.close();
          }
        }
        
        // 失败时不关闭弹窗，保持弹窗打开状态，让用户可以重试
      }
    } catch (error) {
      // 检测跨域错误
      if (
        error instanceof TypeError &&
        (error.message.includes("Failed to fetch") ||
          error.message.includes("NetworkError") ||
          error.message.includes("Network request failed"))
      ) {
        toastInstance = showToast({
          message: "网络错误，请检查网络连接",
          type: "fail",
          duration: 0, // ✅ 设置为0表示不自动关闭，一直显示
        });
        
        // ✅ 修复：网络错误时也重新加载录音资源，加载完成后关闭提示
        try {
          await reloadRecordingResources();
          if (toastInstance && toastInstance.close) {
            toastInstance.close();
          }
        } catch (reloadError) {
          if (toastInstance && toastInstance.close) {
            toastInstance.close();
          }
        }
      } else {
        toastInstance = showToast({
          message: "Miya没听清,请再说一遍",
          type: "fail",
          duration: 0, // ✅ 设置为0表示不自动关闭，一直显示
        });
        getText.value = false;
        
        // ✅ 修复：显示提示后，重新加载录音资源，加载完成后关闭提示
        try {
          await reloadRecordingResources();
          // 关闭 toast
          if (toastInstance && toastInstance.close) {
            toastInstance.close();
          }
        } catch (reloadError) {
          // 即使重新加载失败，也关闭提示（避免一直显示）
          if (toastInstance && toastInstance.close) {
            toastInstance.close();
          }
        }
      }
      // 错误时不关闭弹窗，保持弹窗打开状态
    }
  } else {
    // 如果是取消操作，直接关闭弹窗
    isshowSpeakIcon.value = false;
    isShowVoice.value = false;
  }
};

// 处理语音弹窗关闭（参照 deepseek 的逻辑）
const handleVoiceClose = () => {
  isShowVoice.value = false;
  isshowSpeakIcon.value = false;
  isCanceling.value = false;
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  isLongPress.value = false;
  // 清除15秒无操作定时器（关闭弹窗表示有交互）
  clearNoActionTimer();
};

// ✅ 新增：确认主题接口（带重试机制）
async function callConfirmTheme(userMessage) {
  if (!currentChatId.value || !aiToken.value) {
    return null;
  }

  try {
    const params = {
      chatRecordId: currentChatId.value,
      userMessage: userMessage,
    };


    const res = await confirmTheme(params, aiToken.value);


    // 检查返回状态（兼容 code 200 和 code 0）
    const isSuccess = (res.code === 200 || res.code === 0);
    const data = res.data || res;
    if (isSuccess && data) {
      
      // 处理返回的数据（data 可能是 res.data 或 res 本身）
      
      // 如果有提示内容
      if (data.promptContent) {
        promptContent.value = data.promptContent;
      }
      
      // ✅ 关键修改：返回完整的 data，包括 returnStatus
      return data;
    } else {
      // code 不等于 200，返回 null
        showToast({
          message: "确认主题失败，请重试",
          type: "fail",
        });
        return null;
    }
  } catch (error) {
      showToast({
        message: "确认主题失败，请重试",
        type: "fail",
      });
      return null;
    }
  }

// ✅ 确保 TTS 连接和会话就绪（带重试机制）
// autoStart: 是否自动启动会话（默认true，finish后可以设置为false，等下次发送消息时再start）
async function ensureTtsReady(maxRetries = 3, autoStart = true) {
  for (let retry = 0; retry < maxRetries; retry++) {
    try {
      
      // ✅ 如果 TTS 连接存在且 WebSocket 已连接，但会话未启动
      if (ttsWsManager && ttsWsManager.ws && ttsWsManager.ws.readyState === WebSocket.OPEN && !ttsWsManager.isSessionStarted) {
        // ✅ 新增：如果 autoStart 为 false，不自动启动会话，直接返回
        if (!autoStart) {
          return; // 连接存在即可，不需要启动会话
        }
        
        try {
          await ttsWsManager.connect();
          await new Promise((resolve) => setTimeout(resolve, 300));
          
          // 检查是否启动成功
          if (ttsWsManager.isSessionStarted) {
            return; // 成功，直接返回
          } else {
            // 等待一下，可能 session_started 消息还在路上
            let waitCount = 0;
            while (waitCount < 10 && !ttsWsManager.isSessionStarted) {
              await new Promise((resolve) => setTimeout(resolve, 100));
              waitCount++;
            }
            
            if (ttsWsManager.isSessionStarted) {
              return; // 成功，直接返回
            }
          }
        } catch (e) {
        }
      }
      
      // ✅ 如果 TTS 不存在或连接断开，重新初始化
      if (!ttsWsManager || !ttsWsManager.isReady()) {
        try {
          // 关闭旧连接
          if (ttsWsManager) {
            try {
              await ttsWsManager.close();
            } catch (e) {
            }
          }
          ttsWsManager = null;
          
          await initTtsWebSocket();
          
          // 等待连接建立
          await new Promise((resolve) => setTimeout(resolve, 500));
          
          // 检查是否成功
          if (!ttsWsManager || !ttsWsManager.isReady()) {
            if (retry < maxRetries - 1) {
              await new Promise((resolve) => setTimeout(resolve, 1000));
              continue;
            }
            throw new Error("TTS 初始化失败");
          }
          
          // 检查会话是否启动
          if (ttsWsManager.isSessionStarted) {
            return; // 成功，直接返回
          }
        } catch (ttsError) {
          if (retry < maxRetries - 1) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
            continue;
          }
          throw ttsError;
        }
      }
      
      // ✅ 最终检查：如果 TTS 已就绪且会话已启动，直接返回
      if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
        return;
      }
      
      // ✅ 新增：如果 autoStart 为 false，且连接已建立，直接返回
      if (!autoStart && ttsWsManager && ttsWsManager.ws && ttsWsManager.ws.readyState === WebSocket.OPEN) {
        return;
      }
      
      // 如果到这里还没返回，说明有问题，继续重试
      if (retry < maxRetries - 1) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        continue;
      }
      
      throw new Error("TTS 准备失败");
    } catch (e) {
      if (retry < maxRetries - 1) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        continue;
      }
      throw e;
    }
  }
}

// ✅ 发送 TTS 内容（优化：修复竞态条件，确保完整发送）
async function sendTextToTtsWithRetry(text, maxRetries = 3) {
  if (!text || !text.trim()) {
    return false;
  }
  
  for (let retry = 0; retry < maxRetries; retry++) {
    try {
      
      // ✅ 关键修复：优先复用现有连接，只有连接不存在或已断开时才新建
      if (retry === 0) {
        const wsState = ttsWsManager?.ws?.readyState;
        const wsClosed = !ttsWsManager || !ttsWsManager.ws || wsState === WebSocket.CLOSED || wsState === WebSocket.CLOSING;
        if (wsClosed) {
          if (ttsWsManager) {
            try {
              ttsWsManager.close();
            } catch (e) {
            }
            ttsWsManager = null;
          }
          await initTtsWebSocket();
          await new Promise(resolve => setTimeout(resolve, 500));
        } else if (ttsWsManager && ttsWsManager.ws && wsState === WebSocket.OPEN && !ttsWsManager.isSessionStarted) {
          await ttsWsManager.connect();
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        
        if (!ttsWsManager || !ttsWsManager.isReady()) {
          throw new Error("TTS连接失败");
        }
        
        if (!ttsWsManager.isSessionStarted) {
          let waitCount = 0;
          while (waitCount < 30 && !ttsWsManager.isSessionStarted) {
            await new Promise(resolve => setTimeout(resolve, 100));
            waitCount++;
          }
          if (!ttsWsManager.isSessionStarted) {
            throw new Error("TTS会话启动超时");
          }
        }
        
      } else {
        // 重试时，只需确保连接就绪
        await ensureTtsReady(3);
      }
      
      if (!ttsWsManager || !ttsWsManager.isReady() || !ttsWsManager.isSessionStarted) {
        throw new Error("TTS未就绪");
      }
      
      // 清理文本
      const cleanText = sanitizeTextForTts(text);
      if (!cleanText || !cleanText.trim()) {
        return false;
      }
      
      // 重置状态
      sentTextTotal.value = cleanText.trim();
      isTtsTextAllSent.value = false;
      
      // ✅ 关键优化：按标点符号分割文本，逐句发送，避免竞态
      const punctuationRegex = /[。！？，；：、.!,?;:]/;
      let textBuffer = cleanText.trim();
      let sentCount = 0;
      const sentences = [];
      
      // 先分割所有句子
      let hasPunctuation = true;
      while (hasPunctuation && textBuffer.trim().length > 0) {
        let firstPunctuationIndex = -1;
        for (let i = 0; i < textBuffer.length; i++) {
          if (punctuationRegex.test(textBuffer[i])) {
            firstPunctuationIndex = i;
            break;
          }
        }

        if (firstPunctuationIndex === -1) {
          hasPunctuation = false;
          break;
        }

        const sentenceToSend = textBuffer.substring(0, firstPunctuationIndex + 1);
        textBuffer = textBuffer.substring(firstPunctuationIndex + 1);

        if (sentenceToSend.trim().length > 0) {
          sentences.push(sentenceToSend.trim());
        }
      }

      // 发送剩余文本
      if (textBuffer && textBuffer.trim().length > 0) {
        sentences.push(textBuffer.trim());
      }
      
      
      // ✅ 关键：逐句发送，等待前一句发送完成
      for (let i = 0; i < sentences.length; i++) {
        const sentence = sentences[i];
        
        // 等待前一句发送完成
        while (isTtsSending && ttsSendQueue.length > 0) {
          await new Promise(resolve => setTimeout(resolve, 50));
        }
        
        await convertTextChunkToAudio(sentence, `sentence_${i}_${Date.now()}`);
        sentCount++;
        touchTtsActivity();
        
        // 小延迟，避免发送过快
        if (i < sentences.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
      
      
      // 等待 TTS 发送队列处理完成
      let waitCount = 0;
      while ((ttsSendQueue.length > 0 || isTtsSending) && waitCount < 100) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        waitCount++;
      }
      
      // 标记文本已全部发送
      isTtsTextAllSent.value = true;
      
      // 等待收到足够的音频片段
      const startWaitTime = Date.now();
      while (allAudioBlobsForCurrentMessage.length < sentCount && Date.now() - startWaitTime < 10000) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      
      
      // 发送 finish（只在这里调用一次，避免重复）
      if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
        try {
          await ttsWsManager.finish();
          
          // ✅ 关键修复：finish后重置自动发送标志，防止重新start时自动发送初始消息
          shouldAutoSendInitialMessages = false;
        } catch (finishError) {
        }
      } else {
      }
      
      return allAudioBlobsForCurrentMessage.length > 0;
    } catch (error) {
      if (retry < maxRetries - 1) {
        // 等待后重试
        await new Promise((resolve) => setTimeout(resolve, 1000));
        continue;
      }
      return false;
    }
  }
  return false;
}

// ✅ 新增：发送主题消息接口（简化版：先调用API，再处理TTS）

// 处理 sessionSummary 的独立函数
async function processSessionSummary(summaryText, summaryMessageIndex) {
  
  // 重置音频状态
  pendingAudioBlobs = [];
  allAudioBlobsForCurrentMessage = [];
  clearAudioChunkIndexTracking();
  sentTextTotal.value = "";
  audioReceivedTextLength.value = 0;
  isTtsTextAllSent.value = false;
  
  // ✅ 不再添加新消息，而是使用已存在的消息索引
  // 确保该消息有 audioBlobs 数组
  if (chatList.value[summaryMessageIndex] && !chatList.value[summaryMessageIndex].audioBlobs) {
    chatList.value[summaryMessageIndex].audioBlobs = [];
  }
  
  // 更新 currentAiMessageIndex 为总结消息的索引
  currentAiMessageIndex = summaryMessageIndex;
  
  // 重新初始化 TTS
  await ensureTtsReady(3);
  
  // 处理总结消息的 TTS
  if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
    const cleanSummaryText = sanitizeTextForTts(summaryText);
    if (cleanSummaryText && cleanSummaryText.trim()) {
      const punctuationRegex = /[。！？，；：、.!,?;:]/;
      let summaryTextBuffer = cleanSummaryText.trim();
      let summarySentCount = 0;
      
      let hasSummaryPunctuation = true;
      while (hasSummaryPunctuation && summaryTextBuffer.trim().length > 0) {
        let firstPunctuationIndex = -1;
        for (let i = 0; i < summaryTextBuffer.length; i++) {
          if (punctuationRegex.test(summaryTextBuffer[i])) {
            firstPunctuationIndex = i;
            break;
          }
        }

        if (firstPunctuationIndex === -1) {
          hasSummaryPunctuation = false;
          break;
        }

        const sentenceToSend = summaryTextBuffer.substring(0, firstPunctuationIndex + 1);
        summaryTextBuffer = summaryTextBuffer.substring(firstPunctuationIndex + 1);

        if (sentenceToSend.trim().length > 0) {
          await convertTextChunkToAudio(sentenceToSend.trim(), String(Date.now() + Math.random()));
          summarySentCount++;
          touchTtsActivity();
        }
      }

      // 发送剩余文本
      if (summaryTextBuffer && summaryTextBuffer.trim().length > 0) {
        await convertTextChunkToAudio(summaryTextBuffer.trim(), String(Date.now() + Math.random()));
        summarySentCount++;
        touchTtsActivity();
      }
      
      // 等待总结的 TTS 发送队列处理完成
      let summaryWaitCount = 0;
      while ((ttsSendQueue.length > 0 || isTtsSending) && summaryWaitCount < 50) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        summaryWaitCount++;
      }
      
      // 发送 finish 完成总结消息的 TTS
      if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
        try {
          await ttsWsManager.finish();
          isTtsTextAllSent.value = true;
          resetAudioReceiveTimeout();
          
          // ✅ 关键修复：finish后重置自动发送标志，防止重新start时自动发送初始消息
          shouldAutoSendInitialMessages = false;
        } catch (e) {
        }
      }
    }
  } else {
  }
  
  pendingSessionSummary = null;
  pendingSummaryMessageIndex = -1;
}

async function sendThemeMessage(userMessage) {
  
  // 新的 AI 回复开始：解除熄屏期间的音频禁用
  if (isAudioBlockedWhileScreenOff) {
    isAudioBlockedWhileScreenOff = false;
  }
  if (isTtsHardInterruptedWhileScreenOff) {
    isTtsHardInterruptedWhileScreenOff = false;
  }

  if (!currentChatId.value || !aiToken.value) {
    return null;
  }

  // ✅ 修复：将 aiMessageIndex 提升到函数作用域，以便在 catch 块中访问
  let aiMessageIndex = -1;

  try {
    const params = {
      chatRecordId: currentChatId.value,
      userMessage: userMessage,
    };


    // 停止自动监听，设置响应状态
    stopAutoVolumeMonitoring();
    isResponding.value = true;

    // 重置音频相关状态
    pendingAudioBlobs = [];
    allAudioBlobsForCurrentMessage = [];
    clearAudioChunkIndexTracking();
    shouldAutoSendInitialMessages = false;

    // 启动队列监控
    startQueueMonitor();

    // ✅ 新增：添加 AI 消息占位符（带 loading 状态）
    aiMessageIndex = chatList.value.length;
    chatList.value.push({
      role: "ai",
      content: "",
      renderedContent: "",
      loading: true,
      audioBlobs: [],
    });
    
    // 滚动到底部
    nextTick(() => {
      scrollBoxToBottom();
      if (showDialogBox.value) {
        scrollBoxToBottom();
      }
    });

    // ✅ 第一步：先调用API获取AI回复（不管TTS状态如何）
    
    // ✅ 添加10秒超时处理
    const timeoutPromise = new Promise((_, reject) => {
      apiTimeoutTimer = setTimeout(() => {
        apiTimeoutTimer = null;
        reject(new Error("接口超时（10秒）"));
      }, API_TIMEOUT_DURATION);
    });
    
    let res;
    try {
      res = await Promise.race([
        requestThemeChatMessage(params, aiToken.value),
        timeoutPromise
      ]);
      // 清除超时定时器
      if (apiTimeoutTimer) {
        clearTimeout(apiTimeoutTimer);
        apiTimeoutTimer = null;
      }
    } catch (error) {
      // 清除超时定时器
      if (apiTimeoutTimer) {
        clearTimeout(apiTimeoutTimer);
        apiTimeoutTimer = null;
      }

      // ✅ 中断请求时直接退出，不再走后续 TTS/渲染流程
      if (isAbortError(error) || isManualStop || isStoppingAudio) {
        if (chatList.value[aiMessageIndex] && chatList.value[aiMessageIndex].loading) {
          chatList.value.splice(aiMessageIndex, 1);
        }
        isResponding.value = false;
        isSendButtonProcessing.value = false;
        return null;
      }
      
      // ✅ 超时或网络错误处理
      if (error.message && error.message.includes("超时")) {
        showToast({
          message: "网络错误，请重试",
          type: "fail",
        });
        // ✅ 重置状态，让用户能再次调用
        resetResponseState();
        return null;
      }
      throw error; // 其他错误继续抛出
    }

    // ✅ 中断后请求即使返回，也直接丢弃，不再进入后续播放/渲染逻辑
    if (isManualStop || isStoppingAudio || !isResponding.value) {
      if (chatList.value[aiMessageIndex] && chatList.value[aiMessageIndex].loading) {
        chatList.value.splice(aiMessageIndex, 1);
      }
      return null;
    }

    // 检查返回状态
    if (res.code === 200 && res.data) {
      
      // 处理返回的数据
      const data = res.data;
      
      // ✅ 新增：如果有用户音频且 errorStatus === 1，调用句子评分接口
      if (currentUserAudioBase64 && userMessage && data.errorStatus === 1) {
        try {
          const scoreParams = {
            sentence: userMessage,
            audioBase64: currentUserAudioBase64,
          };
          const scoreRes = await scoreSentence(scoreParams, aiToken.value);
          
          if (scoreRes && scoreRes.code === 200 && scoreRes.data) {
            // 保存评分结果到用户消息中（找到最后一条用户消息）
            for (let i = chatList.value.length - 1; i >= 0; i--) {
              if (chatList.value[i].role === 'user' && chatList.value[i].content === userMessage) {
                chatList.value[i].score = scoreRes.data.score;
                break;
              }
            }
          } else {
          }
        } catch (scoreError) {
        } finally {
          // 清空音频数据，避免下次误用
          currentUserAudioBase64 = null;
        }
      } else {
        // 即使不调用评分接口，也要清空音频数据
        if (currentUserAudioBase64) {
          currentUserAudioBase64 = null;
        }
      }

      // ✅ 模板17：本条回复的纠错字段写回对应用户消息（按语音识别文本匹配，防止被后续消息覆盖）
      if (userMessage) {
        for (let i = chatList.value.length - 1; i >= 0; i--) {
          const m = chatList.value[i];
          if (m.role === "user" && m.content === userMessage) {
            if (data.errorStatus !== undefined) m.errorStatus = data.errorStatus;
            if (data.updateErrorContent !== undefined) {
              m.updateErrorContent = data.updateErrorContent || "";
            }
            if (data.promptContent !== undefined) {
              m.promptContent = data.promptContent || "";
            }
            if (data.correctedExample !== undefined) {
              m.correctedExample = data.correctedExample || "";
            }
            break;
          }
        }
      }

      // 如果有 AI 老师返回内容，更新之前添加的loading消息
      if (data.aiTeacherDialogue) {
        
        // ✅ 修改：更新之前添加的loading消息，而不是添加新消息
        // 移除 loading 状态，设置内容
        chatList.value[aiMessageIndex].loading = false;
        chatList.value[aiMessageIndex].originalContent = data.aiTeacherDialogue;
        chatList.value[aiMessageIndex].content = data.aiTeacherDialogue;
        chatList.value[aiMessageIndex].renderedContent = data.aiTeacherDialogue;
        
        // 设置当前正在处理的 AI 消息索引
        currentAiMessageIndex = aiMessageIndex;
        
        // 确保该消息有 audioBlobs 数组
        if (chatList.value[aiMessageIndex] && !chatList.value[aiMessageIndex].audioBlobs) {
          chatList.value[aiMessageIndex].audioBlobs = [];
        }
        chatList.value[aiMessageIndex].renderedContent = data.aiTeacherDialogue;
        
        // ✅ 如果有 sessionSummary，立即添加第二条消息到聊天列表
        if (data.shouldSummarizeNow && data.sessionSummary) {
          
          // ✅ 新增：标记对话已结束，禁止后续录音和发送
          isDialogueEnded.value = true;
          
          const summaryMessageIndex = chatList.value.length;
          chatList.value.push({
            role: "ai",
            content: data.sessionSummary,
            renderedContent: data.sessionSummary,
            originalContent: data.sessionSummary,
            audioBlobs: [],
          });
        }
        
        // ✅ 第二步：处理TTS（使用和其他模板一样的逻辑）
        try {
          
          // ✅ 关键修复：确保 TTS 就绪（如果会话已结束，会自动重新 start）
          // ensureTtsReady 会检查会话状态，如果会话已结束（之前 finish 了），会重新 start
          // 这样可以避免 start -> finish -> start 的循环问题
          await ensureTtsReady(3, true); // autoStart=true，确保会话已启动
          
          if (!ttsWsManager || !ttsWsManager.isReady() || !ttsWsManager.isSessionStarted) {
          } else {
            // 使用和其他模板一样的文本发送逻辑
            const cleanText = sanitizeTextForTts(data.aiTeacherDialogue);
        if (cleanText && cleanText.trim()) {
          
            // ✅ 先批量入队所有片段，再统一处理，避免只读第一节
            const punctuationRegex = /[。！？，；：、.!,?;:]/;
            let textBuffer = cleanText.trim();
            let sentCount = 0;
            
            let hasPunctuation = true;
            while (hasPunctuation && textBuffer.trim().length > 0) {
              let firstPunctuationIndex = -1;
              for (let i = 0; i < textBuffer.length; i++) {
                if (punctuationRegex.test(textBuffer[i])) {
                  firstPunctuationIndex = i;
                  break;
                }
              }

              if (firstPunctuationIndex === -1) {
                hasPunctuation = false;
                break;
              }

              const sentenceToSend = textBuffer.substring(0, firstPunctuationIndex + 1);
              textBuffer = textBuffer.substring(firstPunctuationIndex + 1);

              if (sentenceToSend.trim().length > 0) {
                convertTextChunkToAudio(sentenceToSend.trim(), String(Date.now() + Math.random()), true);
                sentCount++;
                touchTtsActivity();
              }
            }

            if (textBuffer && textBuffer.trim().length > 0) {
              convertTextChunkToAudio(textBuffer.trim(), String(Date.now() + Math.random()), true);
              sentCount++;
              touchTtsActivity();
            }
            
            processTtsSendQueue().catch((err) => {
              isTtsSending = false;
            });
            
            let waitCount = 0;
            while ((ttsSendQueue.length > 0 || isTtsSending) && waitCount < 150) {
              await new Promise((resolve) => setTimeout(resolve, 100));
              waitCount++;
            }
            
            if (ttsSendQueue.length > 0) {
            }
            
            // ✅ 延迟 400ms 再 finish，给后端时间处理最后一句文本
            await new Promise((resolve) => setTimeout(resolve, 400));
            
              // ✅ 关键修改：如果有 sessionSummary，先发送第二段，然后一起finish
              if (data.shouldSummarizeNow && data.sessionSummary) {
                
                // ✅ 新增：设置标志，表示正在等待更多音频（防止第一段播放完成后自动开启录音）
                isWaitingForMoreAudio = true;
                
                // 切换到第二段消息的索引
                const summaryMessageIndex = chatList.value.length - 1;
                currentAiMessageIndex = summaryMessageIndex;
                
                // 重置音频状态，准备接收第二段的音频
                allAudioBlobsForCurrentMessage = [];
                clearAudioChunkIndexTracking();
                
                // 发送第二段文本到 TTS
                const cleanSummaryText = sanitizeTextForTts(data.sessionSummary);
                if (cleanSummaryText && cleanSummaryText.trim()) {
                  
                  let summaryTextBuffer = cleanSummaryText.trim();
                  let summarySentCount = 0;
                  
                  let hasSummaryPunctuation = true;
                  while (hasSummaryPunctuation && summaryTextBuffer.trim().length > 0) {
                    let firstPunctuationIndex = -1;
                    for (let i = 0; i < summaryTextBuffer.length; i++) {
                      if (punctuationRegex.test(summaryTextBuffer[i])) {
                        firstPunctuationIndex = i;
                        break;
                      }
                    }

                    if (firstPunctuationIndex === -1) {
                      hasSummaryPunctuation = false;
                      break;
                    }

                    const sentenceToSend = summaryTextBuffer.substring(0, firstPunctuationIndex + 1);
                    summaryTextBuffer = summaryTextBuffer.substring(firstPunctuationIndex + 1);

                    if (sentenceToSend.trim().length > 0) {
                      convertTextChunkToAudio(sentenceToSend.trim(), String(Date.now() + Math.random()), true);
                      summarySentCount++;
                      touchTtsActivity();
                    }
                  }

                  if (summaryTextBuffer && summaryTextBuffer.trim().length > 0) {
                    convertTextChunkToAudio(summaryTextBuffer.trim(), String(Date.now() + Math.random()), true);
                    summarySentCount++;
                    touchTtsActivity();
                  }
                  
                  processTtsSendQueue().catch((err) => {
                    isTtsSending = false;
                  });
                  
                  
                  let summaryWaitCount = 0;
                  while ((ttsSendQueue.length > 0 || isTtsSending) && summaryWaitCount < 150) {
                    await new Promise((resolve) => setTimeout(resolve, 100));
                    summaryWaitCount++;
                  }
                  
                  await new Promise((resolve) => setTimeout(resolve, 400));
                  
                  if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
                    try {
                      await ttsWsManager.finish();
                    } catch (finishError) {
                    }
                  }
                }
                
                isTtsTextAllSent.value = true;
        } else {
                // 没有总结消息，发送完消息后 finish（上面已有 400ms 延迟）
                if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
                  try {
                    await ttsWsManager.finish();
                  } catch (finishError) {
                  }
                }
                isTtsTextAllSent.value = true;
              }
            }
          }
        } catch (ttsError) {
        }
        
        // ✅ 关键修复：与 confirmTheme 保持一致，立即设置 isResponding = false
        // 这样音频播放不会被误判为还在响应中而暂停
        // 音频播放完成后的状态重置会在 playNextAudio 的 onended 回调中处理
        isResponding.value = false;
        
        // ✅ 移除这里的 processSessionSummary 调用，因为已经在上面直接发送了
        // 不再需要等待第一段播放完成后再处理第二段
        
        // ✅ 修复：主题对话完成后，如果音频不在播放中，允许再次点击发送按钮
        if (!isPlayingAudio && audioQueueLengthRef.value === 0) {
          isSendButtonProcessing.value = false;
        }
      } else {
        // ✅ 修复：移除loading消息
        if (chatList.value[aiMessageIndex]) {
          chatList.value.splice(aiMessageIndex, 1);
        }
        isResponding.value = false;
      }
      
      // 如果有纠错内容
      // 如果有提示内容（用于“小小建议/小提示”弹窗）
      if (data.promptContent) {
        promptContent.value = data.promptContent;
      }
      
      // 显示轮次（roundNum 暂未使用）
      if (data.roundNum !== undefined) {
        void data.roundNum;
      }
      
      return res.data;
    } else {
      // ✅ 修复：移除loading消息
      if (chatList.value[aiMessageIndex]) {
        chatList.value.splice(aiMessageIndex, 1);
      }
      isResponding.value = false;
      isSendButtonProcessing.value = false; // ✅ 修复：失败时也要重置
      showToast({
        message: "发送消息失败，请重试",
        type: "fail",
      });
      return null;
    }
  } catch (error) {
    if (isAbortError(error) || isManualStop || isStoppingAudio) {
      if (chatList.value[aiMessageIndex] && chatList.value[aiMessageIndex].loading) {
        chatList.value.splice(aiMessageIndex, 1);
      }
      isResponding.value = false;
      isSendButtonProcessing.value = false;
      return null;
    }
    // ✅ 修复：移除loading消息
    if (chatList.value[aiMessageIndex]) {
      chatList.value.splice(aiMessageIndex, 1);
    }
    isResponding.value = false;
    isSendButtonProcessing.value = false; // ✅ 修复：异常时也要重置
    showToast({
      message: "发送消息失败，请重试",
      type: "fail",
    });
    return null;
  }
}

// ✅ 处理主题消息的TTS（独立函数，带重试机制）
async function handleThemeTts(text) {
  if (!text || !text.trim()) {
    return;
  }
  
  const cleanText = sanitizeTextForTts(text);
  if (!cleanText || !cleanText.trim()) {
    return;
  }
  
  // ✅ 修复：使用统一的 ensureTtsReady 函数，避免重复初始化
  try {
    await ensureTtsReady(3);
  } catch (e) {
    return;
  }
  
  // 检查TTS是否最终就绪
  if (!ttsWsManager || !ttsWsManager.isReady() || !ttsWsManager.isSessionStarted) {
    return;
  }
  
  try {
    sentTextTotal.value = cleanText.trim();
    isTtsTextAllSent.value = false;
    
    // 按标点符号分割文本发送
    const punctuationRegex = /[。！？，；：、.!,?;:]/;
    let textBuffer = cleanText.trim();
    let sentCount = 0;
    
    let hasPunctuation = true;
    while (hasPunctuation && textBuffer.trim().length > 0) {
      let firstPunctuationIndex = -1;
      for (let i = 0; i < textBuffer.length; i++) {
        if (punctuationRegex.test(textBuffer[i])) {
          firstPunctuationIndex = i;
          break;
        }
      }

      if (firstPunctuationIndex === -1) {
        hasPunctuation = false;
        break;
      }

      const sentenceToSend = textBuffer.substring(0, firstPunctuationIndex + 1);
      textBuffer = textBuffer.substring(firstPunctuationIndex + 1);

      if (sentenceToSend.trim().length > 0) {
        await convertTextChunkToAudio(sentenceToSend.trim(), String(Date.now() + Math.random()));
        sentCount++;
        touchTtsActivity();
      }
    }

    // 发送剩余文本
    if (textBuffer && textBuffer.trim().length > 0) {
      await convertTextChunkToAudio(textBuffer.trim(), String(Date.now() + Math.random()));
      sentCount++;
      touchTtsActivity();
    }
    
    
    // 等待 TTS 发送队列处理完成
    let waitCount = 0;
    while ((ttsSendQueue.length > 0 || isTtsSending) && waitCount < 50) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      waitCount++;
    }
    
    // 标记文本已全部发送
    isTtsTextAllSent.value = true;
    
    // ✅ 重置自动发送标志
    shouldAutoSendInitialMessages = false;
    
    // ✅ 修改：文本发送完毕后立即发送 finish，不等待 complete
    if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
      try {
        await ttsWsManager.finish();
        
        // ✅ 关键修复：finish后重置自动发送标志，防止重新start时自动发送初始消息
        shouldAutoSendInitialMessages = false;
      } catch (e) {
      }
    }
    
    // ✅ 等待 complete 消息（在 handleCompleteMessage 中会拼接所有音频碎片）
    
    // 启动音频接收超时机制
    if (allAudioBlobsForCurrentMessage.length > 0) {
      resetAudioReceiveTimeout();
    } else {
      await new Promise((resolve) => setTimeout(resolve, 500));
      resetAudioReceiveTimeout();
    }
    
  } catch (err) {
    // 如果发送失败，也要清理定时器
  }
}

// 发送消息
const sendMessage = async () => {
  if (!canSend.value) return;

  // 发送文本前，停止自动监听
  stopAutoVolumeMonitoring();

  // 发送文本前，打断之前的音频和文本输出
  interruptAudioAndText();

  if (inputContent.value?.length == 0 && imageUrl.value?.length == 0) {
    return;
  }
  if (!inputContent.value.trim() && imageUrl.value?.length == 0) {
    return;
  }

  const userMessage = inputContent.value.trim();
  if (!userMessage) return;

  // 添加用户消息
  chatList.value.push({
    role: "user",
    content: userMessage,
    renderedContent: renderMath(userMessage),
  });

  // 添加一个带加载状态的AI消息
  const aiMessageIndex = chatList.value.length;
  chatList.value.push({
    role: "ai",
    content: "",
    renderedContent: "",
    loading: true,
    audioBlobs: [],
  });

  // 清空输入
  inputContent.value = "";
  // ✅ 用户发送消息时清除15秒定时器（播放结束后才重新开始计时）
  clearNoActionTimer();

  // 滚动到底部
  nextTick(() => {
    scrollBoxToBottom();
    if (showDialogBox.value) {
      scrollBoxToBottom();
    }
  });

  // 发送消息
  try {
    isFinishSuccess.value = false;
    await sendSpokenMessage(userMessage, aiMessageIndex);
  } catch (error) {
    showToast({
      message: "发送消息失败，请重试",
      type: "fail",
    });
    // 错误时关闭 loading 状态
    if (chatList.value[aiMessageIndex]) {
      chatList.value[aiMessageIndex].loading = false;
      chatList.value[aiMessageIndex].content = "请求失败，请稍后再试。";
      chatList.value[aiMessageIndex].renderedContent =
        renderMath("请求失败，请稍后再试。");
    }
    isResponding.value = false;
    // 接口报错时，允许再次点击发送按钮
    isSendButtonProcessing.value = false;
  }
};

// ✅ 重置响应状态（接口超时或失败时调用）
function resetResponseState() {
  // 递增代次：使之前所有流式回调失效
  activeResponseEpoch++;
  invalidateVoiceChain();
  
  // 重置响应状态
  isResponding.value = false;
  isConvertingVoiceToText.value = false;
  isSendButtonProcessing.value = false;
  
  // 停止流式请求
  if (currentSpokenStream) {
    try {
      if (typeof currentSpokenStream.abort === "function") {
        currentSpokenStream.abort();
      }
    } catch (e) {
    }
    currentSpokenStream = null;
  }
  abortThemeChatRequest();
  removeEmptyAiLoadingMessages();
  
  // 停止音频播放
  stopAIAudioPlayback();
  stopTextRendering();
  
  // 关闭 loading 状态
  for (let i = chatList.value.length - 1; i >= 0; i--) {
    if (chatList.value[i].role === "ai" && chatList.value[i].loading) {
      chatList.value[i].loading = false;
      // 如果内容为空，添加错误提示
      if (!chatList.value[i].content) {
        chatList.value[i].content = "请求失败，请稍后再试。";
        chatList.value[i].renderedContent = renderMath("请求失败，请稍后再试。");
      }
    }
  }
  
  currentAiMessageIndex = -1;
  
  // 清除接口超时定时器
  if (apiTimeoutTimer) {
    clearTimeout(apiTimeoutTimer);
    apiTimeoutTimer = null;
  }
  
}

// 打断音频和文本输出
function interruptAudioAndText() {
  // 递增代次：使之前所有流式回调失效
  activeResponseEpoch++;
  invalidateVoiceChain();
  isResponding.value = false;

  // ✅ 防止首句等待 complete 的开关在中断后残留，影响后续音频播放
  if (waitForInitialCompleteBeforePlay) {
    waitForInitialCompleteBeforePlay = false;
    if (initialCompleteFallbackTimer) {
      clearTimeout(initialCompleteFallbackTimer);
      initialCompleteFallbackTimer = null;
    }
  }

  if (currentSpokenStream) {
    try {
      if (typeof currentSpokenStream.abort === "function") {
        currentSpokenStream.abort();
      }
    } catch (e) {
    }
    currentSpokenStream = null;
  }
  abortThemeChatRequest();
  removeEmptyAiLoadingMessages();

  stopAIAudioPlayback();
  stopTextRendering();

  for (let i = chatList.value.length - 1; i >= 0; i--) {
    if (chatList.value[i].role === "ai" && chatList.value[i].loading) {
      chatList.value[i].loading = false;
    }
  }

  currentAiMessageIndex = -1;
}

// 停止响应
const stopResponse = async () => {
  try {
    interruptAudioAndText();

    if (ttsWsManager) {
      try {
        if (ttsWsManager.isReady()) {
          ttsWsManager.finish();
        }
      } catch (e) {
      }
    }

    if (ttsFinishTimer) {
      clearTimeout(ttsFinishTimer);
      ttsFinishTimer = null;
    }
    if (audioReceiveTimeoutTimer) {
      clearTimeout(audioReceiveTimeoutTimer);
      audioReceiveTimeoutTimer = null;
    }
    // ✅ 新增：清理模板17的音频超时定时器
    if (template17AudioTimeoutTimer) {
      clearTimeout(template17AudioTimeoutTimer);
      template17AudioTimeoutTimer = null;
    }

    ttsSendQueue = [];
    isTtsSending = false;

    stopAIAudioPlayback();

    pendingAudioBlobs = [];
    allAudioBlobsForCurrentMessage = [];
    receivedMessageIds.clear();
    audioChunkDataMap.clear();
    audioChunkReceiveTimeMap.clear();
    clearAudioChunkIndexTracking();
    audioQueue = [];
    processedTextLength = 0;
    textToAudioRecordIds = [];
    isProcessingBlobs = false;
    isConvertingTextToAudio = false;
    
    if (currentTextToAudioStream) {
      try {
        if (typeof currentTextToAudioStream.abort === "function") {
          currentTextToAudioStream.abort();
        }
      } catch (e) {
        // ignore
      }
      currentTextToAudioStream = null;
    }
    // 2.1 强制中断 mp3ToText 请求
    abortMp3ToTextRequest();
    // 2.2 强制中断主题对话请求
    abortThemeChatRequest();
    
    currentAiMessageIndex = -1;
    sentTextTotal.value = "";
    audioReceivedTextLength.value = 0;
    isTtsTextAllSent.value = false;
    
    if (audioFinishTimer) {
      clearTimeout(audioFinishTimer);
      audioFinishTimer = null;
    }
    
    audioReceiveTimeoutRetryCount = 0;
    updateAudioStateRefs();
    setPlayingAudioState(false);

    setTimeout(() => {
      const isReallyStopped =
        !isPlayingAudio &&
        audioQueueLengthRef.value === 0;
      
    }, 800);
  } catch (error) {
    isResponding.value = false;
    isSendButtonProcessing.value = false;
    currentSpokenStream = null;
  }
};

// ✅ 已移除所有 Web Audio API 播放相关代码，只使用 HTML5 Audio
// 录音相关的 AudioContext 保留在下方，用于录音和音量检测

// ✅ 使用 MediaSource API 播放音频（支持流式追加，降级时使用 Blob URL）
function enqueueWebAudioBlob(blob) {
  if (isAudioBlockedWhileScreenOff) return;
  if (!blob || blob.size === 0) {
    return;
  }

  try {
    // ✅ 关键修复：如果正在录音，先停止录音（但不保存），然后再播放音频
    if (isInSession.value && !isTipAudioMode) {
      shouldSaveRecording = false;
      stopRecording();
    } else if (isInSession.value && isTipAudioMode) {
      /* 提示音频模式，不停止录音 */
    }

    if (audioFinishTimer) {
      clearTimeout(audioFinishTimer);
      audioFinishTimer = null;
    }
    
    updateAudioStateRefs();
    updatePlaybackStatus();
    
    // ✅ MediaSource 模式：存储 Blob；降级模式：存储 Blob URL
    if (USE_MEDIA_SOURCE) {
      audioQueue.push(blob);
    } else {
      const audioUrl = URL.createObjectURL(blob);
      if (audioUrl && audioUrl.trim()) {
        audioQueue.push(audioUrl);
      }
    }
    
    if (!isPlayingAudio && audioQueue.length > 0) {
      initAudioPlayer();
      playNextAudio();
    } else if (isPlayingAudio && audioQueue.length > 0) {
      // 入队时立即预加载下一段，争取更多加载时间减少段间停顿
      const next = audioQueue[0];
      if (next && typeof next === "string" && next.startsWith("blob:")) {
        if (!preloadAudio) {
          preloadAudio = new Audio();
          preloadAudio.preload = "auto";
        }
        if (preloadAudio.src !== next) {
          preloadAudio.src = next;
          preloadAudio.load();
        }
      }
      // 播放中且队列有2+段：延迟合并后续片段，减少播放切换次数（80ms 更快合并减少段间卡顿）
      if (audioQueue.length >= 2) {
        if (queueMergeTimeout) clearTimeout(queueMergeTimeout);
        queueMergeTimeout = setTimeout(() => {
          queueMergeTimeout = null;
          mergePendingQueueSegments();
        }, 80);
      }
    }
  } catch (error) {
  }
}

// ✅ 使用 Howler.js 播放音频（解决Android音量控制和播放卡顿问题）
function playWithHowler(audioUrl) {
  if (!Howl || typeof Howl !== 'function') {
    // 从队列中移除，使用 HTML5 Audio 播放
    const index = audioQueue.indexOf(audioUrl);
    if (index > -1) {
      audioQueue.splice(index, 1);
    }
    if (!isPlayingAudio && audioQueue.length > 0) {
      initAudioPlayer();
      playNextAudio();
    }
    return;
  }
  
  try {
    // ✅ 修复：停止当前播放的音频（Howler.js 和 HTML5 Audio）
    if (currentHowlSound) {
      currentHowlSound.stop();
      currentHowlSound.unload();
      currentHowlSound = null;
    }
    
    // ✅ 修复：停止 HTML5 Audio 播放器（如果正在播放），避免重复播放
    if (audioPlayer.value && !audioPlayer.value.paused) {
      audioPlayer.value.pause();
      audioPlayer.value.currentTime = 0;
    }
    
    // ✅ 修复：从队列中移除当前音频（如果存在），避免 HTML5 Audio 也播放
    const index = audioQueue.indexOf(audioUrl);
    if (index > -1) {
      audioQueue.splice(index, 1);
    }
    
    // 创建新的 Howl 实例
    const howl = new Howl({
      src: [audioUrl],
      format: ['opus', 'webm', 'mp3'], // 支持多种格式
      html5: true, // 使用 HTML5 Audio（Howler.js 会自动优化）
      volume: 1.0, // 使用系统音量（Howler.js 会自动处理）
      autoplay: true,
      onload: () => {
      },
      onplay: () => {
        isPlayingAudio = true;
        setPlayingAudioState(true);
        consecutiveFailures = 0;
        // ✅ 修复：停止 HTML5 Audio 播放器（如果正在播放），避免重复播放
        if (audioPlayer.value && !audioPlayer.value.paused) {
          audioPlayer.value.pause();
          audioPlayer.value.currentTime = 0;
        }
      },
      onend: () => {
        // 释放资源
        if (currentHowlSound) {
          currentHowlSound.unload();
          currentHowlSound = null;
        }
        // 释放 Blob URL
        try {
          URL.revokeObjectURL(audioUrl);
        } catch (e) {
          // 忽略释放错误
        }
        // ✅ 修复：播放下一段（从队列中获取，如果队列为空则停止）
        // 注意：使用 Howler.js 时，音频不在队列中，需要从其他地方获取下一段
        // 这里暂时不自动播放下一段，等待新的音频通过 enqueueWebAudioBlob 加入
        isPlayingAudio = false;
        setPlayingAudioState(false);
      },
      onerror: (id, error) => {
        consecutiveFailures++;
        // 释放资源
        if (currentHowlSound) {
          currentHowlSound.unload();
          currentHowlSound = null;
        }
        // 释放 Blob URL
        try {
          URL.revokeObjectURL(audioUrl);
        } catch (e) {
          // 忽略释放错误
        }
        // 如果失败次数过多，停止播放
        if (consecutiveFailures >= MAX_CONSECUTIVE_FAILURES) {
          isPlayingAudio = false;
          audioQueue = [];
          consecutiveFailures = 0;
        } else if (audioQueue.length > 0) {
          // 继续播放下一段
          const nextUrl = audioQueue.shift();
          playWithHowler(nextUrl);
        }
      }
    });
    
    currentHowlSound = howl;
    
  } catch (error) {
    // 降级到 HTML5 Audio
    audioQueue.push(audioUrl);
    if (!isPlayingAudio && audioQueue.length > 0) {
      initAudioPlayer();
      playNextAudio();
    }
  }
}

let ffmpeg = null;
let isFFmpegLoaded = false;
// ✅ 所有设备禁用静音裁剪（降低复杂度，提升稳定性）
const ENABLE_SILENCE_TRIM = false;
let isProcessingBlobs = false;
let isConvertingTextToAudio = false;
const MAX_CONCURRENT_TTS_REQUESTS = 3;
let activeTtsRequests = 0;
let ttsRequestQueue = [];
let processedTextLength = 0;
let textToAudioRecordIds = [];
let currentTextToAudioStream = null;
let ttsWsManager = null;
let isTtsInitializing = false; // ✅ 新增：防止并发初始化 TTS
let ttsInitializingStartTime = 0; // ✅ 新增：记录初始化开始时间
let ttsLastChunkTime = 0;
let ttsLastSendTime = 0;
let ttsFinishTimer = null;
let audioFinishTimer = null;
let audioReceiveTimeoutTimer = null; // 音频接收超时定时器（动态超时）
let audioReceiveTimeoutRetryCount = 0; // 音频接收超时重试次数
const isFinishSuccess = ref(false);

// ✅ 新增：定时器暂停/恢复系统（用于屏幕关闭/打开）
let pausedTimers = new Map(); // Map<timerName, {timer, startTime, duration, callback, type}>
let isScreenPaused = false; // 标记屏幕是否已暂停

// ✅ 熄屏处理（actOnPause 调用，全部掐断播放，保存状态供亮屏恢复）
let isAudioBlockedWhileScreenOff = false; // 熄屏期间阻断 TTS 回调触发播放/合并（避免碎片音频）
let isScreenOffHardPaused = false; // 熄屏期间的幂等保护
let noActionTimerRemainingWhileScreenOff = 0; // 熄屏时保存闲置语音剩余时间（用于亮屏恢复倒计时）
let isTtsHardInterruptedWhileScreenOff = false; // 熄屏后保持 true：阻断 TTS chunk/complete 进入合并播放
let shouldScheduleNoActionTimerAfterScreenOff = false; // 熄屏期间本应启动闲置倒计时的延后补偿
async function handleScreenOff() {
  // 熄屏硬中断：后续不允许恢复旧队列/旧会话
  if (isScreenOffHardPaused) return;
  isScreenOffHardPaused = true;

  // ✅ 先阻断后续 TTS chunk 回调（避免熄屏后仍把碎片音频合并/入队）
  isAudioBlockedWhileScreenOff = true;
  isTtsHardInterruptedWhileScreenOff = true;
  // 熄屏统一走“中断”链路，行为与手动中断完全一致
  await stopAudioOnly();

  // ✅ 熄屏期间暂停“闲置语音倒计时”，避免定时器触发后因音频被禁用而直接丢失
  if (noActionTimer) {
    const elapsed = Date.now() - noActionTimerStartTime;
    const remaining = Math.max(0, noActionTimerDuration - elapsed);
    noActionTimerRemainingWhileScreenOff = remaining;
    clearTimeout(noActionTimer);
    noActionTimer = null;
  } else {
    noActionTimerRemainingWhileScreenOff = 0;
  }

  // ✅ 释放安卓音频通道（避免熄屏后通话/媒体通道混用残留音）
  if (window.android && typeof window.android.callNative === "function") {
    try {
      window.android.callNative(JSON.stringify({ func: "getResetAudio" }));
    } catch (e) {
      // ignore
    }
  }

  // 记录：熄屏期间音频被禁用，避免 loading 因 isTtsTextAllSent 卡住
  isTtsTextAllSent.value = false;

  // ✅ 熄屏期间音频被强制停止：倒计时由“补偿逻辑”在亮屏/回复结束后启动
  if (!isInSession.value && currentChatId.value && aiToken.value) {
    shouldScheduleNoActionTimerAfterScreenOff = true;
  }
}

// ✅ 亮屏处理（恢复音频和计时器，类似 uniapp onShow）
async function handleScreenOn() {
  // 只结束熄屏幂等保护；本次熄屏期间的“音频禁用”保持到下一次新消息发起时解除
  // 文本流式输出无需中断，因此这里不做 resetAllStatesAndReconnect
  isScreenOffHardPaused = false;
  isAudioBlockedWhileScreenOff = false;
  // 熄屏期间音频已被硬中断时，亮屏后不要继续显示“加载中”
  //（isTtsTextAllSent 为 true 会触发 loading 视图卡住）
  if (isTtsHardInterruptedWhileScreenOff) {
    isResponding.value = false;
    isTtsTextAllSent.value = false;
    clearAiLoadingStates();
    removeEmptyAiLoadingMessages();
  }
  updateAudioStateRefs();

  // ✅ 恢复闲置语音倒计时（如果熄屏前正在跑）
  if (noActionTimerRemainingWhileScreenOff > 0) {
    startNoActionTimerWithDuration(noActionTimerRemainingWhileScreenOff);
    noActionTimerRemainingWhileScreenOff = 0;
  }

  // ✅ 补偿：如果熄屏期间音频停止时本应触发倒计时，但因 isAudioBlockedWhileScreenOff 被 return 掉
  if (shouldScheduleNoActionTimerAfterScreenOff) {
    shouldScheduleNoActionTimerAfterScreenOff = false;
    // 只有在当前不录音且不请求中才启动
    if (!isInSession.value && !isResponding.value && currentChatId.value && aiToken.value) {
      resetNoActionTimer();
    }
  }

  // ✅ 兜底：如果当前确实空闲但倒计时没被安排，补启动一次
  if (!noActionTimer && !isInSession.value && !isResponding.value && currentChatId.value && aiToken.value) {
    resetNoActionTimer();
  }
}

// ✅ 暂停所有定时器和倒计时
function pauseAllTimers() {
  if (isScreenPaused) {
    return;
  }
  
  isScreenPaused = true;
  
  const pauseTimer = (timerName, timerRef, duration, callback, type = 'timeout') => {
    if (timerRef && timerRef !== null) {
      const now = Date.now();
      let remainingTime = duration;
      
      // 对于 setInterval，需要特殊处理
      if (type === 'interval') {
        // 对于 interval，记录下次执行的时间
        pausedTimers.set(timerName, {
          timer: timerRef,
          startTime: now,
          duration: duration,
          callback: callback,
          type: 'interval'
        });
      } else {
        // 对于 setTimeout，计算剩余时间
        // 注意：JavaScript 的 setTimeout 无法直接获取剩余时间，这里使用估算
        pausedTimers.set(timerName, {
          timer: timerRef,
          startTime: now,
          duration: duration,
          callback: callback,
          type: 'timeout'
        });
      }
      
      if (type === 'interval') {
        clearInterval(timerRef);
      } else {
        clearTimeout(timerRef);
      }
      
    }
  };
  
  // 暂停所有定时器
  // 注意：由于无法直接获取 setTimeout 的剩余时间，我们只能清除它们
  // 恢复时需要根据业务逻辑重新启动
  
  // 1. 15秒无操作提示定时器（✅ 暂停而非销毁，保存剩余时间供恢复）
  if (noActionTimer) {
    const remaining = Math.max(0, noActionTimerDuration - (Date.now() - noActionTimerStartTime));
    pausedTimers.set('noActionTimer', {
      timer: noActionTimer,
      startTime: Date.now(),
      duration: remaining,
      remainingDuration: remaining,
      callback: null,
      type: 'timeout'
    });
    clearTimeout(noActionTimer);
    noActionTimer = null;
  }
  
  // 2. 音量检测定时器
  if (volumeCheckTimer) {
    pauseTimer('volumeCheckTimer', volumeCheckTimer, VOLUME_CHECK_INTERVAL, null, 'interval');
    volumeCheckTimer = null;
  }
  
  // 3. 静音检测定时器
  if (silenceTimer) {
    pauseTimer('silenceTimer', silenceTimer, SILENCE_DURATION, null, 'timeout');
    silenceTimer = null;
  }
  
  // 4. 自动音量监听定时器
  if (autoVolumeCheckTimer) {
    pauseTimer('autoVolumeCheckTimer', autoVolumeCheckTimer, AUTO_VOLUME_CHECK_INTERVAL, null, 'interval');
    autoVolumeCheckTimer = null;
  }
  
  // 5. 自动音量超时定时器
  if (autoVolumeTimeoutTimer) {
    pauseTimer('autoVolumeTimeoutTimer', autoVolumeTimeoutTimer, 3000, null, 'timeout');
    autoVolumeTimeoutTimer = null;
  }
  
  // 6. 文本渲染定时器
  if (textRenderTimer) {
    pauseTimer('textRenderTimer', textRenderTimer, TEXT_RENDER_INTERVAL, null, 'interval');
    textRenderTimer = null;
  }
  
  // 7. TTS finish 定时器
  if (ttsFinishTimer) {
    pauseTimer('ttsFinishTimer', ttsFinishTimer, 0, null, 'timeout');
    ttsFinishTimer = null;
  }
  
  // 8. 音频完成定时器
  if (audioFinishTimer) {
    pauseTimer('audioFinishTimer', audioFinishTimer, 0, null, 'timeout');
    audioFinishTimer = null;
  }
  
  // 9. 音频接收超时定时器
  if (audioReceiveTimeoutTimer) {
    pauseTimer('audioReceiveTimeoutTimer', audioReceiveTimeoutTimer, 0, null, 'timeout');
    audioReceiveTimeoutTimer = null;
  }
  
  // 10. 模板17音频超时定时器
  if (template17AudioTimeoutTimer) {
    pauseTimer('template17AudioTimeoutTimer', template17AudioTimeoutTimer, 0, null, 'timeout');
    template17AudioTimeoutTimer = null;
  }
  
  // 11. 提示音频播放完成定时器
  if (tipAudioPlaybackTimer) {
    pauseTimer('tipAudioPlaybackTimer', tipAudioPlaybackTimer, 0, null, 'timeout');
    tipAudioPlaybackTimer = null;
  }
  
  // 13. 提示音频超时定时器
  if (tipAudioTimeoutTimer) {
    pauseTimer('tipAudioTimeoutTimer', tipAudioTimeoutTimer, 0, null, 'timeout');
    tipAudioTimeoutTimer = null;
  }
  
  // 14. 队列监控定时器
  if (queueMonitorTimer) {
    pauseTimer('queueMonitorTimer', queueMonitorTimer, 200, null, 'interval');
    queueMonitorTimer = null;
  }
  
  // 15. 动画帧定时器（requestAnimationFrame）
  if (frameAnimationTimer) {
    stopFrameAnimation();
    pausedTimers.set('frameAnimationTimer', {
      timer: frameAnimationTimer,
      startTime: Date.now(),
      duration: 0,
      callback: null,
      type: 'animation'
    });
    frameAnimationTimer = null;
  }
  
}

// ✅ 恢复所有定时器和倒计时
function resumeAllTimers() {
  if (!isScreenPaused) {
    return;
  }
  
  
  // 恢复定时器（根据业务逻辑重新启动）
  // 注意：由于无法准确获取 setTimeout 的剩余时间，这里根据业务逻辑重新启动
  
  // 1. 恢复15秒无操作提示定时器（有保存则用剩余时间恢复，否则重新开始15秒倒计时）
  const noActionSaved = pausedTimers.get('noActionTimer');
  if (currentChatId.value && !isInSession.value) {
    if (noActionSaved && noActionSaved.remainingDuration > 0) {
      startNoActionTimerWithDuration(noActionSaved.remainingDuration);
    } else {
      resetNoActionTimer();
    }
  }
  pausedTimers.delete('noActionTimer');
  
  // 2. 恢复音量检测定时器（如果正在录音）
  if (isInSession.value && analyser && pausedTimers.has('volumeCheckTimer')) {
    volumeCheckTimer = setInterval(() => {
      if (!analyser || !isInSession.value) {
        return;
      }
      const dataArray = new Uint8Array(analyser.frequencyBinCount);
      analyser.getByteFrequencyData(dataArray);
      const average = dataArray.reduce((sum, val) => sum + val, 0) / dataArray.length;
      const volume = average / 255;
      const currentThreshold = isPlayingAudio ? VOICE_THRESHOLD_WHEN_PLAYING : SILENCE_THRESHOLD;
      
      if (volume > currentThreshold) {
        lastVoiceTime = Date.now();
        if (silenceTimer) {
          clearTimeout(silenceTimer);
          silenceTimer = null;
        }
      } else {
        if (!silenceTimer && Date.now() - lastVoiceTime > SILENCE_DURATION) {
          silenceTimer = setTimeout(() => {
            if (isInSession.value && Date.now() - lastVoiceTime >= SILENCE_DURATION) {
              stopRecording();
            }
            silenceTimer = null;
          }, SILENCE_DURATION);
        }
      }
    }, VOLUME_CHECK_INTERVAL);
  }
  
  // 3. 恢复自动音量监听定时器（如果正在自动监听）
  if (isAutoVolumeMonitoringRef.value && autoVolumeAnalyser && pausedTimers.has('autoVolumeCheckTimer')) {
    autoVolumeCheckTimer = setInterval(() => {
      if (!autoVolumeAnalyser || !isAutoVolumeMonitoringRef.value) {
        return;
      }
      const dataArray = new Uint8Array(autoVolumeAnalyser.frequencyBinCount);
      autoVolumeAnalyser.getByteFrequencyData(dataArray);
      const average = dataArray.reduce((sum, val) => sum + val, 0) / dataArray.length;
      const volume = average / 255;
      
    }, AUTO_VOLUME_CHECK_INTERVAL);
  }
  
  // 4. 恢复文本渲染定时器（如果正在渲染）
  if (textRenderTimer === null && accumulatedText.length > renderedTextLength && pausedTimers.has('textRenderTimer')) {
    startTextRendering(currentRenderingMessageIndex);
  }
  
  // 5. 恢复队列监控定时器（如果队列有内容）
  if (queueMonitorTimer === null && pausedTimers.has('queueMonitorTimer')) {
    startQueueMonitor();
  }
  
  // 6. 恢复动画帧定时器（如果之前有动画）
  if (frameAnimationTimer === null && pausedTimers.has('frameAnimationTimer')) {
    startFrameAnimation();
  }
  
  // 清空暂停记录
  pausedTimers.clear();
  isScreenPaused = false;
  
}
let allAudioBlobsForCurrentMessage = []; // 保留用于缓存完整音频（用于重播）
// 音频片段索引追踪（用于完整性校验）
let audioChunkIndexMap = new Map(); // Map<index, blob> - 按索引存储音频片段（保留用于兼容）
let expectedChunkIndex = 0; // 期望的下一个片段索引（保留用于兼容）
let receivedChunkIndices = new Set(); // 已接收的片段索引集合（用于检测缺失，保留用于兼容）
let maxReceivedChunkIndex = -1; // 已接收的最大索引（保留用于兼容）

// ✅ 优化：基于接收时间戳的排序机制（解决 messageId 无法排序的问题）
let audioChunkReceiveTimeMap = new Map(); // Map<messageId, receiveTimestamp> - 记录每个音频片段的接收时间
let receivedMessageIds = new Set(); // 已接收的 messageId 集合（用于去重）
let audioChunkDataMap = new Map(); // Map<messageId, {blob, receiveTimestamp, messageId}> - 存储音频数据
let shouldAutoSendInitialMessages = false;
let template17InitialSent = false; // 模板17互斥：确保只发送一次，避免正式服读两遍
const TTS_SEND_INTERVAL = 100;
let ttsSendQueue = [];
let isTtsSending = false;
// ✅ 待发送的主题消息缓存（用于重试机制）
let pendingThemeMessage = null; // { params, userMessage, retryCount }
let pendingThemeResponse = null; // 存储接口返回的响应数据

// 文本-音频关联跟踪变量
const sentTextTotal = ref(""); // 累计发送到 TTS 的所有文本
const audioReceivedTextLength = ref(0); // 已接收音频对应的文本长度（需服务端返回，或按音频时长估算）
const isTtsTextAllSent = ref(false); // 是否所有文本都已发送到 TTS
// ✅ 优化配置：提升缓冲门槛，确保首次播放前攒够足够音频，彻底避免「边播边等」
// 所有设备：缓冲阈值提高50-100%（更保守的缓冲策略，确保播放流畅）
const MIN_BUFFER_COUNT = 15; // 减少缓冲要求，更快开始播放
const MIN_BUFFER_COUNT_FALLBACK = 5;
const PREDECODE_COUNT = 30;
const PLAY_START_DELAY = 200; // 减少延迟，更快响应
const BUFFER_WAIT_TIMEOUT = 4000;

// 文本逐字符渲染相关变量
let textRenderTimer = null; // 文本渲染定时器
const TEXT_RENDER_INTERVAL = 50; // 每个字符渲染间隔：50ms（0.05秒）
let currentRenderingMessageIndex = -1; // 当前正在渲染的消息索引
let accumulatedText = ""; // 累加的流式文本（所有文本都先累加到这里）
let renderedTextLength = 0; // 已渲染的字符数（从 accumulatedText 中已渲染的长度）

function sanitizeTextForTts(text) {
  if (!text) return "";
  const EMOJI_REGEX = /[\u{1F000}-\u{1FFFF}\u{2600}-\u{27BF}]/gu;
  // 过滤表情符号、*号和#号（避免AI读出来）
  let cleaned = text.replace(EMOJI_REGEX, "").replace(/\*/g, "").replace(/#/g, "");
  // 列表序号 "1. xxx" 转为 "1、xxx"，避免 TTS 读出 "dot"
  cleaned = cleaned.replace(/(^|\n)\s*(\d+)\.\s+/g, "$1$2、");
  // 多个英文句点统一为省略号停顿
  cleaned = cleaned.replace(/\.{2,}/g, "…");
  // 将非小数点的 "." 替换为中文句号，避免读出 "dot"
  cleaned = cleaned.replace(/\./g, (match, offset, str) => {
    const prev = offset > 0 ? str[offset - 1] : "";
    const next = offset < str.length - 1 ? str[offset + 1] : "";
    const isDecimalPoint = /\d/.test(prev) && /\d/.test(next);
    return isDecimalPoint ? "." : "。";
  });
  return cleaned;
}

// 配置 marked 选项（只执行一次，提升性能）
marked.setOptions({
  // 启用 GFM，并让单个换行符也被当作 <br> 处理
  gfm: true,
  breaks: true,
  headerIds: true,
  mangle: false,
  headerPrefix: "",
  sanitize: false,
  smartLists: true,
  xhtml: true,
});

// 处理 Markdown（保留基础 Markdown 加粗/斜体/标题/换行等）
const renderMath = (text) => {
  try {
    let safeText = typeof text === "string" ? text : String(text ?? "");

    // 把字符串里的 `\n` 和真正的换行，都统一成换行符，方便 marked 处理为 <br> 或新段落
    safeText = safeText.replace(/\\n/g, "\n");

    // 避免 $$\n 被错误拆行
    safeText = safeText.replace(/\$\$\n/g, "$$");

    // 转义下划线，防止被解析为 Markdown 斜体语法
    // marked 会将单个下划线 _text_ 解析为斜体 <em>，我们需要转义这些下划线
    // 但保留双下划线 __text__（粗体）和已转义的下划线 \_
    // 匹配单个下划线（前面不是反斜杠，后面不是下划线）
    safeText = safeText.replace(/([^\\])_(?!_)/g, "$1\\_");
    // 处理行首的单个下划线
    safeText = safeText.replace(/^_(?!_)/gm, "\\_");

    const html = marked.parse(safeText);

    // 将删除线标签改为下划线标签
    // 将 <del> 和 <s> 标签替换为 <u> 标签，使删除线显示为下划线
    let finalHtml = html.replace(/<del>/g, "<u>").replace(/<\/del>/g, "</u>");
    finalHtml = finalHtml.replace(/<s>/g, "<u>").replace(/<\/s>/g, "</u>");

    return `<div class="ai-message-box markdown-body">${finalHtml}</div>`;
  } catch (e) {
    // 兜底：出错时至少返回原始文本
    return `<div class="ai-message-box markdown-body">${text || ""}</div>`;
  }
};

// 从可能被 JSON 包裹的文本中提取实际内容（避免 {"content":"从","role":"assistant"} 等直接显示）
function extractContentFromChunk(text) {
  if (!text || typeof text !== "string") return text;
  const trimmed = text.trim();
  // 若文本形如 {"content":"xxx","role":"assistant"}，解析并提取 content
  if (
    (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
    (trimmed.startsWith("[") && trimmed.endsWith("]"))
  ) {
    try {
      const obj = JSON.parse(trimmed);
      if (obj && typeof obj === "object" && obj.content != null) {
        const inner = String(obj.content);
        // 递归：若 content 本身仍是 JSON 字符串（嵌套），继续提取
        const innerTrimmed = inner.trim();
        if (
          (innerTrimmed.startsWith("{") && innerTrimmed.endsWith("}")) ||
          (innerTrimmed.startsWith("[") && innerTrimmed.endsWith("]"))
        ) {
          return extractContentFromChunk(inner);
        }
        return inner;
      }
    } catch (e) {
      // JSON 解析失败时（如非标准格式），尝试用正则提取 "content":"xxx" 避免整段 JSON 被渲染
      const contentMatch = trimmed.match(/"content"\s*:\s*"((?:[^"\\]|\\.)*)"/);
      if (contentMatch) {
        const unescaped = contentMatch[1].replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        return extractContentFromChunk(unescaped);
      }
    }
  }
  return text;
}

// 将文本累加到渲染缓冲区（流式文本到达时调用）
function addTextToRenderQueue(text, messageIndex) {

  if (!text || !text.trim()) {
    return;
  }

  // 确保消息索引有效
  if (messageIndex === -1 || !chatList.value[messageIndex]) {
    return;
  }

  // 如果当前没有在渲染，或者切换到了新的消息，重置渲染状态
  if (currentRenderingMessageIndex !== messageIndex) {
    // ✅ 先 flush 旧消息的剩余文本，避免切换后旧消息内容不完整
    if (currentRenderingMessageIndex >= 0 && accumulatedText.length > renderedTextLength) {
      flushTextRendering(currentRenderingMessageIndex, true);
    }
    // 停止之前的渲染
    stopTextRendering();
    // 重置当前消息的渲染状态
    currentRenderingMessageIndex = messageIndex;
    accumulatedText = "";
    renderedTextLength = 0;
    // 如果消息已有内容，从已有内容开始（避免重复渲染）
    // 注意：这里需要确保消息的 content 和 renderedTextLength 同步
    if (chatList.value[messageIndex] && chatList.value[messageIndex].content) {
      const existingContent = chatList.value[messageIndex].content;
      accumulatedText = existingContent;
      renderedTextLength = existingContent.length;
    } else {
      // 确保消息的 content 是空的
      if (chatList.value[messageIndex]) {
        chatList.value[messageIndex].content = "";
      }
    }
  }

  // 直接将新文本累加到缓冲区（不拆分字符，不影响渲染速度）
  accumulatedText += text;


  // 如果渲染定时器未启动，启动它
  if (!textRenderTimer) {
    startTextRendering(messageIndex);
    // 验证定时器是否真的启动了
    if (!textRenderTimer) {
    }
  } else {
    // 定时器已运行，确保它能检测到新文本
    // 验证定时器确实在运行（双重检查）
    if (!textRenderTimer || currentRenderingMessageIndex !== messageIndex) {
      startTextRendering(messageIndex);
    }
  }
}

// 启动文本逐字符渲染（从累加的文本中按固定速度渲染）
function startTextRendering(messageIndex) {
  // 如果已经有定时器在运行，且是同一个消息，不需要重新启动
  if (textRenderTimer && currentRenderingMessageIndex === messageIndex) {
    return; // 已经在渲染中
  }

  // 如果有定时器但消息不同，先停止旧的定时器
  if (textRenderTimer) {
    clearInterval(textRenderTimer);
    textRenderTimer = null;
  }

  // 确保 currentRenderingMessageIndex 已设置
  if (
    currentRenderingMessageIndex === -1 ||
    currentRenderingMessageIndex !== messageIndex
  ) {
    currentRenderingMessageIndex = messageIndex;
  }

  // 渲染单个字符的辅助函数
  const renderNextChar = () => {
    // 使用 currentRenderingMessageIndex 而不是闭包中的 messageIndex（避免闭包问题）
    const currentIndex = currentRenderingMessageIndex;
    if (currentIndex === -1 || !chatList.value[currentIndex]) {
      // 如果消息索引无效，停止渲染
      stopTextRendering();
      return;
    }

    // 检查是否还有未渲染的字符
    if (renderedTextLength >= accumulatedText.length) {
      // ✅ 暂时追上：只停止定时器，保留 currentRenderingMessageIndex，以便同消息后续 chunk 到达时能继续渲染
      stopTextRendering(false);
      
      // 如果是手动暂停音频，开启录音
      if (isManualStopAudioOnly) {
        isManualStopAudioOnly = false;
        
        // 文本输出完成，设置 isResponding = false
        isResponding.value = false;
      }
      return;
    }

    // 从累加的文本中取出下一个字符并渲染
    const char = accumulatedText[renderedTextLength];
    renderedTextLength++;

    // 更新消息内容（直接拼接字符）
    // 确保 content 初始化为空字符串（如果还没有）
    if (!chatList.value[currentIndex].content) {
      chatList.value[currentIndex].content = "";
    }

    // 检查当前 content 的长度是否与 renderedTextLength 一致，避免重复追加
    const currentContentLength = chatList.value[currentIndex].content.length;
    if (currentContentLength < renderedTextLength - 1) {
      // 正常情况：content 长度小于已渲染长度-1，说明有缺失，补齐
      const missingPart = accumulatedText.substring(
        currentContentLength,
        renderedTextLength
      );
      chatList.value[currentIndex].content += missingPart;
    } else if (currentContentLength === renderedTextLength - 1) {
      // 正常情况：content 长度等于已渲染长度-1，追加新字符
      chatList.value[currentIndex].content += char;
    } else if (currentContentLength === renderedTextLength) {
      // 已经同步，但需要追加新字符（这种情况不应该发生，但作为保护）
      chatList.value[currentIndex].content += char;

    } else {
      // 异常情况：content 长度大于已渲染长度，说明可能有重复，重新同步
      // 重新同步：将 content 设置为已渲染的部分（包括新字符）
      const expectedContent = accumulatedText.substring(0, renderedTextLength);
      chatList.value[currentIndex].content = expectedContent;
    }

    // 更新 renderedContent（使用当前完整的 content）
    chatList.value[currentIndex].renderedContent = renderMath(
      chatList.value[currentIndex].content
    );

    // 自动滚动到底部
    nextTick(() => {
      scrollBoxToBottom();
    });
  };

  // 立即执行第一次渲染，避免等待第一个间隔（确保立即开始渲染）
  if (renderedTextLength < accumulatedText.length) {
    renderNextChar();
  }

  // 启动定时器，继续渲染后续字符
  textRenderTimer = setInterval(() => {
    renderNextChar();
  }, TEXT_RENDER_INTERVAL);

}

// 停止文本渲染
// clearCurrentMessage: 为 true 时重置 currentRenderingMessageIndex（切换/清理时）；为 false 时保留（仅暂停定时器，后续同消息新 chunk 可继续渲染）
function stopTextRendering(clearCurrentMessage = true) {
  if (textRenderTimer) {
    clearInterval(textRenderTimer);
    textRenderTimer = null;
  }
  if (clearCurrentMessage) {
    currentRenderingMessageIndex = -1;
  }
}

// 立即完成当前消息的文本渲染（用于流式结束或需要立即显示完整文本时）
// forceFlush: 为 true 时跳过 currentRenderingMessageIndex 校验，强制更新指定消息（平板 setInterval 节流时使用）
function flushTextRendering(messageIndex, forceFlush = false) {
  if (!forceFlush && currentRenderingMessageIndex !== messageIndex) {
    return;
  }

  // 停止定时器
  stopTextRendering();

  // 立即渲染剩余的所有文本
  if (
    renderedTextLength < accumulatedText.length &&
    chatList.value[messageIndex]
  ) {
    const remainingText = accumulatedText.substring(renderedTextLength);

    if (chatList.value[messageIndex].content) {
      chatList.value[messageIndex].content += remainingText;
    } else {
      chatList.value[messageIndex].content = remainingText;
    }
    renderedTextLength = accumulatedText.length;

    // 更新 renderedContent
    chatList.value[messageIndex].renderedContent = renderMath(
      chatList.value[messageIndex].content
    );

    // 自动滚动到底部
    nextTick(() => {
      scrollBoxToBottom();
    });

    // 清空累加文本（渲染完成）
    accumulatedText = "";
    renderedTextLength = 0;
    
    if (isManualStopAudioOnly) {
      isManualStopAudioOnly = false;
      isResponding.value = false;
    }
  } else {
    if (isManualStopAudioOnly && !textRenderTimer) {
      isManualStopAudioOnly = false;
      isResponding.value = false;
    }
  }
}

async function initFFmpeg() {
  if (ffmpeg || isFFmpegLoaded) {
    return;
  }

  try {
    ffmpeg = new FFmpeg();
    ffmpeg.on("log", ({ message }) => {
      // 可以在这里处理日志，如果需要的话
    });
    await ffmpeg.load();
    isFFmpegLoaded = true;
  } catch (error) {
    // 加载失败不影响主流程，只是无法裁剪静音帧
    isFFmpegLoaded = false;
  }
}

async function trimSilence(audioBlob) {
  if (!ENABLE_SILENCE_TRIM || !isFFmpegLoaded || !ffmpeg) {
    return audioBlob;
  }

  try {
    const isOpus = audioBlob.type.includes("opus");
    const inputExt = isOpus ? "opus" : "mp3";
    const outputExt = isOpus ? "opus" : "mp3";
    const inputFileName = `input.${inputExt}`;
    const outputFileName = `output.${outputExt}`;

    const fileData = await fetchFile(audioBlob);
    ffmpeg.FS("writeFile", inputFileName, fileData);

    const ffmpegArgs = [
      "-i",
      inputFileName,
      "-af",
      "silencetrim=start_periods=1:start_duration=0.1:start_threshold=0.02:end_periods=1:end_duration=0.1:end_threshold=0.02",
    ];

    if (isOpus) {
      ffmpegArgs.push("-c:a", "libopus", "-b:a", "64k");
    } else {
      ffmpegArgs.push("-c:a", "libmp3lame", "-b:a", "64k");
    }

    ffmpegArgs.push(outputFileName);

    await ffmpeg.run(...ffmpegArgs);

    const outputData = ffmpeg.FS("readFile", outputFileName);

    try {
      ffmpeg.FS("unlink", inputFileName);
      ffmpeg.FS("unlink", outputFileName);
    } catch (e) {
      // ignore
    }

    const trimmedBlob = new Blob([outputData.buffer], { type: audioBlob.type });
    const sizeReduction = (
      (1 - trimmedBlob.size / audioBlob.size) *
      100
    ).toFixed(1);

    return trimmedBlob;
  } catch (error) {
    return audioBlob;
  }
}

async function handleStartSession() {
  // ✅ 新增：检查对话是否已结束
  if (isDialogueEnded.value) {
    showToast({
      message: "对话已结束，请创建新对话",
      type: "fail",
    });
    return;
  }
  
  // ✅ 优化：如果正在播放音频，不允许录音（等待音频播放完成）
  if (
    isPlayingAudio ||
    audioQueueLengthRef.value > 0
  ) {
    showToast({ message: "音频播放中，请等待播放完成", type: "fail" });
    return;
  }

  // 开始录音前，打断之前的音频和文本输出
  interruptAudioAndText();

  if (!currentChatId.value) {
    await newDialogue(planId.value ? planId.value : tutoringId.value);
    if (!currentChatId.value) {
      errorMsg.value = "对话创建失败，请稍后重试";
      return;
    }
    return;
  }

  shouldSaveRecording = true;
  // 注意：录音使用 persistentAudioContext，不需要 ensureWebAudioContext
  await initRecording();
}

async function initRecording() {
  // ✅ 新增：检查对话是否已结束
  if (isDialogueEnded.value) {
    showToast({
      message: "对话已结束，请创建新对话",
      type: "fail",
    });
    return;
  }
  
  // ✅ 新增：检查是否已经在录音中，避免重复初始化
  if (isInSession.value && mediaRecorder && mediaRecorder.state === "recording") {
    return;
  }

  const hasPermission = await requestMicrophonePermission();
  if (hasPermission) {
    await startRecording();
  }
}

function stopAIAudioPlayback() {
  // ✅ 统一使用 cleanupAudioPlayback 彻底清理（finish 会话、关闭 Web Audio、清空队列等），保持 TTS 长连接
  cleanupAudioPlayback();
  updateAudioStateRefs();
  setPlayingAudioState(false);
}

// 暂停并强制切断当前音频/请求/TTS连接（后续由用户重新发起）
let isStoppingAudio = false; // 防止重复调用
let isManualStop = false; // ✅ 标记是否是手动停止（用于避免 setPlayingAudioState 中的自动录音逻辑冲突）
let isManualStopAudioOnly = false; // ✅ 新增：标记是否是手动暂停音频（只停止音频，文本继续输出）
let lastPauseTime = 0; // ✅ 暂停时间戳，用于拒绝 base64 回调中延迟到达的旧音频
function clearManualStopFlags() {
  isManualStop = false;
  isStoppingAudio = false;
}
async function stopAudioOnly() {
  // 防止重复调用
  if (isStoppingAudio) {
    return;
  }
  
  isStoppingAudio = true;
  isManualStop = true;
  // 递增代次：使之前所有流式回调失效
  activeResponseEpoch++;
  invalidateVoiceChain();
  shouldSaveRecording = false; // ✅ 中断时禁止录音 onstop 触发后续语音转文本接口
  lastPauseTime = Date.now(); // ✅ 记录暂停时间，拒绝此后 base64 回调中延迟到达的旧音频
  if (process.env.NODE_ENV === "development") {
    console.log("[AI-Teacher][Abort] stopAudioOnly triggered", {
      hasSpokenStream: !!currentSpokenStream,
      hasMp3ToText: !!currentMp3ToTextAbortController,
      hasThemeChat: !!currentThemeChatAbortController,
      hasTtsWs: !!ttsWsManager,
      chatId: currentChatId.value || "",
      ts: lastPauseTime,
    });
  }

  // ✅ 立即停止动画、清除录音对象（防止播放走通话通道），无继续播放逻辑故直接清空
  stopFrameAnimation();
  clearRecordingObject();

  try {
    // ✅ 统一处理：停止所有正在进行的请求和音频播放
    
    // 1. 强制中断当前流式请求（不保留恢复）
    if (currentSpokenStream) {
      if (process.env.NODE_ENV === "development") {
        console.log("[AI-Teacher][Abort] spoken/chat/completions -> abort()");
      }
      try {
        if (typeof currentSpokenStream.abort === "function") {
          currentSpokenStream.abort();
        }
      } catch (e) {
      }
      currentSpokenStream = null;
    }
    
    // 2. 停止文本转音频流
    if (currentTextToAudioStream) {
      try {
        if (typeof currentTextToAudioStream.abort === "function") {
          currentTextToAudioStream.abort();
        }
      } catch (e) {
      }
      currentTextToAudioStream = null;
    }
    
    // 3. 清除接口超时定时器，避免暂停后残留超时回调
    if (apiTimeoutTimer) {
      clearTimeout(apiTimeoutTimer);
      apiTimeoutTimer = null;
    }
    // 3.1 强制中断主题对话请求
    abortThemeChatRequest();
    removeEmptyAiLoadingMessages();
    
    // 4. 清除15秒闲置提示定时器，防止定时器到期后自动播放提示音频
    clearNoActionTimer();
    // 5. 强制关闭 TTS 连接，彻底切断暂停前会话（不做恢复）
    if (ttsWsManager) {
      try {
        if (ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
          await ttsWsManager.finish();
        }
      } catch (e) {
      }
      try {
        ttsWsManager.close();
      } catch (e) {
      }
      ttsWsManager = null;
    }
    
    // 6. 清空TTS发送队列（确保后续重新发起是全新链路）
    ttsSendQueue = [];
    isTtsSending = false;
    shouldAutoSendInitialMessages = false;
    
    // 7. 重置响应状态和文本转音频状态
    isResponding.value = false;
    isTtsTextAllSent.value = false;
    clearAiLoadingStates();
    isConvertingTextToAudio = false;
    processedTextLength = 0;
    textToAudioRecordIds = [];
    
    // 8. 停止文本渲染
    stopTextRendering();
    
    // 9. 停止并清空当前文本渲染状态（中断后不继续输出文本）
    currentRenderingMessageIndex = -1;
    accumulatedText = "";
    renderedTextLength = 0;
    
    // ✅ 关键：重置 currentAiMessageIndex，阻止 addAudioChunkToSentence 继续处理音频碎片
    currentAiMessageIndex = -1;

    // 10. 停止队列监控，防止 200ms 轮询在暂停后再次触发播放
    stopQueueMonitor();
    // 11. 停止音频播放并清空音频资源
    stopAIAudioPlayback();

    // 清理音频相关定时器
    if (audioFinishTimer) {
      clearTimeout(audioFinishTimer);
      audioFinishTimer = null;
    }
    if (audioReceiveTimeoutTimer) {
      clearTimeout(audioReceiveTimeoutTimer);
      audioReceiveTimeoutTimer = null;
    }
    if (template17AudioTimeoutTimer) {
      clearTimeout(template17AudioTimeoutTimer);
      template17AudioTimeoutTimer = null;
    }
    // 12. 更新音频状态引用
    updateAudioStateRefs();
    setPlayingAudioState(false);

    // 使用 nextTick 确保状态更新后视图立即刷新
    await nextTick();

  } catch (error) {
  } finally {
    // ✅ 防御性兜底：暂停完成后强制解除播放阻塞，避免长按录音被误判为“仍在播放”
    isPlayingAudio = false;
    isAudioPlayingBlock = false;
    pendingMergeCount = 0;
    pendingAudioBlobs = [];
    audioQueue = [];
    updateAudioStateRefs();
    updatePlaybackStatus();

    // 只结束“处理中”态，不自动解除手动中断标记；
    // 由用户下一次主动操作时 clearManualStopFlags() 解锁
    isStoppingAudio = false;
    removeEmptyAiLoadingMessages();
  }
}

// 长按录音相关变量
let micPressTimer = null;
let micPreInitTimer = null; // 50ms 提前初始化定时器
let isMicPressing = false;
let shouldReloadRecordingWhenIdle = false; // 播放中延迟重建麦克风，避免音频通道瞬断

// 长按开始录音
const handleMicPressStart = async (event) => {
  clearManualStopFlags();
  event?.stopPropagation();

  // ✅ 防御性兜底：若实际已无音频，清掉残留播放阻塞标记，确保可长按录音
  if (!isPlayingAudio && audioQueue.length === 0 && pendingMergeCount === 0 && pendingAudioBlobs.length === 0) {
    isAudioPlayingBlock = false;
    updateAudioStateRefs();
  }
  
  // ✅ 五轮结束后点击录音，弹窗确认是否开始新对话
  if (isDialogueEnded.value) {
    pendingDialogueEndedRecord.value = true;
    showSwitchConfirmDialog.value = true;
    return;
  }
  
  // 如果正在录音，不处理
  if (isInSession.value) {
    return;
  }

  // ✅ 平板修复：在首次 await 之前立即初始化麦克风，确保 getUserMedia 在用户手势上下文中调用
  // 平板端若在 await 之后调用，用户手势可能已失效，导致暂停后长按录音无声音
  isMicPressing = true;
  if (!microphoneInitialized) {
    initMicrophoneStream().catch(() => {});
  }

  // 延迟再次检查，避免异步竞态导致状态误判
  await nextTick();

  // ✅ 用户长按录音时清除15秒定时器（播放结束后才重新开始计时）
  clearNoActionTimer();
  
  // ✅ 修复：仅在确认长按（100ms后）再打断，避免轻触就中断流式文本和 TTS
  micPressTimer = setTimeout(async () => {
    // ✅ 修复：在开始录音前再次检查 isMicPressing，如果用户已经松开则不开始录音
    if (!isMicPressing) {
      return;
    }
    
    if (!currentChatId.value) {
      await newDialogue(planId.value ? planId.value : tutoringId.value);
      if (!currentChatId.value) {
        isMicPressing = false;
        return;
      }
      // ✅ 修复：对话创建后再次检查 isMicPressing
      if (!isMicPressing) {
        return;
      }
    }
    
    // 如果麦克风还未初始化，立即初始化（若正在初始化则等待完成，不提示用户）
    if (!microphoneInitialized) {
      try {
        await initMicrophoneStream();
        // ✅ 修复：初始化麦克风后再次检查 isMicPressing
        if (!isMicPressing) {
          return;
        }
      } catch (err) {
        isMicPressing = false;
        return;
      }
    }
    
    // ✅ 修复：在调用 initRecording 前最后一次检查 isMicPressing
    if (!isMicPressing) {
      return;
    }
    
    // 确认长按后才打断音频和文本（避免轻触就中断流式输出）
    interruptAudioAndText();
    
    shouldSaveRecording = true;
    await initRecording().catch((err) => {
      isMicPressing = false;
    });
  }, 100); // 100ms 延迟，避免误触
};

// 长按结束，停止录音
const handleMicPressEnd = async (event) => {
  event?.stopPropagation();
  
  // 清除定时器，防止录音开始
  if (micPressTimer) {
    clearTimeout(micPressTimer);
    micPressTimer = null;
  }
  if (micPreInitTimer) {
    clearTimeout(micPreInitTimer);
    micPreInitTimer = null;
  }
  
  // 设置标志，表示用户已经松开，不应该继续录音
  isMicPressing = false;
  
  // 如果正在录音，立即停止录音
  if (isInSession.value) {
    stopRecording();
    return;
  }
  
  // ✅ 修复：即使录音还没开始（isInSession 还是 false），也要等待一小段时间
  // 因为 initRecording 是异步的，可能在 handleMicPressEnd 之后才设置 isInSession
  // 等待最多 500ms，检查录音是否开始，如果开始了就停止
  let checkCount = 0;
  const maxChecks = 10; // 检查10次，每次50ms，总共500ms
  const checkInterval = setInterval(() => {
    checkCount++;
    if (isInSession.value) {
      stopRecording();
      clearInterval(checkInterval);
    } else if (checkCount >= maxChecks) {
      // 500ms 后如果还没开始录音，说明录音不会开始了，清除定时器
      clearInterval(checkInterval);
    }
  }, 50);
};

async function toggleRecording() {
  if (!currentChatId.value) {
    await newDialogue(planId.value ? planId.value : tutoringId.value);
    if (!currentChatId.value) {
      return;
    }
    return;
  }

  if (isInSession.value) {
    stopRecording();
    return;
  }

  // ✅ 优化：如果正在播放音频，不允许录音（等待音频播放完成）
  if (
    isPlayingAudio ||
    audioQueueLengthRef.value > 0
  ) {
    showToast({ message: "音频播放中，请等待播放完成", type: "fail" });
    return;
  }

  // ✅ 录音仅支持长按启用，点击不开启录音
  showToast({ message: "请长按麦克风按钮开始录音", type: "fail" });
}

async function startRecording() {
  try {
    // 停止自动监听
    stopAutoVolumeMonitoring();

    // ✅ 优化：复用已初始化的音频流，避免每次重新初始化导致丢失前几秒内容
    let stream = persistentRecordingStream;

    // ✅ 修复：只在流真正失效时才重新初始化，不要因为 audioChunks 为空就重新初始化
    const needsReinit = !stream || 
      stream.getTracks().some((track) => track.readyState === "ended");
    
    if (needsReinit) {
      
      // ✅ 先关闭已有录音对象，再创建新的（避免残留旧流）
      clearRecordingObject();
      
      // 获取新的音频流
      stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          sampleRate: 16000,
          channelCount: 1,
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
          // ✅ 修复：禁用监听音频（monitoring），避免产生无法控制的音频输出
          // 在某些设备上，录音流可能会产生监听音频，这里明确禁用
          suppressLocalAudioPlayback: true, // 禁用本地音频播放（如果支持）
        },
      });
      persistentRecordingStream = stream;

      // 重新初始化持久化的音频上下文和分析器（用于音量检测）
      if (persistentAudioContext && persistentAudioContext.state !== "closed") {
        try {
          persistentAudioContext.close().catch(() => {});
        } catch (e) {
          // ignore
        }
      }
      // ✅ 修复：明确指定 AudioContext 为播放模式，避免被识别为通话应用
      // latencyHint: "playback" 表示用于播放，不是实时交互（通话）
      persistentAudioContext = new (window.AudioContext ||
        window.webkitAudioContext)({
        latencyHint: "playback", // 播放模式，使用媒体音量通道
      });
      persistentAnalyser = persistentAudioContext.createAnalyser();
      persistentAnalyser.fftSize = 256;
      const source = persistentAudioContext.createMediaStreamSource(stream);
      // ✅ 修复：只连接到分析器，不连接到destination（避免产生监听音频）
      source.connect(persistentAnalyser);
      // ✅ 平板修复：移动端 AudioContext 常为 suspended，需 resume 后波形/音量检测才有数据
      if (persistentAudioContext.state === "suspended") {
        persistentAudioContext.resume().catch(() => {});
      }
      // ✅ 修复：确保不连接到destination，避免产生监听音频输出
      // 不连接 source 到 destination，只用于音量检测
      microphoneInitialized = true; // clearRecordingObject 已置为 false，此处恢复
    } else {
      // ✅ 复用流时也要确保 AudioContext 已恢复（可能在上次使用后被浏览器挂起）
      if (persistentAudioContext && persistentAudioContext.state === "suspended") {
        await persistentAudioContext.resume();
      }
    }

    recordingStream = stream; // 临时引用，用于兼容现有代码

    // ✅ 录音会切换系统到通话音量通道，标记需在下次 TTS 播放前重新激活媒体通道
    mediaChannelActivated = false;
    needsMediaChannelReactivationAfterRecord = true; // 录音后首次播放时强制激活，解决音量不可控
    
    // ✅ 关键修复：在开始新录音前，强制清空之前的录音数据
    // 确保每次录音都是全新的，不会累积之前的数据
    if (audioChunks.length > 0) {
    }
    audioChunks = [];
    
    isInSession.value = true;
    // ✅ 新增：录音真正开始时，设置 isResponding = false，显示录音状态
    isResponding.value = false;
    errorMsg.value = "";
    lastVoiceTime = Date.now();

    // ✅ 新增：验证流的有效性
    const tracks = stream.getTracks();
    if (tracks.length === 0) {
      isInSession.value = false;
      errorMsg.value = "录音流无效，请刷新页面重试";
      return;
    }
    
    const hasLiveTrack = tracks.some(track => track.readyState === "live");
    if (!hasLiveTrack) {
      isInSession.value = false;
      errorMsg.value = "录音流未激活，请刷新页面重试";
      return;
    }
    

    // ✅ 优化：每次录音时创建新的 MediaRecorder（因为 stop 后不能复用）
    // 但使用已存在的 stream，这样不会丢失前几秒内容
    try {
    mediaRecorder = new MediaRecorder(stream, {
      mimeType: "audio/webm;codecs=opus",
    });
    } catch (e) {
      isInSession.value = false;
      errorMsg.value = "录音器创建失败，请刷新页面重试";
      return;
    }

    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        audioChunks.push(event.data);
      } else {
      }
    };

    mediaRecorder.onstop = async () => {

      // ✅ 录音结束后立即销毁录音对象，退出通话通道
      forceReleaseRecordingStreamForPlayback();

      // ✅ 延迟 200ms 后主动激活媒体通道，让系统完成从通话模式到媒体模式的切换
      setTimeout(() => {
        ensureMediaChannelActive(true).catch(() => {});
      }, 200);

      stopVolumeCheck();

      let audioBlob = null;
      if (audioChunks.length > 0) {
        audioBlob = new Blob(audioChunks, { type: "audio/webm" });
      } else {
      }

      // 清空临时引用；麦克风流在 releaseRecordingStreamWhenIdle 中释放（约 300ms 后）
      recordingStream = null;

      // ✅ 修复：不要强制设置 shouldSaveRecording，尊重调用者的意图
      // 如果 shouldSaveRecording 为 false，说明是被动停止（如音频播放打断），不应该保存

      if (audioBlob && audioBlob.size > 0 && shouldSaveRecording) {
        // ✅ 用户主动发送：转换音频格式并调用语音转文本接口
        try {
          // 转换为符合腾讯云要求的格式：16k采样率、16bit、单声道
          const convertedBase64 = await convertAudioToWav16k(audioBlob);
          // ✅ 关键：在调用接口前先清空 audioChunks，确保下次录音是全新的
          audioChunks = [];
          // ✅ 录音对象已在 onstop 开头立即销毁
          await handleVoiceToTextAndSend(convertedBase64);
        } catch (error) {
          errorMsg.value = "录音数据处理失败";
          isInSession.value = false;
          // ✅ 即使处理失败，也要清空 audioChunks
          audioChunks = [];
          // ✅ 重置 shouldSaveRecording 为 true，为下次录音做准备
          shouldSaveRecording = true;
          // ✅ 重置发送按钮状态
          isSendButtonProcessing.value = false;
          
        }
      } else if (!shouldSaveRecording) {
        // ✅ 被动停止（如 AI 音频打断）：直接清空数据，不发送到接口
        audioChunks = [];
        isInSession.value = false;
        // ✅ 重置 shouldSaveRecording 为 true，为下次录音做准备
        shouldSaveRecording = true;
        // ✅ 重置发送按钮状态
        isSendButtonProcessing.value = false;
      } else {
        // ✅ 录音数据为空：清空并提示
        errorMsg.value = "录音数据为空，请重新录音";
        audioChunks = [];
        isInSession.value = false;
        // ✅ 重置 shouldSaveRecording 为 true，为下次录音做准备
        shouldSaveRecording = true;
        // ✅ 重置发送按钮状态
        isSendButtonProcessing.value = false;

      }

      // ✅ 注意：audioChunks 已在上面各个分支中清空，这里不需要再清空
      // ✅ 只在录音被取消时重置 shouldSaveRecording，其他情况在上面已经处理
    };

    // ✅ 修改：设置 timeslice 参数，每500ms触发一次 ondataavailable
    // 这样可以确保即使录音时间很短，也能收集到数据
    mediaRecorder.start(500); // 每500ms触发一次 ondataavailable
    startVolumeCheck(stream);
    // ✅ 启动波浪前确保 AudioContext 已运行（解决平板/移动端波形不跳动）
    if (persistentAudioContext && persistentAudioContext.state === "suspended") {
      await persistentAudioContext.resume();
    }
    // 注：不在此处 resume webAudioTtsContext，否则会继续播放暂停前已调度的 buffer，导致「点录音后播放一小段」
    // 启动波浪可视化
    nextTick(() => {
      startRecordingWaveVisualization(stream);
    });
  } catch (error) {
    errorMsg.value = "录音启动失败";
    isInSession.value = false;
    // ✅ 优化：不销毁持久化流，只清空临时引用
    recordingStream = null;
  }
}

let recordingStartTime = 0; // 录音开始时间（用于最大时长限制）

function startVolumeCheck(stream) {
  stopVolumeCheck();

  try {
    // ✅ 优化：优先使用持久化的音频上下文和分析器
    if (
      persistentAudioContext &&
      persistentAnalyser &&
      persistentRecordingStream === stream
    ) {
      audioContext = persistentAudioContext;
      analyser = persistentAnalyser;
    } else {
      // 如果没有持久化的，创建新的（兼容旧逻辑）
      // ✅ 修复：明确指定为播放模式，避免被识别为通话应用
      audioContext = new (window.AudioContext || window.webkitAudioContext)({
        latencyHint: "playback", // 播放模式，使用媒体音量通道
      });
      analyser = audioContext.createAnalyser();
      analyser.fftSize = 256;
      const source = audioContext.createMediaStreamSource(stream);
      source.connect(analyser);
    }

    // 记录录音开始时间
    recordingStartTime = Date.now();

    volumeCheckTimer = setInterval(() => {
      if (!analyser || !isInSession.value) {
        return;
      }

      const dataArray = new Uint8Array(analyser.frequencyBinCount);
      analyser.getByteFrequencyData(dataArray);
      const average =
        dataArray.reduce((sum, val) => sum + val, 0) / dataArray.length;
      const volume = average / 255;

      const currentThreshold = isPlayingAudio
        ? VOICE_THRESHOLD_WHEN_PLAYING
        : SILENCE_THRESHOLD;

      const now = Date.now();

      if (volume > currentThreshold) {
        lastVoiceTime = Date.now();
        if (silenceTimer) {
          clearTimeout(silenceTimer);
          silenceTimer = null;
        }
        if (isPlayingAudio) {
          /* 播放中检测到音量，仅更新 lastVoiceTime */
        }
      }
    }, VOLUME_CHECK_INTERVAL);

  } catch (error) {
  }
}

function stopVolumeCheck() {
  if (volumeCheckTimer) {
    clearInterval(volumeCheckTimer);
    volumeCheckTimer = null;
  }

  if (silenceTimer) {
    clearTimeout(silenceTimer);
    silenceTimer = null;
  }

  if (analyser) {
    analyser = null;
  }

  if (audioContext && audioContext.state !== "closed") {
    audioContext.close().catch(() => {});
    audioContext = null;
  }

  lastVoiceTime = 0;
}

// 启动录音波浪可视化
function startRecordingWaveVisualization(stream) {
  if (!recordingWaveCanvas.value) {
    setTimeout(() => {
      if (recordingWaveCanvas.value && isInSession.value) {
        startRecordingWaveVisualization(stream);
      }
    }, 100);
    return;
  }

  try {
    const canvas = recordingWaveCanvas.value;
    const displayWidth = 253;
    const displayHeight = 100;
    const pixelRatio = Math.max(2, window.devicePixelRatio || 1);
    
    canvas.width = displayWidth * pixelRatio;
    canvas.height = displayHeight * pixelRatio;
    canvas.style.width = `${displayWidth}px`;
    canvas.style.height = `${displayHeight}px`;
    
    const ctx = canvas.getContext("2d", { 
      alpha: true,
      desynchronized: false 
    });
    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    // ✅ 波形重试：每次启动时重置
    recordingWaveformStartTime = 0;
    recordingWaveformResumeRetryDone = false;

    // 使用持久化的分析器
    if (persistentAnalyser) {
      recordingWaveAnalyser = persistentAnalyser;
      // ✅ 平板修复：AudioContext 在移动端常为 suspended，需 resume 后 Analyser 才有实时数据
      const ctx = persistentAudioContext;
      if (ctx && ctx.state === "suspended") {
        ctx.resume().then(() => {
          nextTick(() => drawRecordingWaveform());
        }).catch((e) => {
          nextTick(() => drawRecordingWaveform());
        });
      } else {
        nextTick(() => drawRecordingWaveform());
      }
      // 注：不在此处 resume webAudioTtsContext，否则会继续播放暂停前已调度的 buffer
    } else {
      // 如果没有持久化的，创建新的
      // ✅ 修复：明确指定为播放模式，避免被识别为通话应用
      recordingWaveAudioContext = new (window.AudioContext || window.webkitAudioContext)({
        latencyHint: "playback", // 播放模式，使用媒体音量通道
      });
      recordingWaveAnalyser = recordingWaveAudioContext.createAnalyser();
      recordingWaveAnalyser.fftSize = 256;
      recordingWaveAnalyser.smoothingTimeConstant = 0.8;
      const source = recordingWaveAudioContext.createMediaStreamSource(stream);
      source.connect(recordingWaveAnalyser);
      // ✅ 平板修复：新建的 AudioContext 在移动端也可能 suspended
      const ctx = recordingWaveAudioContext;
      if (ctx.state === "suspended") {
        ctx.resume().then(() => {
          nextTick(() => drawRecordingWaveform());
        }).catch((e) => {
          nextTick(() => drawRecordingWaveform());
        });
      } else {
        nextTick(() => drawRecordingWaveform());
      }
      // 注：不在此处 resume webAudioTtsContext，否则会继续播放暂停前已调度的 buffer
    }
  } catch (error) {
  }
}

// 绘制录音波浪（参考VoicePop.vue）
function drawRecordingWaveform() {
  if (!recordingWaveCanvas.value || !recordingWaveAnalyser) return;

  const canvas = recordingWaveCanvas.value;
  const ctx = canvas.getContext("2d", { 
    alpha: true,
    desynchronized: false 
  });
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  
  const width = 253;
  const height = 100;
  const bufferLength = recordingWaveAnalyser.frequencyBinCount;
  const dataArray = new Uint8Array(bufferLength);
  const frequencyDataArray = new Uint8Array(bufferLength);
  
  const THICK_LINE_HEIGHT_RATIO = 3 / 5;
  const DEFAULT_SAMPLING_SIZE = 80;
  const DEFAULT_OFFSET_SPEED = 250.0;
  const DEFAULT_SENSIBILITY = 8;
  const DEFAULT_VOLUME = 80;
  
  let samplingSize = DEFAULT_SAMPLING_SIZE;
  let offsetSpeed = DEFAULT_OFFSET_SPEED;
  let sensibility = DEFAULT_SENSIBILITY;
  const BASE_VOLUME = 1;
  let currentVolume = DEFAULT_VOLUME;
  let targetVolume = DEFAULT_VOLUME;
  let perVolume = sensibility * 0.8;
  
  const thickLineWidth = 2;
  const fineLineWidth = 1;
  
  const wavePositions = [0, 0.18, 0.4, 0.6, 0.82, 1];
  
  const getThickColors = () => {
    return [
      'rgba(136, 128, 255, 0.0)',
      'rgba(134, 132, 255, 1.0)',
      'rgba(122, 158, 255, 1.0)',
      'rgba(107, 187, 255, 1.0)',
      'rgba(99, 223, 255, 1.0)',
      'rgba(97, 113, 231, 0.0)'
    ];
  };
  
  const getFineColors = () => {
    return [
      'rgba(136, 128, 255, 0.0)',
      'rgba(134, 132, 255, 1.0)',
      'rgba(122, 158, 255, 1.0)',
      'rgba(107, 187, 255, 1.0)',
      'rgba(99, 223, 255, 1.0)',
      'rgba(97, 113, 231, 0.0)'
    ];
  };
  
  const pathFuncs = [0.8, 0.35, 0.1, -0.1];
  
  let samplingX = [];
  let mapX = [];
  let centerHeight = 0;
  let amplitude = 0;
  let recessionFuncs = new Map();
  let totalOffset = 0;
  let lastTimestamp = 0;
  
  function initSamplingPoints() {
    const displayWidth = 253;
    samplingX = new Array(samplingSize + 1);
    mapX = new Array(samplingSize + 1);
    const gap = displayWidth / samplingSize;
    
    for (let i = 0; i <= samplingSize; i++) {
      const x = i * gap;
      samplingX[i] = x;
      mapX[i] = (x / displayWidth) * 4 - 2;
    }
  }
  
  function calcValue(mapX, offset) {
    const keyX = Math.round(mapX * 1000);
    offset = offset % 2;
    const sinFunc = Math.sin(Math.PI * mapX - offset * Math.PI);
    let recessionFunc;
    
    if (recessionFuncs.has(keyX)) {
      recessionFunc = recessionFuncs.get(keyX);
    } else {
      recessionFunc = 4 / (4 + Math.pow(mapX, 4));
      recessionFuncs.set(keyX, recessionFunc);
    }
    
    return sinFunc * recessionFunc;
  }
  
  function getThickWaveGradient() {
    const colors = getThickColors();
    const gradient = ctx.createLinearGradient(0, 0, width, 0);
    for (let i = 0; i < colors.length; i++) {
      gradient.addColorStop(wavePositions[i], colors[i]);
    }
    return gradient;
  }
  
  function getFineWaveGradient() {
    const colors = getFineColors();
    const gradient = ctx.createLinearGradient(0, 0, width, 0);
    for (let i = 0; i < colors.length; i++) {
      gradient.addColorStop(wavePositions[i], colors[i]);
    }
    return gradient;
  }
  
  function softerChangeVolume() {
    if (currentVolume < targetVolume - perVolume) {
      currentVolume += perVolume * 2;
    } else if (currentVolume > targetVolume + perVolume) {
      currentVolume -= perVolume * 2;
    } else {
      currentVolume = targetVolume;
    }
  }
  
  function initParameters() {
    const displayWidth = 253;
    const displayHeight = 100;
    
    if (displayWidth === 0 || displayHeight === 0) {
      setTimeout(() => {
        if (displayWidth > 0 && displayHeight > 0) {
          initParameters();
        }
      }, 100);
      return;
    }
    
    centerHeight = displayHeight / 2;
    const originalAmplitude = displayHeight / 2;
    amplitude = originalAmplitude * THICK_LINE_HEIGHT_RATIO;
    initSamplingPoints();
    perVolume = sensibility * 0.8;
    totalOffset = 0;
    lastTimestamp = 0;
    currentVolume = DEFAULT_VOLUME;
    targetVolume = DEFAULT_VOLUME;
  }
  
  setTimeout(() => {
    initParameters();
  }, 0);
  
  function draw(timestamp) {
    if (!isInSession.value || !recordingWaveAnalyser) {
      if (recordingWaveAnimationId) {
        cancelAnimationFrame(recordingWaveAnimationId);
        recordingWaveAnimationId = null;
      }
      lastTimestamp = 0;
      return;
    }

    recordingWaveAnimationId = requestAnimationFrame(draw);

    recordingWaveAnalyser.getByteTimeDomainData(dataArray);
    
    if (!lastTimestamp || lastTimestamp === 0) {
      lastTimestamp = timestamp;
    }
    const deltaTime = timestamp - lastTimestamp;
    lastTimestamp = timestamp;
    
    if (deltaTime <= 0 || deltaTime > 1000) {
      return;
    }

    ctx.clearRect(0, 0, width, height);
    
    if (width === 0 || height === 0) return;
    
    totalOffset += deltaTime / offsetSpeed;
    if (totalOffset > 1000) {
      totalOffset = totalOffset % 2;
    }
    const currentOffset = totalOffset;
    
    let volumeSum = 0;
    let maxVolume = 0;
    for (let i = 0; i < bufferLength; i++) {
      const sample = dataArray[i];
      const volume = Math.abs(sample - 128);
      volumeSum += volume;
      if (volume > maxVolume) {
        maxVolume = volume;
      }
    }
    
    const avgVolume = volumeSum / bufferLength;
    const combinedVolume = maxVolume * 0.6 + avgVolume * 0.4;

    // ✅ 波形重试：500ms 内无音量数据时，尝试再次 resume（解决平板/移动端偶尔不跳动）
    if (recordingWaveformStartTime === 0) {
      recordingWaveformStartTime = Date.now();
    }
    const elapsed = Date.now() - recordingWaveformStartTime;
    if (
      !recordingWaveformResumeRetryDone &&
      elapsed > 500 &&
      combinedVolume < 1
    ) {
      recordingWaveformResumeRetryDone = true;
      const ctxToResume = recordingWaveAnalyser === persistentAnalyser
        ? persistentAudioContext
        : recordingWaveAudioContext;
      if (ctxToResume && ctxToResume.state === "suspended") {
        ctxToResume.resume().catch(() => {});
      }
    }
    
    const sensitivityMultiplier = 2.0;
    const calculatedVolume = (combinedVolume / 128) * 100 * sensitivityMultiplier;
    
    const volumeRange = 100 - BASE_VOLUME;
    targetVolume = Math.min(100, BASE_VOLUME + (calculatedVolume > 3 ? calculatedVolume + 50 : calculatedVolume) * (volumeRange / 100));
    
    softerChangeVolume();

    // 绘制细线
    for (let n = 1; n < 4; n++) {
      ctx.beginPath();
      ctx.moveTo(0, centerHeight);
      
      for (let i = 0; i <= samplingSize; i++) {
        const x = samplingX[i];
        const curY = amplitude * calcValue(mapX[i], currentOffset);
        const realY = curY * pathFuncs[n] * (currentVolume / 100);
        ctx.lineTo(x, centerHeight + realY);
      }
      
      ctx.lineWidth = fineLineWidth;
      ctx.strokeStyle = getFineWaveGradient();
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.globalAlpha = 0.55;
      ctx.stroke();
      ctx.globalAlpha = 1;
    }

    // 绘制粗波浪
    ctx.beginPath();
    ctx.moveTo(0, centerHeight);
    
    for (let i = 0; i <= samplingSize; i++) {
      const x = samplingX[i];
      const curY = amplitude * calcValue(mapX[i], currentOffset);
      const realY = curY * pathFuncs[0] * (currentVolume / 100);
      ctx.lineTo(x, centerHeight + realY);
    }
    
    ctx.lineWidth = thickLineWidth;
    ctx.strokeStyle = getThickWaveGradient();
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.stroke();
  }

  draw();
}

// 停止录音波浪可视化
function stopRecordingWaveVisualization() {
  if (recordingWaveAnimationId) {
    cancelAnimationFrame(recordingWaveAnimationId);
    recordingWaveAnimationId = null;
  }

  recordingWaveformStartTime = 0;
  recordingWaveformResumeRetryDone = false;

  if (recordingWaveAudioContext && recordingWaveAudioContext.state !== "closed") {
    recordingWaveAudioContext.close();
    recordingWaveAudioContext = null;
  }

  recordingWaveAnalyser = null;
  
  // 清空canvas
  if (recordingWaveCanvas.value) {
    const ctx = recordingWaveCanvas.value.getContext("2d");
    if (ctx) {
      ctx.clearRect(0, 0, recordingWaveCanvas.value.width, recordingWaveCanvas.value.height);
    }
  }
}

async function handleVoiceToTextAndSend(base64Audio) {
  if (!base64Audio || !currentChatId.value || !aiToken.value) {
    isInSession.value = false;
    isConvertingVoiceToText.value = false;
    // 处理完成后，准备下次录音
    await prepareNextRecording();
    return;
  }
  
  // ✅ 新增：如果是主题对话模式，保存用户音频 base64（用于句子评分）
  if (isThemeChat.value) {
    currentUserAudioBase64 = base64Audio;
  }
  
  // ✅ 新增：检查录音流状态，如果流已失效，重新初始化
  if (persistentRecordingStream) {
    const tracks = persistentRecordingStream.getTracks();
    const hasEndedTrack = tracks.some(track => track.readyState === "ended");
    if (hasEndedTrack) {
      // 清理失效的流
      tracks.forEach(track => {
        try {
          track.stop();
        } catch (e) {
          // ignore
        }
      });
      persistentRecordingStream = null;
      microphoneInitialized = false;
    }
  }

  // ✅ 新增：发送语音时，打断闲置的提示音频
  if (isTipAudioMode || isPlayingTipAudio) {
    stopAIAudioPlayback();
  }


  isConvertingVoiceToText.value = true;
  // 语音转文本过程中，显示"思考中"状态
  isResponding.value = true;

  // 每次语音发送创建唯一链路ID，贯穿“转文本->AI->TTS”
  const voiceChainId = activateVoiceChain("voice");

  try {
    const res = await requestMp3ToText(base64Audio, aiToken.value, voiceChainId);
    if (!isVoiceChainActive(voiceChainId)) {
      return;
    }

    isConvertingVoiceToText.value = false;
    // 注意：不在这里设置 isResponding.value = false，因为后续会调用 sendSpokenMessage，它会继续设置为 true

    if (res.code === 200 && res.data) {
      const userMessage = res.data.trim();
      
      // ✅ 修复：将 reloadRecordingResources 移到 AI 消息发送完成后再执行，避免阻塞或干扰 AI 调用
      // 原逻辑在发送 AI 消息前执行，可能导致 getUserMedia 超时或失败影响后续流程

      if (!userMessage) {
        isInSession.value = false;
        isResponding.value = false;
        await prepareNextRecording();
        return;
      }

      // ✅ 提前异步初始化 TTS（不阻塞主流程），给 TTS 连接争取时间
      initTtsWebSocket().catch((err) => {
      });

      chatList.value.push({
        role: "user",
        content: userMessage,
        renderedContent: renderMath(userMessage),
        errorStatus: undefined, // 初始化，等接口返回后更新
        score: undefined, // 初始化，等评分接口返回后更新
        updateErrorContent: "", // 初始化，等接口返回后更新
        promptContent: "", // 初始化，等接口返回后更新（提示一下弹窗）
        correctedExample: "", // 模板17 纠正弹窗「小小建议」
      });
      
      // 记录用户消息的索引，用于后续更新纠错信息
      const userMessageIndex = chatList.value.length - 1;

      // ✅ 新增：打印主题对话状态，帮助调试

      // ✅ 修复：确保 isThemeChat 状态正确（非模板17时应该是 false）
      // 防止之前是模板17时状态残留，导致非模板17也走主题对话逻辑
      if (promptId.value != 17 && isThemeChat.value) {
        isThemeChat.value = false;
      }

      // ✅ 新增：如果是主题对话模式
      if (isThemeChat.value) {
        // 如果是第一条用户消息，先确认主题
        if (isFirstUserMessage.value) {
          
          // 调用确认主题接口
          const confirmResult = await callConfirmTheme(userMessage);
          
          if (!confirmResult) {
            // ✅ 兜底：确认主题失败时，改用 sendThemeMessage 获取 AI 回复
            try {
              const sendResult = await sendThemeMessage(userMessage);
              if (sendResult) {
                isFirstUserMessage.value = false; // 兜底成功，标记为已确认（纠错字段已由 sendThemeMessage 写回用户消息）
              }
            } catch (fallbackErr) {
            }
            isInSession.value = false;
            isResponding.value = false;
            await prepareNextRecording();
            return;
          }
          
          
          // ✅ 关键修改：根据 returnStatus 判断是否确认成功
          if (confirmResult.returnStatus === 200) {
            isFirstUserMessage.value = false; // 标记已确认主题，下次调用发送消息接口
          } else if (confirmResult.returnStatus === 500) {
            // 不修改 isFirstUserMessage.value，保持为 true，下次仍然调用确认主题接口
          } else {
          }

          // ✅ 新增：把“确认主题”返回的纠错/建议写入当前用户消息
          // 这样每条消息对应的纠正弹窗内容是独立的，不会被后续接口更新覆盖
          if (chatList.value[userMessageIndex]) {
            if (confirmResult.errorStatus !== undefined) {
              chatList.value[userMessageIndex].errorStatus = confirmResult.errorStatus;
            }
            if (confirmResult.updateErrorContent !== undefined) {
              chatList.value[userMessageIndex].updateErrorContent =
                confirmResult.updateErrorContent || "";
            }
            if (confirmResult.promptContent !== undefined) {
              chatList.value[userMessageIndex].promptContent =
                confirmResult.promptContent || "";
            }
            if (confirmResult.correctedExample !== undefined) {
              chatList.value[userMessageIndex].correctedExample =
                confirmResult.correctedExample || "";
            }
          }
          
          // ✅ 处理确认主题返回的 AI 消息（无论 returnStatus 是 200 还是 500 都要显示）
          if (confirmResult.aiTeacherDialogue) {
            
            // 添加 AI 消息到聊天列表
            const aiMessageIndex = chatList.value.length;
            chatList.value.push({
              role: "ai",
              content: "",
              renderedContent: "",
              originalContent: confirmResult.aiTeacherDialogue,
              audioBlobs: [],
            });
            
            // 设置当前正在处理的 AI 消息索引
            currentAiMessageIndex = aiMessageIndex;
            
            // 确保该消息有 audioBlobs 数组
            if (chatList.value[aiMessageIndex] && !chatList.value[aiMessageIndex].audioBlobs) {
              chatList.value[aiMessageIndex].audioBlobs = [];
            }
            
            // 逐字渲染
            nextTick(() => {
              addTextToRenderQueue(confirmResult.aiTeacherDialogue, aiMessageIndex);
            });
            
            // 处理 TTS（使用和其他模板一样的逻辑）
            try {
              // ✅ 模板17 去重：若初始消息已发送过 TTS，且 confirm 返回内容与已有 AI 消息相同，则跳过，避免读两遍
              let shouldSkipTtsForConfirm = false;
              if (promptId.value == 17 && template17InitialSent) {
                const existingAiText = chatList.value
                  .filter((m) => m.role === "ai" && (m.originalContent || m.content))
                  .map((m) => m.originalContent || m.content)
                  .join(" ")
                  .trim();
                const cleanExisting = sanitizeTextForTts(existingAiText).replace(/\s+/g, " ").trim();
                const cleanConfirm = sanitizeTextForTts(confirmResult.aiTeacherDialogue).replace(/\s+/g, " ").trim();
                if (cleanExisting && cleanConfirm && cleanExisting === cleanConfirm) {
                  shouldSkipTtsForConfirm = true;
                }
              }

              if (!shouldSkipTtsForConfirm) {
              // 确保 TTS 就绪（6秒超时，避免 TTS 连接失败阻塞主流程）
              const TTS_READY_TIMEOUT = 6000;
              await Promise.race([
                ensureTtsReady(3),
                new Promise((_, reject) =>
                  setTimeout(() => reject(new Error("TTS 准备超时")), TTS_READY_TIMEOUT)
                ),
              ]).catch((err) => {
              });
              
              if (!ttsWsManager || !ttsWsManager.isReady() || !ttsWsManager.isSessionStarted) {
              } else {
                const cleanText = sanitizeTextForTts(confirmResult.aiTeacherDialogue);
                if (cleanText && cleanText.trim()) {
                  
                  // ✅ 先批量入队所有片段，再统一处理，避免 processTtsSendQueue 竞态导致只读第一节
                  const punctuationRegex = /[。！？，；：、.!,?;:]/;
                  let textBuffer = cleanText.trim();
                  let sentCount = 0;
                  
                  let hasPunctuation = true;
                  while (hasPunctuation && textBuffer.trim().length > 0) {
                    let firstPunctuationIndex = -1;
                    for (let i = 0; i < textBuffer.length; i++) {
                      if (punctuationRegex.test(textBuffer[i])) {
                        firstPunctuationIndex = i;
                        break;
                      }
                    }

                    if (firstPunctuationIndex === -1) {
                      hasPunctuation = false;
                      break;
                    }

                    const sentenceToSend = textBuffer.substring(0, firstPunctuationIndex + 1);
                    textBuffer = textBuffer.substring(firstPunctuationIndex + 1);

                    if (sentenceToSend.trim().length > 0) {
                      convertTextChunkToAudio(sentenceToSend.trim(), String(Date.now() + Math.random()), true);
                      sentCount++;
                      touchTtsActivity();
                    }
                  }

                  if (textBuffer && textBuffer.trim().length > 0) {
                    convertTextChunkToAudio(textBuffer.trim(), String(Date.now() + Math.random()), true);
                    sentCount++;
                    touchTtsActivity();
                  }
                  
                  // 统一触发队列处理
                  processTtsSendQueue().catch((err) => {
                    isTtsSending = false;
                  });
                  
                  
                  // 等待 TTS 发送队列处理完成（15秒超时，避免多片段时过早 finish）
                  let waitCount = 0;
                  while ((ttsSendQueue.length > 0 || isTtsSending) && waitCount < 150) {
                    await new Promise((resolve) => setTimeout(resolve, 100));
                    waitCount++;
                  }
                  
                  // 仅在队列真正清空后发送 finish
                  if (ttsSendQueue.length > 0) {
                  }
                  
                  // ✅ 延迟 400ms 再 finish，给后端时间处理最后一句文本并返回音频（避免 finish 早于最后几句的 audio_chunk）
                  await new Promise((resolve) => setTimeout(resolve, 400));
                  
                  if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
                    try {
                      await ttsWsManager.finish();
                    } catch (finishError) {
                    }
                  }
                  isTtsTextAllSent.value = true;
                }
              }
              }
            } catch (ttsError) {
            }
            
            // 重置状态
            isResponding.value = false;
            if (!isPlayingAudio && audioQueueLengthRef.value === 0) {
              isSendButtonProcessing.value = false;
            }
          }
          
          // 滚动到底部
          nextTick(() => {
            scrollBoxToBottom();
            if (showDialogBox.value) {
              scrollBoxToBottom();
            }
          });
          
          // 完成后，准备下次录音
          await prepareNextRecording();
          return; // ✅ 确认主题后直接返回，不再调用 sendThemeMessage
        }
        
        // ✅ 后续消息：直接调用 sendThemeMessage
        
        // ✅ 防御性检查：确保必要的参数存在
        if (!currentChatId.value) {
          isInSession.value = false;
          isResponding.value = false;
          await prepareNextRecording();
          return;
        }
        
        if (!aiToken.value) {
          isInSession.value = false;
          isResponding.value = false;
          await prepareNextRecording();
          return;
        }
        
        // 确认主题后（或已经确认过），发送消息
        
        let sendResult;
        try {
          sendResult = await sendThemeMessage(userMessage);
        } catch (err) {
          sendResult = null;
        }

        // 滚动到底部
        nextTick(() => {
          scrollBoxToBottom();
          if (showDialogBox.value) {
            scrollBoxToBottom();
          }
        });
        
        // ✅ 关键修复：不要立即调用 prepareNextRecording()
        // 因为 sendThemeMessage 中已经设置了 isResponding = false
        // 音频播放完成后的自动录音逻辑会在 setPlayingAudioState(false) 中处理
        // 如果音频不在播放，prepareNextRecording 会在 setPlayingAudioState 的延迟检查中自动调用
        // 如果音频正在播放，应该等待音频播放完成后再处理（在 playNextAudio 的 onended 中处理）
        return;
      }

      const aiMessageIndex = chatList.value.length;
      chatList.value.push({
        role: "ai",
        content: "",
        renderedContent: "",
        loading: true,
        audioBlobs: [],
      });

      nextTick(() => {
        scrollBoxToBottom();
        if (showDialogBox.value) {
          scrollBoxToBottom();
        }
      });

      isFinishSuccess.value = false;
      try {
        await sendSpokenMessage(userMessage, aiMessageIndex, voiceChainId);
      } catch (error) {
        // 确保状态被重置
        isResponding.value = false;
        isSendButtonProcessing.value = false;
        throw error; // 重新抛出错误
      }
      await prepareNextRecording();
    } else {
      // ✅ 失败时，显示toast并一直显示（不自动关闭）
      const toastInstance = showToast({
        message: "Miya没听清,请再说一遍",
        type: "fail",
        duration: 0, // ✅ 设置为0表示不自动关闭，一直显示
      });
      errorMsg.value = "语音转文本失败";
      isInSession.value = false;
      isResponding.value = false;
      isConvertingVoiceToText.value = false;
      // 语音转文本失败时，允许再次点击发送按钮
      isSendButtonProcessing.value = false;
      
      // ✅ 修复：显示提示后，重新加载录音资源，加载完成后关闭提示
      try {
        await reloadRecordingResources();
        // 关闭 toast
        if (toastInstance && toastInstance.close) {
          toastInstance.close();
        }
      } catch (reloadError) {
        // 即使重新加载失败，也关闭提示（避免一直显示）
        if (toastInstance && toastInstance.close) {
          toastInstance.close();
        }
      }
      
      await prepareNextRecording();
    }
  } catch (error) {
    if (isAbortError(error) || isManualStop || isStoppingAudio) {
      isInSession.value = false;
      isConvertingVoiceToText.value = false;
      isResponding.value = false;
      isSendButtonProcessing.value = false;
      return;
    }
    // ✅ 异常时，显示toast并一直显示（不自动关闭）
    const toastInstance = showToast({
      message: "Miya没听清,请再说一遍",
      type: "fail",
      duration: 0, // ✅ 设置为0表示不自动关闭，一直显示
    });
    errorMsg.value = "语音转文本接口调用失败";
    isInSession.value = false;
    isConvertingVoiceToText.value = false;
    isResponding.value = false;
    // 语音转文本失败时，允许再次点击发送按钮
    isSendButtonProcessing.value = false;
    
    // ✅ 修复：显示提示后，重新加载录音资源，加载完成后关闭提示
    try {
      await reloadRecordingResources();
      // 关闭 toast
      if (toastInstance && toastInstance.close) {
        toastInstance.close();
      }
    } catch (reloadError) {
      // 即使重新加载失败，也关闭提示（避免一直显示）
      if (toastInstance && toastInstance.close) {
        toastInstance.close();
      }
    }
    
    await prepareNextRecording();
  }
}

async function prepareNextRecording() {
  
  // ✅ 关键修复：强制清空录音数据，确保下次录音是全新的
  if (audioChunks.length > 0) {
  }
  audioChunks = [];
  lastVoiceTime = 0;
  isInSession.value = false;

  // ✅ 修改：不要强制停止正在进行的录音，只清理已停止的 mediaRecorder
  if (mediaRecorder) {
    try {
      if (mediaRecorder.state === "inactive") {
        // 只清理已停止的 mediaRecorder
        mediaRecorder = null;
      } else {
        // 如果正在录音，不要停止，只打印日志
      }
    } catch (e) {
      mediaRecorder = null;
    }
  }

  // ✅ 新增：检查录音流状态，如果失效则清理
  if (persistentRecordingStream) {
    const tracks = persistentRecordingStream.getTracks();
    const hasEndedTrack = tracks.some(track => track.readyState === "ended");
    if (hasEndedTrack) {
      tracks.forEach(track => {
        try {
          track.stop();
        } catch (e) {
          // ignore
        }
      });
      persistentRecordingStream = null;
      microphoneInitialized = false;
    }
  }

  // ✅ 播放中不重建麦克风：避免 getUserMedia 抢占音频通道导致 TTS 瞬时静音
  const hasAudioPlaying =
    isPlayingAudio ||
    audioQueueLengthRef.value > 0 ||
    pendingAudioBlobs.length > 0 ||
    pendingMergeCount > 0;
  if (hasAudioPlaying || isResponding.value || isInSession.value) {
    shouldReloadRecordingWhenIdle = true;
  } else {
    reloadRecordingResources().catch(() => {});
  }

  // ✅ 语音转文本完成后，只有在音频不在播放时才自动开启录音
  // 延迟一下，确保状态已更新，并避免立即检测到声音
  setTimeout(() => {
    const isReallyStopped =
      !isPlayingAudio &&
      audioQueueLengthRef.value === 0;
    
    if (
      isReallyStopped &&
      !isInSession.value &&
      !isResponding.value &&
      currentChatId.value &&
      aiToken.value
    ) {
      /* 条件满足时无需操作 */
    }
  }, 500);
}

// 保存 ttsSessionId 到安卓
function saveTtsSessionIdToAndroid(id) {
  if (!id || typeof id !== "string") return;
  lastTtsSessionIdFromAndroid.value = id.trim();
  if (window.android && window.android.callNative) {
    window.android.callNative(
      JSON.stringify({
        func: "getEncodeDataMMKV",
        params: { keyStr: "ttsSessionId", valueStr: id.trim() },
      })
    );
  }
}

// 从安卓读取 ttsSessionId
function loadTtsSessionIdFromAndroid() {
  if (window.android && window.android.callNative) {
    window.android.callNative(
      JSON.stringify({
        func: "getDecodeDataMMKV",
        params: { keyStr: "ttsSessionId" },
      })
    );
  }
}

// 保存已 finish 的 ttsSessionId 到安卓（每段对话 finish 时调用）
function saveLastFinishedTtsSessionIdToAndroid(id) {
  if (!id || typeof id !== "string") return;
  lastFinishedTtsSessionIdFromAndroid.value = id.trim();
  if (window.android && window.android.callNative) {
    window.android.callNative(
      JSON.stringify({
        func: "getEncodeDataMMKV",
        params: { keyStr: "lastFinishedTtsSessionId", valueStr: id.trim() },
      })
    );
  }
}

// 从安卓读取已 finish 的 ttsSessionId
function loadLastFinishedTtsSessionIdFromAndroid() {
  if (window.android && window.android.callNative) {
    window.android.callNative(
      JSON.stringify({
        func: "getDecodeDataMMKV",
        params: { keyStr: "lastFinishedTtsSessionId" },
      })
    );
  }
}

// 初始化 TTS WebSocket 连接（在创建对话后调用）
// isNewConversation: 是否新建对话，仅新建对话时发送 finish 关闭安卓存储的旧 ttsSessionId
async function initTtsWebSocket(isNewConversation = false) {
  // ✅ 防止并发初始化
  if (isTtsInitializing) {
    const now = Date.now();
    const elapsed = now - ttsInitializingStartTime;
    
    // 如果初始化已经超过 10 秒，强制重置标志
    if (elapsed > 10000) {
      isTtsInitializing = false;
      ttsInitializingStartTime = 0;
    } else {
      // 等待当前初始化完成（最多等待5秒）
      for (let i = 0; i < 50; i++) {
        await new Promise(resolve => setTimeout(resolve, 100));
        if (!isTtsInitializing) {
          return;
        }
      }
      isTtsInitializing = false;
      ttsInitializingStartTime = 0;
    }
  }
  
  if (ttsWsManager && ttsWsManager.isReady()) {
    return;
  }

  // ✅ 连接存在且 WebSocket 已打开，仅会话未启动时，尝试 connect 而非重建
  if (ttsWsManager && ttsWsManager.ws && ttsWsManager.ws.readyState === WebSocket.OPEN && !ttsWsManager.isSessionStarted) {
    try {
      await ttsWsManager.connect(isNewConversation);
      if (ttsWsManager.isSessionStarted) {
        return;
      }
    } catch (e) {
    }
  }

  isTtsInitializing = true; // ✅ 标记开始初始化
  ttsInitializingStartTime = Date.now(); // ✅ 记录开始时间
  
  try {
  // 清理旧连接
  if (ttsWsManager) {
    ttsWsManager.close();
    ttsWsManager = null;
  }

    ttsWsManager = createTtsWebSocketManager({
      userId: userInfo.value?.id || userInfo.value?.userId || "",
      token: aiToken.value,
      lastTtsSessionIdFromStorage: () => lastTtsSessionIdFromAndroid.value,
      lastFinishedTtsSessionIdFromStorage: () => lastFinishedTtsSessionIdFromAndroid.value,
      shouldFinishOldTtsSession: isNewConversation,
      onTtsSessionIdUpdate: (id) => {
        saveTtsSessionIdToAndroid(id);
      },
      onFinishSent: (id) => {
        saveLastFinishedTtsSessionIdToAndroid(id);
      },
      onAudioChunk: (audioBase64, rawMsg) => {
        // 文档约定 audio_chunk / complete 的音频字段为 audioData（base64）
        // 现在改为：先按"句子"合并，再入队播放
        // 传递 rawMsg 以获取索引信息（如果后端提供了）
        if (audioBase64) {
          addAudioChunkToSentence(audioBase64, { ...(rawMsg || {}), _chainId: currentTtsChainId });
        }
      },
      onRawMessage: (msg) => {
        // 所有 ws 消息都输出（不区分环境）

        // 1. TTS 连接失败（广播给所有用户）- 隐藏 toast，仅保留日志
        if (msg && msg.type === "tts_connection_failed") {
          if (msg.autoRetry && ttsWsManager) {
            setTimeout(() => {
              initTtsWebSocket().catch(() => {});
            }, 3000);
          }
          return;
        }

        // 2. TTS 会话失败（对特定活跃用户）- 隐藏 toast，仅保留日志
        if (msg && msg.type === "tts_session_failed") {
          // 重置响应状态，允许用户重新操作
          isResponding.value = false;
          isSendButtonProcessing.value = false;
          return;
        }

        // 3. TTS 连接恢复 - 隐藏 toast
        if (msg && msg.type === "tts_connection_restored") {
          return;
        }

        // 监听 complete 消息，说明所有音频都接收完了
        if (msg && msg.type === "complete") {
          // ✅ 修改：如果是提示音频模式，使用独立的处理函数
          if (isTipAudioMode) {
            handleTipAudioComplete();
          } else {
            handleCompleteMessage();
          }
        }
      },
      onConnected: (msg) => {
        // TTS 连接成功回调（收到 session_started 时调用）

        // ✅ 新增：如果还没有进入对话（没有currentChatId），播放欢迎提示音频
        // ✅ 修复：切换模板/进入对话过程中不播放欢迎提示，避免与新模版初始音频混播
        // ✅ 模板切换后进入对话：不播欢迎音，只播新对话首句
        if (
          !skipWelcomeForNextConnection &&
          isReadyToEnterConversation.value &&
          !currentChatId.value &&
          !isPlayingTipAudio &&
          !isEnteringConversation.value
        ) {
          setTimeout(() => {
            try {
              if (!skipWelcomeForNextConnection && !isEnteringConversation.value && !currentChatId.value) {
                playRandomWelcomeTip();
              }
            } catch (error) {
            }
          }, 100);
        }
        skipWelcomeForNextConnection = false; // 仅本次连接生效

        // 连接成功后，自动处理队列中的文本（如果有）
        if (ttsSendQueue.length > 0) {
          processTtsSendQueue().catch((err) => {
            isTtsSending = false;
          });
        } else {
        }

        // 连接成功后，如果标记为需要自动发送初始消息，则发送新建对话的内容到 TTS
        if (
          shouldAutoSendInitialMessages &&
          currentChatId.value &&
          chatList.value &&
          chatList.value.length > 0
        ) {
          setTimeout(async () => {
            if (!shouldAutoSendInitialMessages) return;
            // 模板17互斥：任一路径已发送则跳过，避免读两遍
            if (promptId.value == 17 && template17InitialSent) return;
            shouldAutoSendInitialMessages = false;
            if (promptId.value == 17) template17InitialSent = true;

            if (promptId.value == 17) {
              const aiMessages = chatList.value.filter(
                (msg) => msg.role === "ai" && (msg.originalContent || msg.content)
              );
              if (aiMessages.length > 0) {
                const fullText = aiMessages
                  .map(msg => msg.originalContent || msg.content)
                  .join(" ");
                const cleanText = sanitizeTextForTts(fullText);
                if (cleanText && cleanText.trim()) {
                  pendingAudioBlobs = [];
                  allAudioBlobsForCurrentMessage = [];
                  clearAudioChunkIndexTracking();
                  currentAiMessageIndex = chatList.value.findIndex(msg => msg.role === "ai");
                  await convertTextChunkToAudio(cleanText.trim(), String(Date.now() + Math.random()));
                  touchTtsActivity();
                  if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
                    try {
                      await ttsWsManager.finish();
                    } catch (finishError) {
                    }
                  }
                }
              }
            } else {
              await sendInitialMessagesToTts();
            }
          }, 300);
        }
      },
      onError: (error) => {
      },
      onClose: () => {
      },
    });

    await ttsWsManager.connect();
  } catch (error) {
    ttsWsManager = null;
    throw error; // 重新抛出错误，让调用者知道
  } finally {
    isTtsInitializing = false; // ✅ 无论成功失败都重置标志
    ttsInitializingStartTime = 0; // ✅ 重置时间戳
  }
}

// 处理 TTS 发送队列（按顺序、间隔 300ms 发送）
async function processTtsSendQueue() {
  
  // 如果正在发送中或队列为空，直接返回
  if (isTtsSending) {
    return;
  }
  
  if (ttsSendQueue.length === 0) {
    return;
  }
  

  isTtsSending = true;

  while (ttsSendQueue.length > 0) {
    const { textChunk, reportId, chainId } = ttsSendQueue.shift();
    if (chainId && !isVoiceChainActive(chainId)) {
      logChain("tts queue dropped", { chainId, reportId });
      continue;
    }

    if (!ttsWsManager) {
      ttsSendQueue.unshift({ textChunk, reportId, chainId });
      // 如果 TTS 管理器不存在，尝试立即初始化（不等待）
      initTtsWebSocket().catch((err) => {
      });
      // 减少等待时间，快速重试
      await new Promise((resolve) => setTimeout(resolve, 100));
      continue;
    }

    // 检查 WebSocket 状态
    if (!ttsWsManager.ws || ttsWsManager.ws.readyState !== WebSocket.OPEN) {
      // 如果 WebSocket 未打开，将文本重新放回队列
      ttsSendQueue.unshift({ textChunk, reportId, chainId });
      // 尝试重新初始化（如果 WebSocket 已关闭）
      if (!ttsWsManager.ws || ttsWsManager.ws.readyState === WebSocket.CLOSED) {
        initTtsWebSocket().catch((err) => {
        });
      }
      // 减少等待时间，快速重试
      await new Promise((resolve) => setTimeout(resolve, 100));
      continue;
    }

    if (!ttsWsManager.isSessionStarted) {
      // 如果会话未开始，将文本重新放回队列
      ttsSendQueue.unshift({ textChunk, reportId, chainId });
      // 尝试重新启动会话
      if (ttsWsManager.ws && ttsWsManager.ws.readyState === WebSocket.OPEN) {
        ttsWsManager.connect().catch((err) => {
        });
      }
      // 减少等待时间，快速重试
      await new Promise((resolve) => setTimeout(resolve, 100));
      continue;
    }

    // 控制发送间隔：如果距离上次发送不足 300ms，等待到 300ms
    const now = Date.now();
    const timeSinceLastSend = now - ttsLastSendTime;
    if (ttsLastSendTime > 0 && timeSinceLastSend < TTS_SEND_INTERVAL) {
      const waitTime = TTS_SEND_INTERVAL - timeSinceLastSend;
      await new Promise((resolve) => setTimeout(resolve, waitTime));
    }

    // 更新最后发送时间
    ttsLastSendTime = Date.now();


    // 记录最近一次 TTS 文本活动时间，并重置 finish 超时
    touchTtsActivity();

    // 直接通过管理器发送文本（如果会话未开始会自动加入队列，等待 session_started 后自动发送）
    try {
      currentTtsChainId = chainId || activeVoiceChainId || null;
      // ✅ 打印完整发送给 TTS 的文本
      
      ttsWsManager.sendText(textChunk);
    } catch (error) {
      // 发送失败，将文本重新放回队列
      ttsSendQueue.unshift({ textChunk, reportId, chainId });
      // 不要 break，继续尝试发送下一段（可能只是这一段有问题）
      // 但如果连续失败多次，可能需要 break
      continue;
    }
  }

  isTtsSending = false;

  // 如果队列中还有文本但处理已停止，继续处理（确保所有文本都被发送）
  if (ttsSendQueue.length > 0) {
    // 立即重试，不要延迟（确保快速处理）
    processTtsSendQueue().catch((err) => {
      isTtsSending = false;
      // 如果失败，500ms 后重试
      if (ttsSendQueue.length > 0) {
        setTimeout(() => {
          processTtsSendQueue().catch((err) => {
            isTtsSending = false;
          });
        }, 500);
      }
    });
  } else {
  }
}

// 将文本片段转换为音频（通过复用的 WebSocket TTS）
// skipProcess: 仅入队不触发处理，用于批量入队后统一调用 processTtsSendQueue
async function convertTextChunkToAudio(textChunk, reportId, skipProcess = false, chainId = null) {
  if (!textChunk || !textChunk.trim()) {
    return;
  }

  if (!ttsWsManager) {
    return;
  }

  const trimmedText = textChunk.trim();
  
  // ✅ 打印即将加入队列的文本（完整内容）

  // 将文本加入发送队列
  ttsSendQueue.push({ textChunk: trimmedText, reportId, chainId: chainId || activeVoiceChainId || null });

  // 仅入队模式：不触发处理，由调用方统一调用 processTtsSendQueue
  if (!skipProcess) {
    processTtsSendQueue().catch((err) => {
      isTtsSending = false;
    });
  }
}

// 随机播放欢迎提示音频（进入页面时调用）
function playRandomWelcomeTip() {
  const tipAudioFiles = getWelcomeTipAudioFiles();
  // 随机选择一句（0或1）
  const randomIndex = Math.floor(Math.random() * tipAudioFiles.length);
  welcomeTipAudioIndex.value = randomIndex;
  const selectedAudioFile = tipAudioFiles[randomIndex];
  playTipAudio(selectedAudioFile, 'welcome').catch((err) => {
  });
}

// 播放提示音频（直接使用本地音频文件，不通过TTS）
// audioFile: 音频文件路径或URL
// type: 'welcome' 表示欢迎提示，'noAction' 表示15秒无操作提示
async function playTipAudio(audioFile, type = null) {

  if (!audioFile) {
    return;
  }

  // 如果正在播放提示音频，不重复播放
  if (isPlayingTipAudio) {
    return;
  }


  // 设置提示音频模式标记
  isTipAudioMode = true;
  isPlayingTipAudio = true;
  currentTipAudioType = type; // 保存当前提示音频类型

  // ✅ 播放前释放录音对象，避免录音占用通话音道导致闲置语音播放不全或播放到一半音量突变
  if (isInSession.value) {
    shouldSaveRecording = false;
    stopRecording();
  }
  releaseRecordingStreamWhenIdle();

  try {
    // 加载音频文件（添加时间戳避免浏览器缓存）
    const audioUrlWithCacheBust = `${audioFile}?t=${Date.now()}`;
    const response = await fetch(audioUrlWithCacheBust, {
      cache: 'no-cache' // 禁用缓存
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const audioBlob = await response.blob();
    
    if (!audioBlob || audioBlob.size === 0) {
      throw new Error("音频文件为空或无效");
    }


    // 确保音频格式为 opus
    const opusBlob = new Blob([audioBlob], { type: "audio/opus; codecs=opus" });
    
    // 将音频加入播放队列
    enqueueWebAudioBlob(opusBlob);

    // 根据音频大小估算播放时长
    const audioSize = opusBlob.size;
    const estimatedDuration = Math.max((audioSize / 1024) * 100, 1500); // 至少1.5秒
    
    
    // 延迟处理播放完成逻辑
    if (tipAudioPlaybackTimer) {
      clearTimeout(tipAudioPlaybackTimer);
    }
    tipAudioPlaybackTimer = setTimeout(() => {
      tipAudioPlaybackTimer = null;
      handleTipAudioPlaybackComplete();
    }, estimatedDuration);
  } catch (error) {
    isPlayingTipAudio = false;
    isTipAudioMode = false;
    // 即使播放失败，也递增对应类型的索引
    updateTipAudioIndexAfterPlayback();
  }
}

// 处理提示音频完成
async function handleTipAudioComplete() {
  if (!isTipAudioMode) {
    return;
  }

  // ✅ 播放前释放录音对象，避免录音占用通话音道导致闲置语音播放不全或播放到一半音量突变
  if (isInSession.value) {
    shouldSaveRecording = false;
    stopRecording();
  }
  releaseRecordingStreamWhenIdle();

  
  // ✅ 新增：收到 complete 消息后，发送 finish
  if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
    try {
      await ttsWsManager.finish();
    } catch (e) {
    }
  }
  
  // 清除超时定时器（已经收到 complete，不需要超时处理）
  if (tipAudioTimeoutTimer) {
    clearTimeout(tipAudioTimeoutTimer);
    tipAudioTimeoutTimer = null;
  }

  if (tipAudioBlobs.length === 0) {
    isPlayingTipAudio = false;
    isTipAudioMode = false;
    tipAudioBlobs = [];
    return;
  }

  // 保存音频片段数量（用于后续处理）
  const audioBlobsCount = tipAudioBlobs.length;
  const audioBlobsCopy = [...tipAudioBlobs]; // 复制一份，避免后续被清空
  tipAudioBlobs = []; // 立即清空，避免重复处理

  // ✅ 修改：先对音频片段进行排序（参考AI消息的处理逻辑）
  const sortedTipAudioBlobs = audioBlobsCopy.sort((a, b) => {
    // ✅ 优先级1：优先使用 sentCount 排序（从1开始递增，有序且唯一）
    const sentCountA = a.sentCount !== null && a.sentCount !== undefined ? parseInt(a.sentCount, 10) : null;
    const sentCountB = b.sentCount !== null && b.sentCount !== undefined ? parseInt(b.sentCount, 10) : null;
    
    if (sentCountA !== null && sentCountB !== null) {
      // 两个都有 sentCount，直接按 sentCount 排序
      return sentCountA - sentCountB;
    } else if (sentCountA !== null) {
      // 只有 A 有 sentCount，A 优先
      return -1;
    } else if (sentCountB !== null) {
      // 只有 B 有 sentCount，B 优先
      return 1;
    }

    // ✅ 优先级2：如果都没有 sentCount，回退到时间戳排序
    const timestampA = a.sortTimestamp || a.serverTimestamp || a.receiveTimestamp || 0;
    const timestampB = b.sortTimestamp || b.serverTimestamp || b.receiveTimestamp || 0;
    if (timestampA !== timestampB) {
      return timestampA - timestampB;
    }
    
    // ✅ 优先级3：如果时间戳相同，回退到索引排序
    if (a.index >= 0 && b.index >= 0) {
      return a.index - b.index;
    }
    return 0;
  });
  
  // ✅ 验证排序结果
  if (sortedTipAudioBlobs.length > 1) {
    const sentCounts = sortedTipAudioBlobs
      .map(item => item.sentCount !== null && item.sentCount !== undefined ? parseInt(item.sentCount, 10) : null)
      .filter(count => count !== null);
    
    if (sentCounts.length > 1) {
    } else {
      const timestamps = sortedTipAudioBlobs.map(item => item.sortTimestamp || item.serverTimestamp || item.receiveTimestamp);
    }
  }
  
  // ✅ 提取 Blob 对象用于合并
  const blobsToMerge = sortedTipAudioBlobs.map(item => item.blob);

  // 合并所有音频片段
  mergeBlobsByWorker(blobsToMerge, (mergedBlob, mergeError) => {
    if (mergeError || !mergedBlob) {
      // 合并失败，逐个播放（已排序的）
      if (sortedTipAudioBlobs.length > 0) {
        sortedTipAudioBlobs.forEach((item, index) => {
          const blob = item.blob;
          if (blob && blob.size > 0) {
            enqueueWebAudioBlob(blob);
          } else {
          }
        });
        // 估算总播放时长（假设每个片段约1秒）
        const estimatedDuration = audioBlobsCopy.length * 1000;
        // ✅ 修改：保存定时器 ID，便于清理
        if (tipAudioPlaybackTimer) {
          clearTimeout(tipAudioPlaybackTimer);
        }
        tipAudioPlaybackTimer = setTimeout(() => {
          tipAudioPlaybackTimer = null;
          handleTipAudioPlaybackComplete();
        }, estimatedDuration);
      } else {
        isPlayingTipAudio = false;
        isTipAudioMode = false;
        // ✅ 修改：即使播放失败，也递增对应类型的索引
        updateTipAudioIndexAfterPlayback();
      }
    } else {
      
      // ✅ 修改：确保音频格式为 opus
      const opusBlob = new Blob([mergedBlob], { type: "audio/opus; codecs=opus" });
      
      if (opusBlob.size === 0) {
        isPlayingTipAudio = false;
        isTipAudioMode = false;
        // ✅ 修改：即使播放失败，也递增对应类型的索引
        updateTipAudioIndexAfterPlayback();
        return;
      }
      
      // 直接播放合并后的音频
      enqueueWebAudioBlob(opusBlob);
      
      // ✅ 修改：根据音频大小估算播放时长，并在播放完成后递增索引
      // 简单估算：假设每KB约0.1秒（实际可能不同）
      const audioSize = opusBlob.size;
      const estimatedDuration = Math.max((audioSize / 1024) * 100, 1500); // 至少1.5秒
      
      
      // 延迟处理播放完成逻辑
      // ✅ 修改：保存定时器 ID，便于清理
      if (tipAudioPlaybackTimer) {
        clearTimeout(tipAudioPlaybackTimer);
      }
      tipAudioPlaybackTimer = setTimeout(() => {
        tipAudioPlaybackTimer = null;
        handleTipAudioPlaybackComplete();
      }, estimatedDuration);
    }
  });
}

// ✅ 新增：更新提示音频索引（根据类型更新对应的索引）
function updateTipAudioIndexAfterPlayback() {
  const savedType = currentTipAudioType;
  if (savedType === 'welcome') {
    const tipAudioFiles = getWelcomeTipAudioFiles();
    welcomeTipAudioIndex.value = (welcomeTipAudioIndex.value + 1) % tipAudioFiles.length;
  } else if (savedType === 'noAction') {
    const tipAudioFiles = getNoActionTipAudioFiles();
    noActionTipAudioIndex.value = (noActionTipAudioIndex.value + 1) % tipAudioFiles.length;
  } else {
  }
  currentTipAudioType = null; // 重置类型
}

// 处理提示音频播放完成（重置状态并递增索引）
function handleTipAudioPlaybackComplete() {
  // ✅ 修改：即使 isTipAudioMode 已被重置，也要更新索引（确保循环播放）
  const wasInTipAudioMode = isTipAudioMode;
  
  // ✅ 修改：清理提示音频相关的定时器
  if (tipAudioPlaybackTimer) {
    clearTimeout(tipAudioPlaybackTimer);
    tipAudioPlaybackTimer = null;
  }
  if (tipAudioTimeoutTimer) {
    clearTimeout(tipAudioTimeoutTimer);
    tipAudioTimeoutTimer = null;
  }
  
  isTipAudioMode = false;
  isPlayingTipAudio = false;
  
  // ✅ 修改：根据提示音频类型更新对应的索引
  updateTipAudioIndexAfterPlayback();

  // ✅ 已移除：不再提示音频播放完成后预初始化麦克风，录音仅在用户长按时开启
}

// ✅ 新增：清理提示音频相关的所有定时器和状态
function cleanupTipAudio() {
  if (tipAudioPlaybackTimer) {
    clearTimeout(tipAudioPlaybackTimer);
    tipAudioPlaybackTimer = null;
  }
  if (tipAudioTimeoutTimer) {
    clearTimeout(tipAudioTimeoutTimer);
    tipAudioTimeoutTimer = null;
  }
  isTipAudioMode = false;
  isPlayingTipAudio = false;
  tipAudioBlobs = [];
  tipAudioErrorLogCount = 0;
  tipAudioErrorLastLogTime = 0;
}

// 记录 TTS 活动并设置 1 分钟无活动后自动 finish 的逻辑
function touchTtsActivity() {
  ttsLastChunkTime = Date.now();

  // 原先这里会启动一个 1 分钟的定时器自动调用 finish 结束会话，
  // 现在改为仅记录时间，真正的 finish 由“音频播放完成”时触发，
  // 或由手动“结束对话”按钮触发，不再自动超时关闭。
}

// 发送消息：调用口语对话流式接口，并将每次流式返回的文本片段交给 TTS 播放
async function sendSpokenMessage(message, aiMessageIndex, chainId = null) {
  const effectiveChainId = chainId || activateVoiceChain("text");
  activeVoiceChainId = effectiveChainId;
  logChain("sendSpokenMessage start", { chainId: effectiveChainId, chatId: currentChatId.value || "" });
  const effectiveChatId = currentChatId.value || "";
  const requestEpoch = ++activeResponseEpoch;

  // 新的 AI 回复开始：解除熄屏期间的音频禁用
  if (isAudioBlockedWhileScreenOff) {
    isAudioBlockedWhileScreenOff = false;
  }
  if (isTtsHardInterruptedWhileScreenOff) {
    isTtsHardInterruptedWhileScreenOff = false;
  }

  // ✅ 提前标记为请求中，避免 cleanup 后 noActionTimer 竞态误触发闲置语音
  isResponding.value = true;

  // ✅ 新消息开始前完整清理音频，确保暂停后的旧音频完全停止
  cleanupAudioPlayback();

  // ✅ 关键：先 cleanup 再清除暂停标记，避免清理期间延迟到达的旧 base64 回调入队
  // lastPauseTime 不在此处清除，在收到首个新音频 chunk 时清除，拒绝暂停前的旧片段
  isManualStop = false;
  isStoppingAudio = false;

  if (!currentChatId.value || !aiToken.value) {
    isResponding.value = false;
    return;
  }

  // 确保之前的流式请求已被清空
  if (currentSpokenStream) {
    try {
      if (typeof currentSpokenStream.abort === "function") {
        currentSpokenStream.abort();
      }
    } catch (e) {
      // 忽略错误
    }
    currentSpokenStream = null;
  }

  // 设置当前正在处理的 AI 消息索引（用于缓存音频）
  currentAiMessageIndex = aiMessageIndex;
  bindAiMessageChain(aiMessageIndex, effectiveChainId, effectiveChatId);
  // 确保该消息有 audioBlobs 数组
  if (
    chatList.value[aiMessageIndex] &&
    !chatList.value[aiMessageIndex].audioBlobs
  ) {
    chatList.value[aiMessageIndex].audioBlobs = [];
  }
  // 重置当前消息的音频片段缓存（新消息开始）
  allAudioBlobsForCurrentMessage = [];
  clearAudioChunkIndexTracking();

  // 重置文本渲染状态，确保新消息可以正确渲染
  if (currentRenderingMessageIndex !== aiMessageIndex) {
    stopTextRendering();
    currentRenderingMessageIndex = aiMessageIndex;
    accumulatedText = "";
    renderedTextLength = 0;
    // 确保消息的 content 是空的（新消息开始时必须清空）
    if (chatList.value[aiMessageIndex]) {
      chatList.value[aiMessageIndex].content = "";
    }
  } else {
    // 如果是同一个消息，确保状态同步（防止重复渲染）
    if (chatList.value[aiMessageIndex]) {
      const currentContent = chatList.value[aiMessageIndex].content || "";
      // 如果 content 的长度与 renderedTextLength 不一致，重新同步
      if (currentContent.length !== renderedTextLength) {
        accumulatedText = currentContent;
        renderedTextLength = currentContent.length;
      }
    }
  }

  try {
    // 接口请求开始时，停止自动监听
    stopAutoVolumeMonitoring();
    isResponding.value = true;

    // 重置本次回答相关的音频状态
    pendingAudioBlobs = [];
    processedTextLength = 0;
    textToAudioRecordIds = [];
    clearAudioChunkIndexTracking();

    // 启动队列监控（方便观察是否有卡顿）
    startQueueMonitor();

    // 累积 AI 文本内容，用于渲染到对话框中
    let uiAccumulatedText = "";
    // 记录接口上一次返回的完整文本（用于处理"累积式返回"防止重复）
    let lastFullText = "";
    // 累积文本缓冲区，用于按句发送到 TTS（遇到标点符号就发送）
    let ttsTextBuffer = "";
    // 累计发送到 TTS 的所有文本内容（用于音频完整性校验）
    let totalSentText = "";

    const payload = {
      chatRecordId: currentChatId.value,
      message,
      nickname: userInfo.value?.nickname || "",
      grade:
        userInfo.value?.grade ||
        (gradeId.value ? String(gradeId.value) : "") ||
        "",
    };


    // ✅ 复用 TTS 连接：只有连接不存在或已断开时才新建，否则复用并 finish+start
    try {
      const wsState = ttsWsManager?.ws?.readyState;
      const isConnecting = wsState === WebSocket.CONNECTING;
      const isOpen = wsState === WebSocket.OPEN;
      const isClosed = !wsState || wsState === WebSocket.CLOSED || wsState === WebSocket.CLOSING;
      
      // 1. 只有连接不存在或已关闭时才新建，不因 isSessionStarted=false 就重建
      if (!ttsWsManager || isClosed) {
        if (ttsWsManager) {
          try {
            ttsWsManager.close();
          } catch (e) {
            // 忽略关闭错误
          }
          ttsWsManager = null;
        }
        const TTS_INIT_TIMEOUT = 6000;
        await Promise.race([
          (async () => {
            await initTtsWebSocket();
            let waitCount = 0;
            const maxWaits = 30;
            while (
              waitCount < maxWaits &&
              (!ttsWsManager || !ttsWsManager.isReady())
            ) {
              await new Promise((resolve) => setTimeout(resolve, 100));
              waitCount++;
            }
          })(),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("TTS 初始化超时")), TTS_INIT_TIMEOUT)
          ),
        ]).catch((err) => {
        });
        if (ttsWsManager && ttsWsManager.isReady()) {
        } else {
        }
      } else if (isConnecting) {
        // 2. 连接正在建立中，等待完成
        let waitCount = 0;
        const maxWaits = 30;
        while (
          waitCount < maxWaits &&
          (!ttsWsManager.isReady() || ttsWsManager?.ws?.readyState !== WebSocket.OPEN)
        ) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          waitCount++;
          if (ttsWsManager?.ws?.readyState === WebSocket.OPEN && ttsWsManager.isSessionStarted) {
            break;
          }
        }
        if (ttsWsManager?.isReady() && ttsWsManager?.ws?.readyState === WebSocket.OPEN) {
        } else {
        }
      } else if (isOpen) {
        // 3. 连接已打开，复用：finish（如有会话）后 start
        if (ttsWsManager.isSessionStarted) {
          try {
            await ttsWsManager.finish();
            await new Promise((resolve) => setTimeout(resolve, 100));
          } catch (error) {
          }
        }
        try {
          await ttsWsManager.connect();
        } catch (error) {
        }
      }
    } catch (error) {
      // 即使处理失败，也继续执行流式请求（不阻塞）
    }

    // 确保在调用流式接口之前，所有状态都正确
    // ✅ 修复：暂停后下一句语音不渲染/TTS 不发送。TTS 初始化 await 期间 onRawMessage 可能收到 tts_session_failed 等，误将 isResponding 置为 false，流式回调因此提前 return。此处强制恢复
    isResponding.value = true;
    isManualStop = false;
    isStoppingAudio = false;

    // ✅ 添加5分钟超时处理（流式接口）
    apiTimeoutTimer = setTimeout(() => {
        apiTimeoutTimer = null;
        showToast({
          message: "网络错误，请重试",
          type: "fail",
        });
        // ✅ 重置状态，让用户能再次调用
        resetResponseState();
      }, STREAM_REQUEST_TIMEOUT);
      
      currentSpokenStream = sendSpokenChatCompletionsStream(
        payload,
        (chunk) => {
          // 旧代次回调直接丢弃，避免暂停后串到下一段
          if (requestEpoch !== activeResponseEpoch) {
            logChain("stream chunk dropped by epoch", {
              chainId: effectiveChainId,
              requestEpoch,
              activeEpoch: activeResponseEpoch
            });
            return;
          }
          if (!isVoiceChainActive(effectiveChainId)) {
            logChain("stream chunk dropped by chain", { chainId: effectiveChainId });
            return;
          }
          if (effectiveChatId && effectiveChatId !== (currentChatId.value || "")) {
            logChain("stream chunk dropped by chat", {
              chainId: effectiveChainId,
              chunkChatId: effectiveChatId,
              currentChatId: currentChatId.value || ""
            });
            return;
          }
          if (!isAiMessageChainMatched(aiMessageIndex, effectiveChainId, effectiveChatId)) {
            logChain("stream chunk dropped by message bind", {
              chainId: effectiveChainId,
              aiMessageIndex
            });
            return;
          }
          // ✅ 清除超时定时器（收到数据表示接口正常）
          if (apiTimeoutTimer) {
            clearTimeout(apiTimeoutTimer);
            apiTimeoutTimer = null;
          }
          
          // ✅ 关键：检查是否已停止响应，如果已停止则不再处理后续数据
          if (!isResponding.value) {
            return;
          }

          if (!chunk) {
            return;
          }

          // ragStreamRequest 传递的是 data.content（字符串），ragStreamRequestFull 传递的是完整对象
          let contentText = "";

          try {
            // 如果 chunk 是对象（ragStreamRequestFull 传递的格式）
            if (typeof chunk === "object" && chunk !== null) {
              // ✅ 优化：优先使用 audioData（TTS WebSocket 标准字段），兼容 audioBase64
              const audioData = chunk.audioData || chunk.audioBase64;
              if (audioData) {
                // ✅ 新增：如果是手动暂停音频模式，跳过音频处理，但允许文本继续
                if (isManualStopAudioOnly) {
                } else {
                  // ✅ 关键优化：传递完整的 chunk 对象作为 rawMsg，以便提取 timestamp 和 messageId
                  addAudioChunkToSentence(audioData, { ...chunk, _chainId: effectiveChainId });
                }
              }

              // 处理文本内容（如果有）
              if (chunk.content) {
                contentText = String(chunk.content);
              }
            }
            // 如果是字符串（ragStreamRequest 传递的格式，或者是 JSON 字符串）
            else if (typeof chunk === "string") {

              // 先尝试解析为 JSON（可能是包含 audioData/audioBase64 和 content 的对象）
              try {
                const obj = JSON.parse(chunk);
                if (obj && typeof obj === "object") {
                  // 是 JSON 对象
                  // ✅ 优化：优先使用 audioData（TTS WebSocket 标准字段），兼容 audioBase64
                  const audioData = obj.audioData || obj.audioBase64;
                  if (audioData) {
                    // ✅ 新增：如果是手动暂停音频模式，跳过音频处理，但允许文本继续
                    if (isManualStopAudioOnly) {
                    } else {
                      // ✅ 关键优化：传递完整的 obj 对象作为 rawMsg，以便提取 timestamp 和 messageId
                      addAudioChunkToSentence(audioData, { ...obj, _chainId: effectiveChainId });
                    }
                  }
                  if (obj.content) {
                    contentText = String(obj.content);
                  }
                } else {
                  // 解析后不是对象，当作纯文本
                  contentText = chunk;
                }
              } catch (e) {
                // 如果不是 JSON，当作纯文本处理（ragStreamRequest 直接传递 content 字符串）
                contentText = chunk;

              }
            }
          } catch (e) {
            return;
          }

          // ✅ 若 content 被 JSON 包裹（如 {"content":"从","role":"assistant"}），提取实际文本
          contentText = extractContentFromChunk(contentText);

          // ✅ 关键：再次检查是否已停止响应（在处理文本之前）
          if (!isResponding.value) {
            return;
          }

          // 如果没有文本内容，直接返回（可能只有音频数据）
          if (!contentText || contentText.trim() === "") {
            return;
          }

          // 1）先计算“本次新增的文本部分”
          // 有两种后端返回方式：
          //  - 增量：每次只返回新增内容，如 "请"、"你"、"说出" ...
          //  - 累积：每次返回完整内容，如 "请"、"请你"、"请你说出" ...
          // 对于累积式返回，如果直接累加会出现“每条内容显示两遍”的情况，
          // 所以这里用前缀判断，抠出真正新增的部分。
          let displayText = contentText;
          if (lastFullText && contentText.startsWith(lastFullText)) {
            // 累积式返回：只取新增部分
            displayText = contentText.slice(lastFullText.length);
          }
          // 更新 lastFullText（用于下次比较）
          lastFullText = contentText;

          // 如果没有新增文本（可能是重复的累积式返回），直接返回
          if (!displayText || displayText.trim() === "") {
            return;
          }

          // 2）更新对话框展示：将新增文本加入渲染队列，逐字符渲染（0.1秒一个字符）
          uiAccumulatedText += displayText;

          // ✅ 关键：再次检查是否已停止响应（在渲染文本之前）
          if (!isResponding.value) {
            return;
          }

          if (chatList.value[aiMessageIndex]) {
            // 收到第一个文本内容时，关闭 loading 状态
            if (chatList.value[aiMessageIndex].loading) {
              chatList.value[aiMessageIndex].loading = false;
            }

            addTextToRenderQueue(displayText, aiMessageIndex);
          }

          // 3）累积文本到缓冲区，遇到第一个标点符号就立即发送到 TTS
          //    同时去掉表情等特殊符号，避免通过长连接影响语音效果
          const text = sanitizeTextForTts(displayText);
          if (text.length > 0) {
            // 累积到缓冲区
            ttsTextBuffer += text;

            // 检查缓冲区是否包含标点符号（中英文标点符号：。！？，；：、. ! ? , ; :）
            const punctuationRegex = /[。！？，；：、.!,?;:]/;

            // 循环处理：只要缓冲区中有标点符号，就立即发送
            let hasPunctuation = true;
            while (hasPunctuation) {
              // 从前往后查找第一个标点符号的位置
              let firstPunctuationIndex = -1;
              for (let i = 0; i < ttsTextBuffer.length; i++) {
                if (punctuationRegex.test(ttsTextBuffer[i])) {
                  firstPunctuationIndex = i;
                  break;
                }
              }

              if (firstPunctuationIndex === -1) {
                // 没有找到标点符号，跳出循环，等待更多文本
                hasPunctuation = false;
                break;
              }

              // 提取到第一个标点符号（包括标点）的文本
              const sentenceToSend = ttsTextBuffer.substring(
                0,
                firstPunctuationIndex + 1
              );
              // 保留标点符号之后的内容
              ttsTextBuffer = ttsTextBuffer.substring(
                firstPunctuationIndex + 1
              );

              // ✅ 关键：检查是否已停止响应（在发送到 TTS 之前）
              if (!isResponding.value) {
                return;
              }

              // 立即发送这一句到 TTS
              if (sentenceToSend.trim().length > 0) {
                totalSentText += sentenceToSend;
                touchTtsActivity();

                // 确保 TTS WebSocket 已就绪，如果未就绪则立即初始化（不阻塞流式回调）
                if (
                  !ttsWsManager ||
                  !ttsWsManager.isReady() ||
                  !ttsWsManager.isSessionStarted
                ) {
                  // 异步初始化，不等待完成（避免阻塞流式回调）
                  initTtsWebSocket().catch((err) => {
                  });
                }

                // 立即加入队列并触发处理（不等待）
                convertTextChunkToAudio(
                  sentenceToSend.trim(),
                  String(Date.now() + Math.random())
                ).catch((err) => {
                });
              }
            }

          }
        },
        aiToken.value
      );

    // 等待流式结束
    try {
      await currentSpokenStream;
      // ✅ 清除超时定时器（流式请求成功完成）
      if (apiTimeoutTimer) {
        clearTimeout(apiTimeoutTimer);
        apiTimeoutTimer = null;
      }
    } catch (error) {
      // ✅ 清除超时定时器
      if (apiTimeoutTimer) {
        clearTimeout(apiTimeoutTimer);
        apiTimeoutTimer = null;
      }
      if (isManualStop || isStoppingAudio || isAbortError(error)) {
        currentSpokenStream = null;
        return;
      }
      // ✅ 如果是超时错误，已经在超时回调中处理了，这里不再重复处理
      if (!error.message || !error.message.includes("超时")) {
        // 其他错误，显示提示并重置状态
        showToast({
          message: "网络错误，请重试",
          type: "fail",
        });
        resetResponseState();
      }
      throw error; // 重新抛出错误，让外层的 catch 处理
    }
    currentSpokenStream = null;

    // 流式请求结束后不再立即 flush，让定时器继续逐字渲染，保持打字机效果
    // 若在平板/移动端 setInterval 被节流，定时器会自然完成剩余渲染
    const remainingChars = accumulatedText.length - renderedTextLength;
    if (remainingChars > 0) {
    } else {
    }

    // 重要：流式请求 Promise resolve 后，等待更长时间（300ms），确保所有回调函数都已执行完
    // 因为 onload 事件处理剩余数据后，使用 setTimeout(0) 延迟 resolve，需要给回调函数时间处理所有数据
    // 同时，流式数据的处理是异步的，需要等待所有 onMessage 回调执行完成
    await new Promise((resolve) => setTimeout(resolve, 300));

    // 流式请求结束后，按标点符号分段发送缓冲区中剩余的文本到 TTS（如果有）
    if (ttsTextBuffer && ttsTextBuffer.trim().length > 0) {

      // 检查缓冲区是否包含标点符号（中英文标点符号：。！？，；：、. ! ? , ; :）
      const punctuationRegex = /[。！？，；：、.!,?;:]/;

      // 循环处理：只要缓冲区中有标点符号，就分段发送
      let hasPunctuation = true;
      while (hasPunctuation && ttsTextBuffer.trim().length > 0) {
        // 从前往后查找第一个标点符号的位置
        let firstPunctuationIndex = -1;
        for (let i = 0; i < ttsTextBuffer.length; i++) {
          if (punctuationRegex.test(ttsTextBuffer[i])) {
            firstPunctuationIndex = i;
            break;
          }
        }

        if (firstPunctuationIndex === -1) {
          // 没有找到标点符号，跳出循环
          hasPunctuation = false;
          break;
        }

        // 提取到第一个标点符号（包括标点）的文本
        const sentenceToSend = ttsTextBuffer.substring(
          0,
          firstPunctuationIndex + 1
        );
        // 保留标点符号之后的内容
        ttsTextBuffer = ttsTextBuffer.substring(firstPunctuationIndex + 1);

        // 分段发送这一句到 TTS
        if (sentenceToSend.trim().length > 0) {
          totalSentText += sentenceToSend;
          touchTtsActivity();
          convertTextChunkToAudio(
            sentenceToSend.trim(),
            String(Date.now() + Math.random())
          ).catch((err) => {
          });
        }
      }

      // 如果还有剩余文本（没有标点符号的），也发送（作为最后一段）
      if (ttsTextBuffer && ttsTextBuffer.trim().length > 0) {
        totalSentText += ttsTextBuffer;
        touchTtsActivity();
        convertTextChunkToAudio(
          ttsTextBuffer.trim(),
          String(Date.now() + Math.random())
        ).catch((err) => {
        });
        ttsTextBuffer = ""; // 清空缓冲区
      } else {
        ttsTextBuffer = ""; // 清空缓冲区
      }
    }

    // 累计发送的文本内容（用于音频完整性校验）
    sentTextTotal.value = totalSentText;

    // 等待 TTS 发送队列处理完成（最多等待 10 秒）
    let waitCount = 0;
    const maxWaits = 100; // 最多等待 10 秒
    while ((ttsSendQueue.length > 0 || isTtsSending) && waitCount < maxWaits) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      waitCount++;
      if (waitCount % 10 === 0) {
      }
    }
    if (ttsSendQueue.length > 0 || isTtsSending) {
    } else {
    }

    // 标记所有文本都已发送到 TTS（用于音频完整性校验）
    // 熄屏时音频禁用，不让 isTtsTextAllSent=true 造成 UI loading 长时间不回退
    isTtsTextAllSent.value = !isAudioBlockedWhileScreenOff;

    // 4. 流式请求结束后，启动音频接收超时机制（动态超时 + 双重校验）
    // 不再立即发送 finish，而是等待音频接收超时（动态超时内没收到新音频才发送 finish）
    // 这样可以确保所有音频都接收完成后再发送 finish

    // 如果已经有音频片段，立即启动倒计时
    if (allAudioBlobsForCurrentMessage.length > 0) {
      resetAudioReceiveTimeout();
    } else {
      // 如果没有音频片段，等待一下看是否有音频到达
      await new Promise((resolve) => setTimeout(resolve, 500));
      // 如果500ms后还是没有音频，启动倒计时（可能文本还在处理中）
      if (allAudioBlobsForCurrentMessage.length === 0) {
        resetAudioReceiveTimeout();
      } else {
        resetAudioReceiveTimeout();
      }
    }

    // 注意：不再在这里立即发送 finish，而是由音频接收超时机制自动发送（动态超时 + 双重校验）

    // 统一关闭本次所有文本转音频的连接（如果有）
    if (textToAudioRecordIds.length > 0) {
      for (const rid of textToAudioRecordIds) {
        try {
          await audioClose(rid, aiToken.value);
        } catch (e) {
        }
      }
    }
  } catch (error) {
    if (isManualStop || isStoppingAudio || isAbortError(error)) {
      isSendButtonProcessing.value = false;
      return;
    }
    showToast({
      message: "发送消息失败，请重试",
      type: "fail",
    });
    // 接口报错时，允许再次点击发送按钮
    isSendButtonProcessing.value = false;
    // 接口报错时，只有在音频不在播放时才自动开启录音
    setTimeout(() => {
      const isReallyStopped =
        !isPlayingAudio &&
        audioQueueLengthRef.value === 0;
      
    }, 500);
  } finally {
    // ✅ 安全 finish：等待发送队列清空后再发，避免最后一句音频被提前截断
    setTimeout(async () => {
      if (requestEpoch !== activeResponseEpoch) {
        return;
      }
      try {
        let waitCount = 0;
        while ((ttsSendQueue.length > 0 || isTtsSending) && waitCount < 30) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          waitCount++;
        }
        await new Promise((resolve) => setTimeout(resolve, 800));
        if (
          ttsWsManager &&
          ttsWsManager.isReady() &&
          ttsWsManager.isSessionStarted
        ) {
          await ttsWsManager.finish();
        }
      } catch (e) {
      }
    }, 0);

    // 确保 loading 状态被关闭
    if (isAiMessageChainMatched(aiMessageIndex, effectiveChainId, effectiveChatId) && chatList.value[aiMessageIndex]) {
      chatList.value[aiMessageIndex].loading = false;
    }
    isResponding.value = false;
    // 流式请求结束，如果音频不在播放中，允许再次点击发送按钮
    // 如果音频还在播放，等待音频播放完毕时再重置（在 setPlayingAudioState 中处理）
    if (
      !isPlayingAudio &&
      audioQueueLengthRef.value === 0
    ) {
      isSendButtonProcessing.value = false;
    }
    // 录音会话状态在 handleVoiceToTextAndSend / cleanupRecording 中统一管理

    // ✅ 流式结束时强制 flush 剩余文本，确保完整显示（后端已返回完整内容，避免渲染到一半停止）
    setTimeout(() => {
      if (isManualStop || isStoppingAudio) {
        return;
      }
      if (aiMessageIndex >= 0 && chatList.value[aiMessageIndex]) {
        flushTextRendering(aiMessageIndex, true);
      }
    }, 100);

    // ✅ 修改：文本渲染完成后，如果是手动暂停音频，开启录音（录音开始后会自动设置 isResponding = false）
    if (isManualStopAudioOnly && !textRenderTimer) {
      isManualStopAudioOnly = false;
      
      // 开启录音（录音开始后会自动设置 isResponding = false）
      if (
        currentChatId.value &&
        aiToken.value &&
        !isInSession.value
      ) {
        isResponding.value = false;
      } else {
        // 如果无法开启录音，设置 isResponding = false
        isResponding.value = false;
      }
    } else {
    }

    if (currentAiMessageIndex >= 0) {
    }
  }
}

// 请求录音权限（参考 VoicePop 的实现）
async function requestMicrophonePermission() {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: {
        sampleRate: 16000,
        channelCount: 1,
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
      },
    });
    // 权限获取成功，先关闭临时流（参考 VoicePop：权限检查后关闭流）
    stream.getTracks().forEach((track) => track.stop());
    return true;
  } catch (err) {
    // 用户拒绝权限时给出简单提示（参考 VoicePop 的错误处理）
    const isUserNotAllow =
      err.name === "NotAllowedError" || err.name === "PermissionDeniedError";
    if (isUserNotAllow) {
      errorMsg.value = "麦克风权限被拒绝";
      isInSession.value = false;
    } else {
      errorMsg.value = "录音权限获取失败";
      isInSession.value = false;
    }
    return false;
  }
}

// 停止录音（参考 VoicePop 的实现）
// 处理发送按钮点击
function handleSendButtonClick() {
  clearManualStopFlags();
  // ✅ 新增：检查对话是否已结束
  if (isDialogueEnded.value) {
    showToast({
      message: "对话已结束，请创建新对话",
      type: "fail",
    });
    return;
  }
  
  // 如果按钮被禁用，不执行任何操作
  if (isSendButtonDisabled.value) {
    return;
  }
  showTipsDialog.value = false;
  // ✅ 用户点击发送时清除15秒定时器（播放结束后才重新开始计时）
  clearNoActionTimer();
  
  // ✅ 关键修复：判断当前是否在录音中
  if (isInSession.value) {
    // 正在录音，点击发送按钮表示停止录音并发送
  // 点击后立即设置为处理中，禁止再次点击
  isSendButtonProcessing.value = true;
  // 调用原有的 stopRecording 函数
  stopRecording();
  } else {
    // ✅ 录音仅支持长按启用，点击不开启录音
    showToast({ message: "请长按麦克风按钮开始录音", type: "fail" });
  }
}

function stopRecording() {

  // 立即设置 isInSession 为 false，停止声波动画
  isInSession.value = false;
  // 停止波浪可视化
  stopRecordingWaveVisualization();
  // ✅ 修复：停止录音时不重置定时器，因为定时器应该从音频播放完成后开始计时
  // 如果用户只是短暂录音然后停止，不应该重置定时器
  // 定时器会在音频播放完成后重新启动

  // ✅ 修复：在停止前请求最后的数据，并等待一小段时间确保数据被收集
  if (mediaRecorder && mediaRecorder.state === "recording") {
    try {
      mediaRecorder.requestData(); // 请求最后的数据块
      
      // ✅ 关键修复：延迟停止，给 ondataavailable 事件时间触发
      setTimeout(() => {
        if (mediaRecorder && mediaRecorder.state !== "inactive") {
          mediaRecorder.stop();
        }
      }, 100); // 延迟100ms确保最后的数据块被收集
      
      return; // 提前返回，避免立即执行后续代码
    } catch (e) {
      // 继续执行下面的停止逻辑
    }
  }

  if (mediaRecorder && mediaRecorder.state !== "inactive") {
    try {
    mediaRecorder.stop();
    } catch (e) {
      mediaRecorder = null;
      // 停止失败时兜底释放麦克风，避免一直占用通话通道
      setTimeout(() => forceReleaseRecordingStreamForPlayback(), 300);
    }
  }

  // 清空临时引用；麦克风流在 mediaRecorder.onstop 中通过 forceReleaseRecordingStreamForPlayback 释放
  recordingStream = null;

  // 兜底：500ms 后释放麦克风（若 onstop 未触发时仍能释放，避免占用通话通道）
  setTimeout(() => forceReleaseRecordingStreamForPlayback(), 500);

  // 录音停止后，只有在不在响应中时才重新启动自动监听
  if (
    shouldSaveRecording &&
    !isPlayingAudio &&
    !isResponding.value &&
    currentChatId.value &&
    aiToken.value
  ) {
    setTimeout(() => {
      const isReallyStopped =
        !isPlayingAudio &&
        audioQueueLengthRef.value === 0;
      
      if (
        isReallyStopped &&
        !isInSession.value &&
        !isResponding.value &&
        currentChatId.value &&
        aiToken.value
      ) {
      } else {
      }
    }, 1000);
  } else if (!shouldSaveRecording) {
  }
}

// 结束录音（修改原有的 stopSession）
async function stopRecordingSession() {
  // 先停止录音器，这会触发 onstop 事件（参考 VoicePop：调用 stopRecording）
  stopRecording();

  // 如果正在响应，停止流式请求
  if (currentSpokenStream && typeof currentSpokenStream.abort === "function") {
    currentSpokenStream.abort();
    currentSpokenStream = null;
  }

  isResponding.value = false;

  // ===== 手动结束对话：结束长连接 + 关闭对话 =====
  // 1）停止 TTS finish 定时器
  if (ttsFinishTimer) {
    clearTimeout(ttsFinishTimer);
    ttsFinishTimer = null;
  }

  // 2）通知服务端本次 TTS 会话结束，并关闭 WebSocket 长连接
  try {
    if (ttsWsManager && ttsWsManager.isReady()) {
      ttsWsManager.finish();
    }
  } catch (e) {
  }

  if (ttsWsManager) {
    try {
      ttsWsManager.close();
    } catch (e) {
    } finally {
      ttsWsManager = null;
    }
  }

  // 3）清理本地音频播放资源
  cleanupAudioPlayback();

  // 4）调用 closeChat 主动关闭当前对话（如果有）
  if (currentChatId.value && aiToken.value) {
    try {
      await closeChat(currentChatId.value, aiToken.value);
    } catch (e) {
    }
  }

  // 标记会话已结束
  isInSession.value = false;
}

// 停止录音（仅停止录音，不关闭对话和长连接）
function handleStopRecording() {
  // 只调用停止录音函数，停止录音后会触发 onstop 事件，自动处理后续流程
  stopRecording();
}
async function openDialogBox() {
  // ✅ 检查：如果还没有进入对话，不允许打开对话框
  if (!currentChatId.value) {
    return;
  }

  // 1. 先立即显示对话框，提升用户体验
  showDialogBox.value = true;

  // 2. 立即恢复 AudioContext（用户交互时恢复，后续可以自动播放）
  try {
    // ✅ 已禁用：不再使用 AudioBufferManager 和 Web Audio API
    // 改用 HTML5 Audio，不需要恢复 AudioContext
  } catch (err) {
  }

  // 3. 延迟滚动到底部，确保 DOM 已渲染
  nextTick(() => {
    scrollBoxToBottom();
  });
}

// 发送初始消息到 TTS WebSocket（在 TTS 连接成功后调用）
async function sendInitialMessagesToTts() {
  if (
    !currentChatId.value ||
    !aiToken.value ||
    !ttsWsManager ||
    !ttsWsManager.isReady()
  ) {
    // 如果条件不满足，重置思考状态
    isResponding.value = false;
    return;
  }

  // ✅ 修改：开始发送初始消息时，确保显示思考状态
  isResponding.value = true;

  // ✅ 仅在“创建对话”的这次初始发送期间：等待 complete 再开始播放第一句音频
  // 后续音频（对话进行中）不需要这个处理
  waitForInitialCompleteBeforePlay = true;
  if (initialCompleteFallbackTimer) {
    clearTimeout(initialCompleteFallbackTimer);
    initialCompleteFallbackTimer = null;
  }


  // 处理初始消息：如果有 AI 消息，通过 TTS WebSocket 发送
  if (chatList.value && chatList.value.length > 0) {
    // 找到所有 AI 消息（检查 content 或 originalContent）
    const aiMessages = chatList.value.filter((msg) => {
      return msg.role === "ai" && (msg.content || msg.originalContent);
    });

    if (aiMessages.length > 0) {

      // 再次确认 WebSocket 状态（双重检查）
      if (!ttsWsManager.ws || ttsWsManager.ws.readyState !== WebSocket.OPEN) {
        return;
      }

      if (!ttsWsManager.isSessionStarted) {
        return;
      }

      // 记录所有需要发送的文本（用于校验）
      let totalTextToSend = "";
      const textsToSend = [];

      // 遍历所有 AI 消息，收集需要发送的文本
      for (let i = 0; i < aiMessages.length; i++) {
        const msg = aiMessages[i];
        const messageIndex = chatList.value.indexOf(msg);

        if (messageIndex !== -1) {
          // 优先使用 originalContent（新建对话时），否则使用 content（已渲染的）
          const messageText = msg.originalContent || msg.content || "";

          if (messageText.trim()) {
            // 清理文本（去掉表情等）
            const cleanText = sanitizeTextForTts(messageText);

            if (cleanText.trim()) {
              textsToSend.push({
                text: cleanText.trim(),
                messageIndex: messageIndex,
              });
              totalTextToSend += cleanText.trim();
            }
          }
        }
      }

      if (textsToSend.length === 0) {
        return;
      }


      // 重置 TTS 发送相关的跟踪变量
      sentTextTotal.value = "";

      // 遍历所有收集到的文本，通过 TTS WebSocket 发送
      for (let i = 0; i < textsToSend.length; i++) {
        const { text, messageIndex } = textsToSend[i];

        // 设置当前正在处理的 AI 消息索引（用于缓存音频）
        currentAiMessageIndex = messageIndex;
        // 确保该消息有 audioBlobs 数组
        if (!chatList.value[messageIndex].audioBlobs) {
          chatList.value[messageIndex].audioBlobs = [];
        }

        // 如果是第一条消息，重置当前消息的音频片段缓存
        if (i === 0) {
          allAudioBlobsForCurrentMessage = [];
        }


        // 累计发送的文本长度（用于校验）
        sentTextTotal.value += text;

        // 将文本加入 TTS 发送队列
        touchTtsActivity();
        convertTextChunkToAudio(text, String(Date.now() + Math.random())).catch(
          (err) => {
          }
        );

        // 发送完成后，清除 originalContent（避免重复发送）
        if (
          chatList.value[messageIndex] &&
          chatList.value[messageIndex].originalContent
        ) {
          delete chatList.value[messageIndex].originalContent;
        }
      }


      // 等待 TTS 发送队列处理完成（确保所有文本都已发送到服务端）
      let queueWaitCount = 0;
      const maxQueueWaits = 200; // 最多等待 20 秒（确保长文本也能发送完成）
      while (
        (ttsSendQueue.length > 0 || isTtsSending) &&
        queueWaitCount < maxQueueWaits
      ) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        queueWaitCount++;
        if (queueWaitCount % 20 === 0) {
        }
      }

      // 校验：检查发送的文本长度是否与预期一致
      const sentLength = sentTextTotal.value.length;
      const expectedLength = totalTextToSend.length;
      if (sentLength !== expectedLength) {
      } else {
      }

      // 等待 TTS WebSocket 内部队列清空（如果存在）
      if (ttsWsManager.pendingTexts && ttsWsManager.pendingTexts.length > 0) {
        let internalQueueWaitCount = 0;
        const maxInternalQueueWaits = 100; // 最多等待 10 秒
        while (
          internalQueueWaitCount < maxInternalQueueWaits &&
          ttsWsManager.pendingTexts &&
          ttsWsManager.pendingTexts.length > 0
        ) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          internalQueueWaitCount++;
        }
        if (ttsWsManager.pendingTexts && ttsWsManager.pendingTexts.length > 0) {
        } else {
        }
      }

      // 再等待 500ms 确保所有文本都已发送到服务端，然后发送 finish
      await new Promise((resolve) => setTimeout(resolve, 500));

      // 再次确认会话已开始，避免在 start 之前就发送 finish
      if (
        ttsWsManager &&
        ttsWsManager.isReady() &&
        ttsWsManager.isSessionStarted
      ) {
        try {
          await ttsWsManager.finish();

          // 发送 finish 后，等待一段时间让音频片段到达并处理
          await new Promise((resolve) => setTimeout(resolve, 2000));

          // ✅ complete 到达前：不做任何“合并并播放”的兜底操作
          // 避免首句音频播放过早导致第一段-第二段卡顿

          // 保险兜底：如果 complete 没触发，最长等到 8 秒后再播放
          initialCompleteFallbackTimer = setTimeout(() => {
            if (!waitForInitialCompleteBeforePlay) return;
            waitForInitialCompleteBeforePlay = false;
            initialCompleteFallbackTimer = null;

            if (pendingAudioBlobs.length > 0 && !isPlayingAudio) {
              mergeAndPlayPendingBlobs(true);
            }
          }, 8000);
        } catch (e) {
        }
      } else {
      }
    } else {
    }
  }
}

// 滚动对话框聊天列表到底部
function scrollBoxToBottom() {
  if (boxChatListRef.value) {
    boxChatListRef.value.scrollTop = boxChatListRef.value.scrollHeight;
  }
}

// 监听 chatList 变化，自动滚动到底部
watch(
  () => chatList.value,
  () => {
    if (showDialogBox.value) {
      nextTick(() => {
        scrollBoxToBottom();
      });
    }
  },
  { deep: true }
);

// 清除15秒无操作定时器
function clearNoActionTimer() {
  if (noActionTimer) {
    clearTimeout(noActionTimer);
    noActionTimer = null;
  }
  isRecordingStarted = false;
}

// 闲置语音计时器回调（提取为独立函数，便于暂停后恢复时复用）
function executeNoActionTimerCallback() {
  // 遇到之前问题：用户刚手动暂停时，不播放闲置音频（防止暂停后立马播放）
  if (isManualStop || isStoppingAudio) return;

  const hasOtherAudioPlaying = isPlayingAudio || audioQueueLengthRef.value > 0 || pendingMergeCount > 0 || pendingAudioBlobs.length > 0;
  const hasStartedRecording = isInSession.value;
  const isRequesting = isResponding.value;
  const hasChatId = currentChatId.value;

  if (hasChatId && !hasOtherAudioPlaying && !hasStartedRecording && !isRequesting) {
    (async () => {
      if (isInSession.value) {
        shouldSaveRecording = false;
        stopRecording();
      }
      isRecordingStarted = false;

      forceReleaseRecordingStreamForPlayback();

      if (window.android && typeof window.android.callNative === "function") {
        try {
          window.android.callNative(JSON.stringify({ func: "getResetAudio" }));
        } catch (e) {
        }
      }

      await new Promise((r) => setTimeout(r, 2000));

      if (isManualStop || isStoppingAudio || isInSession.value || isPlayingAudio || audioQueueLengthRef.value > 0 || pendingMergeCount > 0 || pendingAudioBlobs.length > 0 || isResponding.value) {
        return;
      }

      const tipAudioFiles = getNoActionTipAudioFiles();
      const tipAudioFile = tipAudioFiles[noActionTipAudioIndex.value];
      playTipAudio(tipAudioFile, 'noAction').catch(err => {
      });
    })();
  } else {
    if (!hasChatId) {
    } else if (hasOtherAudioPlaying) {
    } else if (hasStartedRecording) {
    } else if (isRequesting) {
    }
  }
}

// 启动闲置语音计时器（支持自定义时长，用于熄屏恢复时按剩余时间继续倒计时）
function startNoActionTimerWithDuration(durationMs) {
  if (!currentChatId.value || durationMs <= 0) return;
  // ✅ 正在录音时不启动，避免「录音时闲置语音一起倒计时」
  if (isInSession.value) return;
  noActionTimerStartTime = Date.now();
  noActionTimerDuration = durationMs;
  noActionTimer = setTimeout(executeNoActionTimerCallback, durationMs);
}

// 启动15秒无操作定时器（仅在播放结束后调用，15秒内无操作则播放闲置语音）
function resetNoActionTimer() {
  clearNoActionTimer();
  startNoActionTimerWithDuration(NO_ACTION_TIMER_DURATION);
}

// 启动15秒无操作定时器（已废弃：改为仅在播放结束后才启动定时器）
function startNoActionTimer() {
  // ✅ 用户开始录音时清除定时器（播放结束后才重新开始计时）
  clearNoActionTimer();
}

// ✅ 修复：监听录音开始，当用户长按录音时重置15秒定时器
watch(
  () => [isInSession.value, isShowVoice.value],
  ([newIsInSession, newIsShowVoice], [oldIsInSession, oldIsShowVoice]) => {
    // 如果录音刚刚开始（从 false 变为 true），清除15秒定时器
    if ((newIsInSession && !oldIsInSession) || (newIsShowVoice && !oldIsShowVoice)) {
      clearNoActionTimer();
    }
    
    // ✅ 修复：录音停止时不重置定时器，因为定时器应该从音频播放完成后开始计时
    // 如果用户只是短暂录音然后停止，不应该重置定时器
    // 定时器会在音频播放完成后重新启动
  }
);

// ✅ 修复：监听 currentChatId，当退出对话时清除定时器（不再在进入对话时启动定时器，应该从音频播放完成后开始计时）
watch(
  () => currentChatId.value,
  (newChatId, oldChatId) => {
    // 如果退出对话（从有值变为空），清除定时器
    if (!newChatId && oldChatId) {
      clearNoActionTimer();
    }
    // ✅ 修复：不再在进入对话时自动启动定时器，应该从音频播放完成后开始计时
  }
);

// 熄屏期间禁止启动闲置倒计时后：当 isResponding 变为 false 时补启动
watch(
  () => isResponding.value,
  (newIsResponding) => {
    // 熄屏硬中断后，文本输出结束时强制回收 loading 状态，避免一直“正在加载中”
    if (!newIsResponding && isTtsHardInterruptedWhileScreenOff) {
      const hasAudioPending = isPlayingAudioRef.value || audioQueueLengthRef.value > 0 || pendingAudioBlobs.length > 0 || pendingMergeCount > 0;
      if (!hasAudioPending && !isInSession.value) {
        isTtsTextAllSent.value = false;
      }
    }
    if (!newIsResponding && shouldScheduleNoActionTimerAfterScreenOff) {
      if (!isInSession.value && currentChatId.value && aiToken.value) {
        shouldScheduleNoActionTimerAfterScreenOff = false;
        resetNoActionTimer();
      }
    }
  }
);

watch(
  () => [isResponding.value, isTtsTextAllSent.value],
  () => {
    // 熄屏硬中断后：任何异步回调回写 loading 态都立即回收，避免亮屏后一直“正在加载中”
    if (!isTtsHardInterruptedWhileScreenOff) return;
    if (isResponding.value) {
      isResponding.value = false;
    }
    if (isTtsTextAllSent.value) {
      isTtsTextAllSent.value = false;
    }
    clearAiLoadingStates();
    removeEmptyAiLoadingMessages();
  }
);
// 进入对话按钮点击处理函数
// options.fromTemplateSwitch: 为 true 时来自模板切换，不播欢迎音、不播队列残留，只播新对话首句
async function handleEnterConversation(options = {}) {
  clearManualStopFlags();
  const fromTemplateSwitch = !!options.fromTemplateSwitch;

  // 新的用户交互开始：解除熄屏期间的音频禁用
  if (isAudioBlockedWhileScreenOff) {
    isAudioBlockedWhileScreenOff = false;
  }
  if (isTtsHardInterruptedWhileScreenOff) {
    isTtsHardInterruptedWhileScreenOff = false;
  }

  // ✅ 新增：重置对话结束标志（创建新对话）
  isDialogueEnded.value = false;

  // ✅ 模板切换后：强制清空音频，确保只播新对话首句，避免旧音频/欢迎音混入
  if (fromTemplateSwitch) {
    if (audioPlayer.value) {
      try {
        audioPlayer.value.pause();
        audioPlayer.value.currentTime = 0;
        audioPlayer.value.src = "";
      } catch (e) { /* ignore */ }
    }
    audioQueue = [];
    isPlayingAudio = false;
    if (queueMergeTimeout) {
      clearTimeout(queueMergeTimeout);
      queueMergeTimeout = null;
    }
    if (preloadAudio) preloadAudio.src = "";
    pendingAudioBlobs = [];
    if (pendingMergeTimeout) {
      clearTimeout(pendingMergeTimeout);
      pendingMergeTimeout = null;
    }
    cleanupTipAudio();
  }

  // ✅ 用户交互后，尝试播放待播放的提示音频（模板切换时不播队列残留）
  if (!fromTemplateSwitch && audioQueue.length > 0 && !isPlayingAudio && audioPlayer.value) {
    const firstItem = audioQueue[0];
    const isUrl = typeof firstItem === "string" && firstItem.startsWith("blob:");
    if (isUrl) {
      if (!audioPlayer.value.src) {
        audioPlayer.value.src = firstItem;
      }
      applyUnifiedAudioSettings(audioPlayer.value);
      if (audioPlayer.value.src && audioPlayer.value.src.startsWith("blob:")) {
        try {
          await audioPlayer.value.play();
          isPlayingAudio = true;
          if (isTipAudioMode) isPlayingTipAudio = true;
          updateAudioStateRefs();
          updatePlaybackStatus();
        } catch (error) {
          // 播放失败，继续正常的进入对话流程
        }
      }
    } else {
      // MediaSource 模式：通过 playNextAudio 播放
      initAudioPlayer();
      playNextAudio();
    }
  }

  // ✅ 修改：立即设置状态，显示"思考中"
  isEnteringConversation.value = true;
  isResponding.value = true;

  isTemplateSwitching.value = false;
  if (fromTemplateSwitch) {
    skipWelcomeForNextConnection = true; // 本次连接不播欢迎音、只播新对话首句
  }
  try {
    // 0. ✅ 激活媒体通道，确保后续 TTS 使用媒体音量播放
    await ensureMediaChannelActive(true);

    // 1. 创建新对话（麦克风延后到用户长按录音时再初始化，避免页面一直显示调用麦克风）
    try {
      // ✅ 检查是否是主题对话模板（promptId == 17，使用宽松比较兼容字符串）
      if (promptId.value == 17) {
        
        const params = {
          theme: "机场问路",
          nickname: userInfo.value?.nickname || "小米",
          gradeId: gradeId.value || "1"
        };
        
        
        const res = await newThemeChat(params, aiToken.value);
        
        
        if ((res.code === 200 || res.code === 0) && res.data) {
          // 处理返回的对话数据
          currentChatId.value = res.data.id || "";
          
          // ✅ 设置主题对话模式标志
          isThemeChat.value = true;
          isFirstUserMessage.value = true;
          
          
          // 清空现有的 chatList
          chatList.value = [];
          
          // 将返回的消息数据映射到 chatList
          if (res.data.messages && Array.isArray(res.data.messages) && res.data.messages.length > 0) {
            chatList.value = res.data.messages.map((msg, index) => {
              const role = (msg.role || "").toLowerCase();
              const normalizedRole = role === "user" ? "user" : "ai";
              const messageContent = msg.context || "";
              return {
                role: normalizedRole,
                content: "",
                renderedContent: "",
                originalContent: messageContent,
                audioBlobs: [],
              };
            });
            
            
            // 对每条消息进行逐字渲染
            nextTick(() => {
              chatList.value.forEach((msg, index) => {
                if (msg.originalContent && msg.originalContent.trim()) {
                  addTextToRenderQueue(msg.originalContent, index);
                }
              });
            });
            
            // ✅ 主题对话：newThemeChat 接口调用成功后，标记需要发送消息到TTS
            // 注意：不在接口成功后立即初始化TTS，而是在步骤3和步骤4中统一处理
            const aiMessages = chatList.value.filter(
              (msg) => msg.role === "ai" && (msg.originalContent || msg.content)
            );
            if (aiMessages.length > 0) {
              shouldAutoSendInitialMessages = true;
              template17InitialSent = false; // 新建对话，重置互斥标志
            }
          }
        } else {
          isEnteringConversation.value = false;
          isResponding.value = false;
          showToast({
            message: "创建主题对话失败，请重试",
            type: "fail",
          });
          return;
        }
      } else {
        // 普通对话
        await newDialogue(planId.value ? planId.value : tutoringId.value);
      }
      
      if (!currentChatId.value) {
        // ✅ 修改：失败时重置状态，重新显示按钮
        isEnteringConversation.value = false;
        isResponding.value = false;
        showToast({
          message: "创建对话失败，请重试",
          type: "fail",
        });
        return;
      }
      
      // ✅ 新增：创建对话后，检查是否有AI消息需要发送到TTS，设置标志
      const hasAiMessages = chatList.value && chatList.value.some(
        (msg) => msg.role === "ai" && (msg.originalContent || msg.content)
      );
      if (hasAiMessages && !shouldAutoSendInitialMessages) {
        shouldAutoSendInitialMessages = true;
      }
    } catch (error) {
      // ✅ 修改：失败时重置状态，重新显示按钮
      isEnteringConversation.value = false;
      isResponding.value = false;
      showToast({
        message: "创建对话失败，请重试",
        type: "fail",
      });
      return;
    }

    // 3. 连接 TTS WebSocket（等待连接成功并 start）
    try {
      let ttsConnected = false;

      // ✅ 修改：优先复用现有的 TTS WebSocket
      if (ttsWsManager && ttsWsManager.ws && ttsWsManager.ws.readyState === WebSocket.OPEN) {
        
        // 如果会话未启动，重新启动会话
        if (!ttsWsManager.isSessionStarted) {
          try {
            await ttsWsManager.connect(true); // 新建对话，发送 finish 关闭旧 ttsSessionId
          } catch (error) {
          }
        }
        
        ttsConnected = true;
      } else if (!ttsWsManager || !ttsWsManager.isReady()) {
        // TTS WebSocket 不存在或连接异常，需要重新创建
        
        // 清理旧连接
        if (ttsWsManager) {
          try {
            ttsWsManager.close();
          } catch (e) {
            // 忽略关闭错误
          }
          ttsWsManager = null;
        }
        
        // 重置 finish 标志
        isFinishSuccess.value = false;
        await initTtsWebSocket(true); // 新建对话，发送 finish 关闭旧 ttsSessionId

        // 等待 TTS WebSocket 连接就绪（确保 session_started 已收到）
        let retryCount = 0;
        const maxRetries = 50; // 最多等待 5 秒
        while (
          retryCount < maxRetries &&
          (!ttsWsManager ||
            !ttsWsManager.ws ||
            ttsWsManager.ws.readyState !== WebSocket.OPEN ||
            !ttsWsManager.isSessionStarted)
        ) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          retryCount++;
          if (retryCount % 5 === 0) {
          }
        }

        if (
          ttsWsManager &&
          ttsWsManager.ws &&
          ttsWsManager.ws.readyState === WebSocket.OPEN &&
          ttsWsManager.isSessionStarted
        ) {
          ttsConnected = true;
        } else {
          // ✅ 修改：失败时重置状态，重新显示按钮 - 隐藏 TTS toast
          isEnteringConversation.value = false;
          isResponding.value = false;
          return;
        }
      } else {
        ttsConnected = true;
      }

      // 4. TTS 连接成功后，如果标记为需要自动发送初始消息，手动发送一次
      // 这样可以处理 onConnected 回调可能已经错过的情况
      if (
        ttsConnected &&
        currentChatId.value &&
        shouldAutoSendInitialMessages
      ) {
        // 如果连接已经就绪且会话已启动，手动发送一次
        if (
          ttsWsManager &&
          ttsWsManager.isReady() &&
          ttsWsManager.isSessionStarted
        ) {
          
          // ✅ 新增：模板17使用一次性全部发送逻辑
          if (promptId.value == 17 && isThemeChat.value) {
            if (!template17InitialSent) {
              template17InitialSent = true;
              shouldAutoSendInitialMessages = false;
              const aiMessages = chatList.value.filter(
                (msg) => msg.role === "ai" && (msg.originalContent || msg.content)
              );
              if (aiMessages.length > 0) {
                const fullText = aiMessages
                .map(msg => msg.originalContent || msg.content)
                .join(" ");
              const cleanText = sanitizeTextForTts(fullText);
              
              if (cleanText && cleanText.trim()) {
                // 清空音频状态
                pendingAudioBlobs = [];
                allAudioBlobsForCurrentMessage = [];
                clearAudioChunkIndexTracking();
                
                currentAiMessageIndex = chatList.value.findIndex(msg => msg.role === "ai");
                
                // ✅ 修改：一次性全部发送，不分割
                await convertTextChunkToAudio(cleanText.trim(), String(Date.now() + Math.random()));
                touchTtsActivity();
                
                let initWaitCount = 0;
                while ((ttsSendQueue.length > 0 || isTtsSending) && initWaitCount < 150) {
                  await new Promise((resolve) => setTimeout(resolve, 100));
                  initWaitCount++;
                }
                
                isTtsTextAllSent.value = true;
                resetTemplate17AudioTimeout();
                
                await new Promise((resolve) => setTimeout(resolve, 400));
                
                if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
                  try {
                    await ttsWsManager.finish();
                  } catch (finishError) {
                  }
                }
              }
            }
            }
          } else {
            // 普通对话使用标准发送逻辑
          await sendInitialMessagesToTts();
          shouldAutoSendInitialMessages = false;
          }
        } else if (ttsWsManager && ttsWsManager.isReady() && !ttsWsManager.isSessionStarted) {
          // 如果连接已就绪但会话未启动，先启动会话
          try {
            await ttsWsManager.connect();
            
            // ✅ 新增：模板17使用一次性全部发送逻辑
            if (promptId.value == 17 && isThemeChat.value) {
              if (!template17InitialSent) {
                template17InitialSent = true;
                const aiMessages = chatList.value.filter(
                  (msg) => msg.role === "ai" && (msg.originalContent || msg.content)
                );
              if (aiMessages.length > 0) {
                shouldAutoSendInitialMessages = false;
                const fullText = aiMessages
                  .map(msg => msg.originalContent || msg.content)
                  .join(" ");
                const cleanText = sanitizeTextForTts(fullText);
                
                if (cleanText && cleanText.trim()) {
                  // 清空音频状态
                  pendingAudioBlobs = [];
                  allAudioBlobsForCurrentMessage = [];
                  clearAudioChunkIndexTracking();
                  
                  currentAiMessageIndex = chatList.value.findIndex(msg => msg.role === "ai");
                  
                  // ✅ 修改：一次性全部发送，不分割
                  await convertTextChunkToAudio(cleanText.trim(), String(Date.now() + Math.random()));
                  touchTtsActivity();
                  
                  let initWaitCount2 = 0;
                  while ((ttsSendQueue.length > 0 || isTtsSending) && initWaitCount2 < 150) {
                    await new Promise((resolve) => setTimeout(resolve, 100));
                    initWaitCount2++;
                  }
                  
                  isTtsTextAllSent.value = true;
                  resetTemplate17AudioTimeout();
                  
                  await new Promise((resolve) => setTimeout(resolve, 400));
                  
                  if (ttsWsManager && ttsWsManager.isReady() && ttsWsManager.isSessionStarted) {
                    try {
                      await ttsWsManager.finish();
                    } catch (finishError) {
                    }
                  }
                }
              }
              }
            } else {
              // 普通对话使用标准发送逻辑
              await sendInitialMessagesToTts();
              shouldAutoSendInitialMessages = false;
            }
          } catch (error) {
          }
        } else {
        }
      }

      // 创建对话后，滚动到底部（确保新消息显示）
      nextTick(() => {
        scrollBoxToBottom();
      });
    } catch (error) {
      // ✅ 修改：失败时重置状态，重新显示按钮 - 隐藏 TTS toast
      isEnteringConversation.value = false;
      isResponding.value = false;
      return;
    }

    // ✅ 修改：成功完成所有步骤后，重置进入对话状态（此时 currentChatId 已设置，会显示正常状态）
    isEnteringConversation.value = false;

    // ✅ 不再在进入对话时预初始化麦克风，仅播放结束或用户长按时才创建
  } catch (error) {
    // ✅ 修改：失败时重置状态，重新显示按钮
    isEnteringConversation.value = false;
    isResponding.value = false;
    showToast({
      message: "进入对话失败，请重试",
      type: "fail",
    });
  }
}

// 初始化当前对话（调用 newChat 接口创建新对话）
// sendToTts: 是否在创建对话后立即发送消息到 TTS（默认 false，由 openDialogBox 控制流程）
async function newDialogue(arg, sendToTts = false) {
  if (arg) {
    tutoringId.value = arg;
    planId.value = arg;
  }

  // 如果没有 aiToken，无法创建对话
  if (!aiToken.value) {
    return;
  }

  // ✅ 新增：新建对话时，打断闲置的提示音频
  if (isTipAudioMode || isPlayingTipAudio) {
    stopAIAudioPlayback();
  }


  // 如果已经有对话ID，先关闭原有的 WebSocket 和对话
  if (currentChatId.value) {

    // 1. 关闭 TTS WebSocket 连接
    if (ttsWsManager) {
      try {
        if (ttsWsManager.isReady()) {
          ttsWsManager.finish();
        }
        ttsWsManager.close();
        ttsWsManager = null;
      } catch (e) {
      }
    }

    // 2. 调用 closeChat 关闭原有对话
    try {
      await closeChat(currentChatId.value, aiToken.value);
    } catch (e) {
    }

    // 3. 清理本地状态
    cleanupAudioPlayback();
    cleanupRecording();

    // 4. 清空对话ID，准备创建新对话
    currentChatId.value = "";
    // 清空对话ID后，停止自动监听
    stopAutoVolumeMonitoring();
    chatList.value = [];
    
    // ✅ 重置主题对话标志
    isThemeChat.value = false;
    isFirstUserMessage.value = true;
  }

  // 调用 newChat 接口创建新对话
  const params = {
    modelType: 0, // 0文本对话模型 1视觉模型
    promptId: promptId.value, // 模板Id（可选）
    message: "", // 消息内容（可选）
    nickname: userInfo.value?.nickname || "", // 昵称（可选）
    grade:
      gradeId.value||"1", // 年级（可选，1、2、3、4、5、6）
  };

  try {
    const res = await newChat(params, aiToken.value);
    if ((res.code === 200 || res.code === 0) && res.data) {
      currentChatId.value = res.data.id || "";

      // ✅ 修复：非模板17时，明确设置 isThemeChat = false
      // 避免之前是模板17时状态残留，导致非模板17也走主题对话逻辑
      if (promptId.value != 17) {
        isThemeChat.value = false;
      }

      // ✅ 修改：创建对话成功后，不立即开启录音
      // 应该等待第一段音频播放完成后才开启录音（由音频播放完成的回调处理）

      // 新建对话时清空本地所有音频相关状态，确保重新获取并播放本轮内容
      try {
        // 清理播放中的音频与队列
        cleanupAudioPlayback();
        // 额外清空音频片段缓存与音频队列
        allAudioBlobsForCurrentMessage = [];
        isPlayingAudio = false;
        audioQueue = [];
        updatePlaybackStatus();
      } catch (e) {
      }

      // 将返回的消息数据映射到 chatList
      // 注意：后端 role 和 context 字段写反了，需要反着来取
      if (
        res.data.messages &&
        Array.isArray(res.data.messages) &&
        res.data.messages.length > 0
      ) {
        // 清空现有的 chatList，使用后端返回的消息
        chatList.value = res.data.messages.map((msg, index) => {
          // 后端写反了，用 context 字段来判断角色
          // role 可能是 "user"/"USER" 或 "ai"/"AI"/"assistant" 等
          const role = (msg.context || "").toLowerCase();
          // 统一角色标识：如果是 user 相关，标记为 "user"，否则标记为 "ai"
          const normalizedRole = role === "user" ? "user" : "ai";
          const messageContent = msg.role || ""; // 后端写反了，用 role 字段来获取内容
          return {
            role: normalizedRole,
            content: "", // 先清空内容，后续通过逐字渲染显示
            renderedContent: "", // 渲染后的 HTML 内容
            originalContent: messageContent, // 保存原始内容，用于逐字渲染
            audioBlobs: [], // 初始化音频缓存数组
          };
        });

        // 对每条消息进行逐字渲染（延迟执行，确保 DOM 已渲染）
        nextTick(() => {
          chatList.value.forEach((msg, index) => {
            if (msg.originalContent && msg.originalContent.trim()) {
              // 使用逐字渲染显示原始内容
              addTextToRenderQueue(msg.originalContent, index);
              // 注意：不在这里删除 originalContent，等 TTS 发送完成后再删除（在 sendInitialMessagesToTts 中处理）
            }
          });
        });

        // 检查是否有 AI 消息需要发送到 TTS
        const hasAiMessages = chatList.value.some(
          (msg) => msg.role === "ai" && (msg.originalContent || msg.content)
        );
        if (hasAiMessages) {
          // 标记需要在 TTS 连接成功后自动发送初始消息
          shouldAutoSendInitialMessages = true;
          // ✅ 修改：创建对话后，立即显示思考状态
          isResponding.value = true;
        }
      }

      // 4. 如果 sendToTts 为 true，创建新对话成功后，处理初始消息：如果有 AI 消息，通过 TTS WebSocket 发送
      // 注意：现在默认 sendToTts 为 false，由 openDialogBox 控制流程
      // 但如果初始消息加载时 TTS 已连接，上面已经发送了，这里就不需要再发送
      if (
        sendToTts &&
        currentChatId.value &&
        aiToken.value &&
        ttsWsManager &&
        ttsWsManager.isReady() &&
        ttsWsManager.isSessionStarted
      ) {
        // 检查是否已经有初始消息且已发送（避免重复发送）
        const hasInitialAiMessages =
          chatList.value &&
          chatList.value.some((msg) => msg.role === "ai" && msg.content);
        if (hasInitialAiMessages) {
          // 检查是否已经发送过（通过检查 audioBlobs 是否已有数据）
          const hasSent = chatList.value.some(
            (msg) =>
              msg.role === "ai" && msg.audioBlobs && msg.audioBlobs.length > 0
          );
          if (!hasSent) {
            await sendInitialMessagesToTts();
          } else {
          }
        }
      }
    } else {
      showToast({
        message: "创建新对话失败，请重试",
        type: "fail",
      });
    }
  } catch (error) {
    // 检测跨域错误
    if (
      error instanceof TypeError &&
      (error.message.includes("Failed to fetch") ||
        error.message.includes("NetworkError") ||
        error.message.includes("Network request failed"))
    ) {
      showToast({
        message: "网络错误，请检查网络连接",
        type: "fail",
      });
    } else {
      showToast({
        message: "创建新对话失败，请重试",
        type: "fail",
      });
    }
  }
}

// ✅ Android平板音频通道修复：使用 Web Audio API 生成无声音频（更兼容）
function createSilentAudioBlob() {
  try {
    // 使用 Web Audio API 创建一个极短的无声音频（1秒，16kHz采样率）
    const sampleRate = 16000;
    const duration = 0.1; // 0.1秒
    const length = sampleRate * duration;
    const audioContext = new (window.AudioContext || window.webkitAudioContext)({
      latencyHint: "playback",
    });
    
    const buffer = audioContext.createBuffer(1, length, sampleRate);
    // 数据已经是0（静音），不需要填充
    
    // 转换为 WAV Blob
    const wavLength = 44 + length * 2;
    const arrayBuffer = new ArrayBuffer(wavLength);
    const view = new DataView(arrayBuffer);
    
    // WAV 文件头
    const writeString = (offset, string) => {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    };
    
    writeString(0, 'RIFF');
    view.setUint32(4, wavLength - 8, true);
    writeString(8, 'WAVE');
    writeString(12, 'fmt ');
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, 1, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * 2, true);
    view.setUint16(32, 2, true);
    view.setUint16(34, 16, true);
    writeString(36, 'data');
    view.setUint32(40, length * 2, true);
    
    // 音频数据已经是0，不需要写入
    
    return new Blob([arrayBuffer], { type: 'audio/wav' });
  } catch (error) {
    return null;
  }
}

// ✅ Android平板音频通道修复：激活媒体通道（关键步骤）
async function activateMediaChannel() {
  // 如果已经激活，直接返回
  if (mediaChannelActivated) {
    return Promise.resolve(true);
  }
  
  // ✅ Android：先调用 getResetAudio 重置音频模式，避免无录音时 TTS 仍走通话通道
  if (window.android && typeof window.android.callNative === "function") {
    try {
      window.android.callNative(JSON.stringify({ func: "getResetAudio" }));
    } catch (e) {
    }
  }
  
  return new Promise((resolve) => {
    try {
      // 创建极短的无声音频
      if (!mediaChannelActivator) {
        mediaChannelActivator = new Audio();
        
        // ✅ 平板修复：为激活器设置媒体通道属性，确保使用媒体音量而非通话音量
        applyUnifiedAudioSettings(mediaChannelActivator, { volume: 0.001 });
        const silentBlob = createSilentAudioBlob();
        if (silentBlob) {
          const silentUrl = URL.createObjectURL(silentBlob);
          mediaChannelActivator.src = silentUrl;
        } else {
          mediaChannelActivated = true;
          resolve(true);
          return;
        }
      }
      
      // 播放并立即暂停
      mediaChannelActivator.play()
        .then(() => {
          // 播放后暂停（平板需较长时间才能从通话音量切换到媒体音量，500ms）
          const duration = 500; // 平板部署统一
          setTimeout(() => {
            mediaChannelActivator.pause();
            mediaChannelActivator.currentTime = 0;
            mediaChannelActivated = true;
            resolve(true);
          }, duration);
        })
        .catch(async (err) => {
          // 方案2：使用 Web Audio API 创建无声振荡器激活通道
          try {
            const audioCtx = new (window.AudioContext || window.webkitAudioContext)({ latencyHint: "playback" });
            if (audioCtx.state === "suspended") await audioCtx.resume();
            const oscillator = audioCtx.createOscillator();
            const gainNode = audioCtx.createGain();
            gainNode.gain.value = 0;
            oscillator.connect(gainNode).connect(audioCtx.destination);
            oscillator.start();
            oscillator.stop(audioCtx.currentTime + 0.1);
            setTimeout(() => {
              oscillator.disconnect();
              audioCtx.close().catch(() => {});
              mediaChannelActivated = true;
              resolve(true);
            }, 150);
          } catch (webAudioErr) {
            mediaChannelActivated = true;
            resolve(false);
          }
        });
    } catch (error) {
      // 如果激活失败，直接标记为已激活（简化方案）
      mediaChannelActivated = true;
      resolve(false);
    }
  });
}

// ✅ Android平板音频通道修复：确保媒体通道处于激活状态
// forceReactivate: 强制重新激活（录音后 TTS 播放前调用，解决通话音量问题）
async function ensureMediaChannelActive(forceReactivate = false) {
  if (forceReactivate || !mediaChannelActivated) {
    if (forceReactivate) {
      mediaChannelActivated = false;
    }
    await activateMediaChannel();
  }
}

// ✅ 全局统一音频设置：所有播放器使用相同配置，避免音量波动
function applyUnifiedAudioSettings(el, options = {}) {
  if (!el) return;
  const { volume = 1, muted = false } = options;
  el.volume = volume;
  el.muted = muted;
  if (el.setAttribute) {
    el.setAttribute("playsinline", "true");
    el.setAttribute("webkit-playsinline", "true");
    el.setAttribute("data-media-priority", "high");
    el.setAttribute("data-audio-category", "playback");
    el.setAttribute("x-webkit-airplay", "allow");
    el.setAttribute("data-audio-mode", "media");
    el.setAttribute("data-audio-usage", "playback");
  }
}

// ✅ Android平板音频通道修复：设置全局监听器
function setupAndroidAudioListeners() {
  // 监听页面点击事件，确保音频通道保持激活
  document.addEventListener('click', () => {
    if (audioPlayer.value && audioPlayer.value.paused && !mediaChannelActivated) {
      ensureMediaChannelActive();
    }
  }, { once: true });
  
  // 监听窗口失焦/获焦事件
  window.addEventListener('blur', () => {
    // 窗口失焦时可以选择暂停音频（这里不暂停，保持播放）
  });
  
  window.addEventListener('focus', () => {
    // 窗口获焦时重新激活媒体通道
    setTimeout(() => ensureMediaChannelActive(), 100);
  });
  
  // ✅ 熄屏/亮屏仅通过安卓 actOnPause/actOnResume 控制，不监听 visibilitychange
}

// 将段结束/错误处理器绑定到当前 audioPlayer（双缓冲 swap 时复用）
function attachSegmentEndHandlers() {
  if (!audioPlayer.value) return;
  const handleSegmentEnded = (player) => {
      consecutiveFailures = 0;
      if (player?.previousBlobUrl) {
        try {
          URL.revokeObjectURL(player.previousBlobUrl);
        } catch (e) {
          // ignore
        }
        player.previousBlobUrl = null;
      }
      cleanupCurrentLoadListeners();

      if (audioQueue.length > 0) {
        playNextAudio();
      } else {
        
        // ✅ 关键修复：先设置 isResponding = false，再调用 setPlayingAudioState(false)
        // 这样 setPlayingAudioState 内部检查 !isResponding.value 时才能正确判断
        isResponding.value = false;
        
        // ✅ 新增：重置 isWaitingForMoreAudio 标志（模板17两段音频都播放完成）
        if (isWaitingForMoreAudio) {
          isWaitingForMoreAudio = false;
        }
        
        // ✅ 修复：使用 setPlayingAudioState 来更新状态，触发状态变化逻辑（包括自动开启录音）
        setPlayingAudioState(false);
        
        // ✅ 修改：如果是提示音频播放完成，递增索引（循环播放）
        // 检查是否还有提示音频在队列中（简单检查：如果队列刚为空且之前播放过提示音频）
        // 由于提示音频已经加入队列，我们通过检查队列长度来判断
        // 但更准确的方式是在播放提示音频时设置一个标记，这里简化处理
        // 注意：这里不直接判断，因为无法区分是提示音频还是对话音频播放完成
        // 索引递增改为在 handleTipAudioComplete 中延迟处理
      }
    };
  audioPlayer.value.onended = () => {
    const player = audioPlayer.value;
    if (!player) return;
    const currentTime = player.currentTime || 0;
    const duration = player.duration || 0;
    const playedRatio = duration > 0 ? currentTime / duration : 1;
    if (playedRatio < 0.5 && duration > 1) {
      player.play().then(() => {}).catch(() => {
        setTimeout(() => handleSegmentEnded(player), 100);
      });
      return;
    }
    handleSegmentEnded(player);
  };
  audioPlayer.value.onerror = (err) => {
    const mediaError = audioPlayer.value?.error;
      const now = Date.now();
      
      // ✅ 修改：防止错误日志重复打印（每5秒最多打印一次）
      // 统一处理所有音频错误的频率限制
      const shouldSuppressLog = now - tipAudioErrorLastLogTime < 5000;
      
      if (shouldSuppressLog) {
        // 5秒内，静默计数，不打印日志
        tipAudioErrorLogCount++;
        return;
      } else {
        // 超过5秒间隔，先打印累积的错误次数（如果有），然后重置
        if (tipAudioErrorLogCount > 0) {
          const audioType = isTipAudioMode ? "提示音频" : "音频";
          tipAudioErrorLogCount = 0;
        }
        // 更新日志时间
        tipAudioErrorLastLogTime = now;
      }
      
      // 打印当前错误（已经通过了频率限制）
      
      // ✅ 修改：检查是否是 src 为空导致的错误
      if (mediaError?.code === 4 && mediaError?.message?.includes('Empty src')) {
        // 如果是提示音频模式
        if (isTipAudioMode) {
          // 如果是提示音频模式且队列中有音频，尝试重新设置src
          if (audioQueue.length > 0) {
            playNextAudio();
          } else {
            // 队列为空，清理状态
            isPlayingTipAudio = false;
            isPlayingAudio = false;
            isTipAudioMode = false;
          }
          return;
        }
        // 非tip音频模式，不打印额外的警告（因为上面已经打印了错误日志）
      }
      
      // ✅ 修改：如果是提示音频模式，且错误是由于自动播放限制导致的，不要清空队列
      if (isTipAudioMode && audioPlayer.value?.src) {
        // 不清空src，不清空队列，等待用户交互后重新尝试播放
        isPlayingTipAudio = false;
        isPlayingAudio = false;
        return;
      }
      
      consecutiveFailures++;

      // 如果连续失败次数过多，停止播放
      if (consecutiveFailures >= MAX_CONSECUTIVE_FAILURES) {
        isPlayingAudio = false;
        audioQueue = [];
        consecutiveFailures = 0;
        return;
      }

      // 移除当前失败的音频URL（不是从队列头部移除，因为已经设置了src）
      const failedUrl = audioPlayer.value?.src;
      if (failedUrl && failedUrl.startsWith("blob:")) {
        try {
          URL.revokeObjectURL(failedUrl);
        } catch (e) {
          // 忽略释放错误
        }
      }

      // 清空当前音频源，准备下一段
      if (audioPlayer.value) {
        audioPlayer.value.src = "";
      }

      // 如果队列还有音频，继续播放下一段
      if (audioQueue.length > 0) {
        playNextAudio();
      } else {
        isPlayingAudio = false;
        consecutiveFailures = 0;
        
        // ✅ 移除 sessionSummary 处理逻辑，因为已经在发送时就处理了两段
      }
    };

  audioPlayer.value.ontimeout = () => {
    consecutiveFailures++;
    if (consecutiveFailures >= MAX_CONSECUTIVE_FAILURES) {
      isPlayingAudio = false;
      audioQueue = [];
      consecutiveFailures = 0;
      return;
    }
    if (audioQueue.length > 0) {
      playNextAudio();
    } else {
      isPlayingAudio = false;
      consecutiveFailures = 0;
    }
  };
}

// 初始化音频播放器（如果已存在但事件处理器被清空，会重新设置）
function initAudioPlayer() {
  ensureMediaChannelActive();
  if (!audioPlayer.value) {
    audioPlayer.value = new Audio();
    audioPlayer.value.preload = "auto";
    applyUnifiedAudioSettings(audioPlayer.value);
    if (audioPlayer.value.style) audioPlayer.value.style.display = "none";
    audioPlayer.value.onplaying = () => applyUnifiedAudioSettings(audioPlayer.value);
  }
  applyUnifiedAudioSettings(audioPlayer.value);
  if (!audioPlayer.value.onended) {
    attachSegmentEndHandlers();
  }
}

// 清理当前的事件监听器和超时
function cleanupCurrentLoadListeners() {
  // 清除之前的超时
  if (currentLoadTimeout) {
    clearTimeout(currentLoadTimeout);
    currentLoadTimeout = null;
  }

  // 移除之前的事件监听器（必须包含 loadedmetadata，否则平板会触发旧 handler 导致「音频源已改变」误判）
  if (currentCanPlayHandler && audioPlayer.value) {
    audioPlayer.value.removeEventListener("loadedmetadata", currentCanPlayHandler);
    audioPlayer.value.removeEventListener("loadeddata", currentCanPlayHandler);
    audioPlayer.value.removeEventListener("canplay", currentCanPlayHandler);
    audioPlayer.value.removeEventListener("canplaythrough", currentCanPlayHandler);
    currentCanPlayHandler = null;
  }
  if (currentTimeupdateHandler && audioPlayer.value) {
    audioPlayer.value.removeEventListener("timeupdate", currentTimeupdateHandler);
    currentTimeupdateHandler = null;
  }
}

// ✅ 确保下一段已预加载（供 timeupdate 和播放开始时调用）
function ensurePreloadNextSegment() {
  if (audioQueue.length === 0) return;
  const next = audioQueue[0];
  if (!next || typeof next !== "string" || !next.startsWith("blob:")) return;
  if (!preloadAudio) {
    preloadAudio = new Audio();
    preloadAudio.preload = "auto";
  }
  if (preloadAudio.src !== next) {
    preloadAudio.src = next;
    preloadAudio.load();
  }
}

// ✅ 播放到约 60% 时提前预加载下一段，减少段间卡顿
function scheduleTimeupdatePreload() {
  const player = audioPlayer.value;
  if (!player || audioQueue.length === 0) return;
  if (currentTimeupdateHandler) return;
  const handler = () => {
    if (!player.duration || player.duration <= 0) return;
    const ratio = player.currentTime / player.duration;
    if (ratio >= 0.6) {
      player.removeEventListener("timeupdate", handler);
      currentTimeupdateHandler = null;
      ensurePreloadNextSegment();
    }
  };
  currentTimeupdateHandler = handler;
  player.addEventListener("timeupdate", handler);
}

// 播放队列中的下一段音频（始终使用 audioPlayer 单一实例）
async function playNextAudio() {
  if (isTemplateSwitching.value) return;
  if (isAudioBlockedWhileScreenOff) return;
  if (isManualStop || isStoppingAudio) return; // ✅ 手动暂停时不再播放，防止模版17等场景下暂停后自动恢复
  // 先清理之前的事件监听器和超时
  cleanupCurrentLoadListeners();

  // ✅ 播放前立即清除闲置定时器，避免暂停→下一条消息播放时闲置语音误触发
  clearNoActionTimer();

  // 队列空，停止播放
  if (audioQueue.length === 0) {
    
    // ✅ 关键修复：先设置 isResponding = false，再调用 setPlayingAudioState(false)
    isResponding.value = false;
    
    // ✅ 新增：重置 isWaitingForMoreAudio 标志（模板17两段音频都播放完成）
    if (isWaitingForMoreAudio) {
      isWaitingForMoreAudio = false;
    }
    
    // ✅ 修复：使用 setPlayingAudioState 来更新状态，触发状态变化逻辑（包括自动开启录音）
    setPlayingAudioState(false);
    consecutiveFailures = 0;
    if (audioPlayer.value) {
      // 暂停并清空音频源
      audioPlayer.value.pause();
      audioPlayer.value.src = "";
    }
    return;
  }

  // 激活媒体通道（仅首次或录音后，不每段都 force 避免卡顿）
  const forceReactivate = needsMediaChannelReactivationAfterRecord;
  if (needsMediaChannelReactivationAfterRecord) {
    needsMediaChannelReactivationAfterRecord = false;
  }
  ensureMediaChannelActive(forceReactivate).catch(() => {});
  
  // 检查音频播放器是否已初始化
  if (!audioPlayer.value) {
    initAudioPlayer();
    if (!audioPlayer.value) {
      isPlayingAudio = false;
      audioQueue = [];
      return;
    }
  }

  // 若当前音频正在播放/加载，不重复操作
  if (audioPlayer.value.readyState !== 0 && !audioPlayer.value.paused) {
    return;
  }

  // ✅ 修改：不要在这里设置播放状态，等到真正开始播放时再设置
  // setPlayingAudioState(true);
  
  // 取出队列头部：MediaSource 模式为 Blob，降级模式为 blob URL
  const nextItem = audioQueue.shift();

  // 更新响应式状态追踪
  updateAudioStateRefs();
  updatePlaybackStatus();

  if (!nextItem) {
    if (audioQueue.length === 0) {
      isResponding.value = false;
      if (isWaitingForMoreAudio) isWaitingForMoreAudio = false;
      setPlayingAudioState(false);
      consecutiveFailures = 0;
      if (audioPlayer.value) {
        audioPlayer.value.pause();
        audioPlayer.value.src = "";
      }
    }
    return;
  }

  // ✅ MediaSource API 播放
  if (USE_MEDIA_SOURCE && nextItem instanceof Blob) {
    currentPlayingBlob = nextItem;
    playWithMediaSource(nextItem);
    return;
  }

  // ✅ 降级：Blob URL 播放
  const trimmedUrl = typeof nextItem === "string" ? nextItem.trim() : "";
  if (!trimmedUrl || !trimmedUrl.startsWith("blob:")) {
    consecutiveFailures++;
    handlePlayFailure();
    return;
  }

  // ✅ 双缓冲：若预加载已就绪（readyState>=2 即可开始），直接播放减少段间停顿
  if (preloadAudio && preloadAudio.src === trimmedUrl && preloadAudio.readyState >= 2) {
    const oldMain = audioPlayer.value;
    if (oldMain) {
      oldMain.pause();
      if (currentTimeupdateHandler) {
        oldMain.removeEventListener("timeupdate", currentTimeupdateHandler);
        currentTimeupdateHandler = null;
      }
      if (oldMain.src && oldMain.src.startsWith("blob:")) {
        try { URL.revokeObjectURL(oldMain.src); } catch (e) { /* ignore */ }
      }
      oldMain.src = "";
      oldMain.onended = null;
      oldMain.onerror = null;
    }
    audioPlayer.value = preloadAudio;
    preloadAudio = oldMain;
    attachSegmentEndHandlers();
    applyUnifiedAudioSettings(audioPlayer.value);
    audioPlayer.value.previousBlobUrl = audioPlayer.value.previousBlobUrl || null;
    ensureMediaChannelActive().catch(() => {});
    ensurePreloadNextSegment();
    if (isAudioBlockedWhileScreenOff) return;
    audioPlayer.value.play()
      .then(() => {
        if (isAudioBlockedWhileScreenOff) {
          try {
            audioPlayer.value.pause();
            audioPlayer.value.currentTime = 0;
            audioPlayer.value.src = "";
          } catch (e) { /* ignore */ }
          return;
        }
        setPlayingAudioState(true);
        consecutiveFailures = 0;
        scheduleTimeupdatePreload();
      })
      .catch(() => {
        consecutiveFailures++;
        handlePlayFailure();
      });
    return;
  }

  applyUnifiedAudioSettings(audioPlayer.value);
  audioPlayer.value.previousBlobUrl = audioPlayer.value.src;
  audioPlayer.value.src = trimmedUrl;
  if (preloadAudio && preloadAudio.src === trimmedUrl) {
    preloadAudio.src = "";
  }
  applyUnifiedAudioSettings(audioPlayer.value);
  // ✅ 提前开始预加载第二段（双缓冲），避免“第一段结束太快”时第二段还没 ready
  ensurePreloadNextSegment();

  currentCanPlayHandler = () => {
    const player = audioPlayer.value;
    if (!player || player.readyState < 2) return;
    if (currentLoadTimeout) {
      clearTimeout(currentLoadTimeout);
      currentLoadTimeout = null;
    }
    if (currentCanPlayHandler && player) {
      player.removeEventListener("loadedmetadata", currentCanPlayHandler);
      player.removeEventListener("loadeddata", currentCanPlayHandler);
      player.removeEventListener("canplay", currentCanPlayHandler);
    }
    currentCanPlayHandler = null;
    if (!audioPlayer.value || audioPlayer.value.src !== trimmedUrl) return;
    ensureMediaChannelActive().catch(() => {});
    applyUnifiedAudioSettings(audioPlayer.value);
    ensurePreloadNextSegment();
    if (isAudioBlockedWhileScreenOff) return;
    audioPlayer.value.play()
      .then(() => {
        if (isAudioBlockedWhileScreenOff) {
          try {
            audioPlayer.value.pause();
            audioPlayer.value.currentTime = 0;
            audioPlayer.value.src = "";
          } catch (e) { /* ignore */ }
          return;
        }
        applyUnifiedAudioSettings(audioPlayer.value);
        setPlayingAudioState(true);
        consecutiveFailures = 0;
        scheduleTimeupdatePreload();
      })
      .catch((err) => {
        if (err.name === 'NotAllowedError' || err.message?.includes('user didn\'t interact')) {
          if (isTipAudioMode) {
            isPlayingTipAudio = false;
            isPlayingAudio = false;
            return;
          }
        }
        consecutiveFailures++;
        handlePlayFailure();
      });
  };

  audioPlayer.value.addEventListener("loadedmetadata", currentCanPlayHandler);
  audioPlayer.value.addEventListener("loadeddata", currentCanPlayHandler);
  audioPlayer.value.addEventListener("canplay", currentCanPlayHandler);
  currentLoadTimeout = setTimeout(() => {
    cleanupCurrentLoadListeners();
    consecutiveFailures++;
    handlePlayFailure();
  }, 5000);
  audioPlayer.value.load();
}

// ✅ MediaSource API 播放单个 Blob（WebM/Opus）
function playWithMediaSource(blob) {
  if (!audioPlayer.value || !blob || blob.size === 0) {
    currentPlayingBlob = null;
    if (audioQueue.length > 0) playNextAudio();
    else setPlayingAudioState(false);
    return;
  }

  const mimeType = MediaSource.isTypeSupported('audio/webm; codecs="opus"')
    ? 'audio/webm; codecs="opus"'
    : 'audio/webm';
  const mediaSource = new MediaSource();
  const mediaUrl = URL.createObjectURL(mediaSource);
  currentMediaSourceUrl = mediaUrl;

  if (audioPlayer.value.previousBlobUrl) {
    try { URL.revokeObjectURL(audioPlayer.value.previousBlobUrl); } catch (e) { /* ignore */ }
    audioPlayer.value.previousBlobUrl = null;
  }

  audioPlayer.value.src = mediaUrl;
  applyUnifiedAudioSettings(audioPlayer.value);

  const onSourceOpen = () => {
    try {
      const sourceBuffer = mediaSource.addSourceBuffer(mimeType);
      sourceBuffer.addEventListener("updateend", () => {
        if (sourceBuffer.updating) return;
        if (mediaSource.readyState === "open") {
          try {
            mediaSource.endOfStream();
          } catch (e) {
            /* MediaSource 可能已被关闭，忽略 */
          }
        }
        if (currentLoadTimeout) {
          clearTimeout(currentLoadTimeout);
          currentLoadTimeout = null;
        }
        if (!audioPlayer.value || audioPlayer.value.src !== mediaUrl) return;
        audioPlayer.value.play()
          .then(() => {
            setPlayingAudioState(true);
            consecutiveFailures = 0;
          })
          .catch(() => {
            consecutiveFailures++;
            handlePlayFailure();
          });
      }, { once: true });

      blob.arrayBuffer().then((arrayBuffer) => {
        if (mediaSource.readyState !== "open" || sourceBuffer.updating) return;
        sourceBuffer.appendBuffer(arrayBuffer);
      }).catch(() => {
        currentPlayingBlob = null;
        consecutiveFailures++;
        handlePlayFailure();
      });
    } catch (e) {
      currentPlayingBlob = null;
      consecutiveFailures++;
      handlePlayFailure();
    }
  };

  mediaSource.addEventListener("sourceopen", onSourceOpen, { once: true });

  audioPlayer.value.onended = () => {
    currentPlayingBlob = null;
    if (currentMediaSourceUrl) {
      try { URL.revokeObjectURL(currentMediaSourceUrl); } catch (e) { /* ignore */ }
      currentMediaSourceUrl = null;
    }
    const player = audioPlayer.value;
    if (player?.previousBlobUrl) {
      try { URL.revokeObjectURL(player.previousBlobUrl); } catch (e) { /* ignore */ }
      player.previousBlobUrl = null;
    }
    cleanupCurrentLoadListeners();
    if (audioQueue.length > 0) {
      playNextAudio();
    } else {
      isResponding.value = false;
      if (isWaitingForMoreAudio) isWaitingForMoreAudio = false;
      setPlayingAudioState(false);
      consecutiveFailures = 0;
      if (audioPlayer.value) {
        audioPlayer.value.pause();
        audioPlayer.value.src = "";
      }
    }
  };

  audioPlayer.value.onerror = () => {
    currentPlayingBlob = null;
    if (currentMediaSourceUrl) {
      try { URL.revokeObjectURL(currentMediaSourceUrl); } catch (e) { /* ignore */ }
      currentMediaSourceUrl = null;
    }
    consecutiveFailures++;
    handlePlayFailure();
  };

  // 设置加载超时
  currentLoadTimeout = setTimeout(() => {
    cleanupCurrentLoadListeners();
    currentPlayingBlob = null;
    consecutiveFailures++;
    handlePlayFailure();
  }, 5000);
}

// 播放失败统一处理函数
function handlePlayFailure() {
  currentPlayingBlob = null;
  if (currentMediaSourceUrl) {
    try { URL.revokeObjectURL(currentMediaSourceUrl); } catch (e) { /* ignore */ }
    currentMediaSourceUrl = null;
  }
  if (consecutiveFailures >= MAX_CONSECUTIVE_FAILURES) {
    isPlayingAudio = false;
    audioQueue = [];
    consecutiveFailures = 0;
    if (audioPlayer.value) audioPlayer.value.src = "";
    updatePlaybackStatus();
    return;
  }
  if (audioPlayer.value) audioPlayer.value.src = "";
  if (audioQueue.length > 0) {
    playNextAudio();
  } else {
    isPlayingAudio = false;
    consecutiveFailures = 0;
  }
  updatePlaybackStatus();
}

// 当前正在处理的 AI 消息索引（用于缓存音频）
let currentAiMessageIndex = -1;

// ✅ complete 消息到达时间戳，用于宽限期：网络延迟时最后一句 audio_chunk 可能晚于 complete 到达
let completeMessageReceivedAt = 0;

// ✅ 创建对话后“第一句音频”需要等待 complete 才开始播放（避免首段卡顿）
let waitForInitialCompleteBeforePlay = false;
let initialCompleteFallbackTimer = null;
// 平板主线程 base64 解码较慢，需更长宽限期等待末尾片段
const COMPLETE_GRACE_PERIOD_MS = 4500;
// complete 后等待再处理，给末尾 audio_chunk 到达和解码留时间（模板切换首句需更长，避免少一句）
const COMPLETE_INITIAL_WAIT_MS = 2000;
// 延迟合并时等待 base64 解码完成的时长（平板主线程解码慢，需更长）
const BASE64_DECODE_WAIT_MS = 200; // 缩短解码等待，减少相邻分段空窗

// 待处理的 sessionSummary（用于在第一段音频播放完成后处理第二段）
let pendingSessionSummary = null;
let pendingSummaryMessageIndex = -1; // 待处理的 sessionSummary 消息索引


// 重置音频接收超时定时器（动态超时 + 双重校验）
function resetAudioReceiveTimeout() {
  // 清除之前的定时器
  if (audioReceiveTimeoutTimer) {
    clearTimeout(audioReceiveTimeoutTimer);
    audioReceiveTimeoutTimer = null;
  }

  // 重置重试次数（每次收到新音频时重置）
  audioReceiveTimeoutRetryCount = 0;

  // ✅ 已移除：模板17特殊处理 - 3秒无新音频则finish的逻辑已移除
  // 模板17现在使用标准的finish逻辑（等待complete消息）
  if (promptId.value == 17 && isThemeChat.value) {
    // 不再调用 resetTemplate17AudioTimeout()，使用标准逻辑
  }

  // 只有在流式请求已结束且 TTS 管理器存在时才启动倒计时
  if (
    !isResponding.value &&
    ttsWsManager &&
    ttsWsManager.isReady() &&
    ttsWsManager.isSessionStarted
  ) {
    // 动态计算超时时间：基础 3 秒 + 每 10 个字符加 100ms（适配不同文本长度）
    const baseTimeout = 3000;
    const textLength = sentTextTotal.value.length;
    const dynamicTimeout =
      baseTimeout + Math.min(Math.floor(textLength / 10) * 100, 10000); // 最长不超过 13 秒


    audioReceiveTimeoutTimer = setTimeout(() => {

      // 校验1：是否所有文本都已发送，且音频队列无新数据
      if (
        isTtsTextAllSent.value &&
        ttsSendQueue.length === 0 &&
        !isTtsSending
      ) {
        // 校验2：音频片段数是否匹配文本长度（简单估算：每 5 个字符至少 1 个音频片段）
        const expectedMinAudioChunks = Math.ceil(
          sentTextTotal.value.length / 5
        );
        const isAudioEnough =
          allAudioBlobsForCurrentMessage.length >= expectedMinAudioChunks;

        if (isAudioEnough) {
          handleAudioComplete(); // 处理音频完成逻辑
        } else {
          handleAudioComplete(); // 兜底拼接，避免无音频播放
        }
      } else {
        // 文本未发完，重新启动超时（每次 +1 秒，最多重试 3 次）
        if (audioReceiveTimeoutRetryCount < 3) {
          audioReceiveTimeoutRetryCount++;
          const retryTimeout =
            dynamicTimeout + audioReceiveTimeoutRetryCount * 1000;
          audioReceiveTimeoutTimer = setTimeout(() => {
            resetAudioReceiveTimeout();
          }, retryTimeout);
        } else {
          handleAudioComplete();
        }
      }
    }, dynamicTimeout);
  }
}

// ✅ 已移除：模板17专用的音频接收超时逻辑（3秒无新音频则finish）
// 暂时移除3秒超时逻辑，避免在文本发送过程中提前finish
function resetTemplate17AudioTimeout() {
  // 清除之前的定时器（如果存在）
  if (template17AudioTimeoutTimer) {
    clearTimeout(template17AudioTimeoutTimer);
    template17AudioTimeoutTimer = null;
  }
  // ✅ 已移除：不再启动3秒超时定时器
}

// 统一的音频完成处理函数（替代原 handleCompleteMessage 和超时逻辑）
async function handleAudioComplete() {
  if (isAudioBlockedWhileScreenOff || isTtsHardInterruptedWhileScreenOff) return;
  // 清除所有定时器
  if (audioReceiveTimeoutTimer) {
    clearTimeout(audioReceiveTimeoutTimer);
    audioReceiveTimeoutTimer = null;
  }
  // ✅ 新增：清理模板17的音频超时定时器
  if (template17AudioTimeoutTimer) {
    clearTimeout(template17AudioTimeoutTimer);
    template17AudioTimeoutTimer = null;
  }
  if (ttsFinishTimer) {
    clearTimeout(ttsFinishTimer);
    ttsFinishTimer = null;
  }

  // ✅ 关键修复：pendingAudioBlobs 与 allAudioBlobsForCurrentMessage 存的是同一批数据（addAudioChunkToSentence 双写）
  // 若先 merge pending 入队，必须清空 allAudioBlobsForCurrentMessage，否则会重复合并入队导致播两遍
  if (pendingAudioBlobs.length > 0) {
    mergeAndPlayPendingBlobs(true);
    allAudioBlobsForCurrentMessage = [];
  }

  // 检查是否有音频在队列中（只使用 HTML5 Audio）
  const hasPending = pendingAudioBlobs.length > 0;
  const hasQueue = audioQueue.length > 0;

  if (allAudioBlobsForCurrentMessage.length === 0) {
    // 如果 allAudioBlobsForCurrentMessage 为空，但可能有音频在队列中（已通过 addAudioChunkToSentence 提前合并入队）
    if (hasQueue && !isPlayingAudio) {
      initAudioPlayer();
      playNextAudio();
    } else if (hasPending) {
      setTimeout(() => {
        if (pendingAudioBlobs.length > 0) mergeAndPlayPendingBlobs(true);
      }, 200);
    } else {
      // 队列有音频或正在播放时，仅标记完成，不打印「无音频片段」（音频已提前合并入队）
      if (!hasQueue) {
      }
      isFinishSuccess.value = true;
      currentAiMessageIndex = -1;
      // 重置文本跟踪
      sentTextTotal.value = "";
      audioReceivedTextLength.value = 0;
      isTtsTextAllSent.value = false;
      return;
    }
  }

  // ✅ 优化：优先按 sentCount 排序所有音频片段，确保顺序正确
  const sortedAudioBlobs = [...allAudioBlobsForCurrentMessage]
    .map((item) => {
      // 兼容新旧格式：新格式是 {messageId, sentCount, serverTimestamp, receiveTimestamp, sortTimestamp, index, blob}，旧格式是 {index, blob} 或直接是 blob
      if (typeof item === "object" && item.blob) {
        // 如果是新格式，已经有 sentCount 或时间戳
        if (
          item.sentCount !== null && item.sentCount !== undefined ||
          item.sortTimestamp !== undefined ||
          item.serverTimestamp !== undefined ||
          item.receiveTimestamp !== undefined
        ) {
          return item;
        }
        // 旧格式：没有 sentCount 和时间戳，使用 index 或生成一个时间戳
        return {
          messageId: item.messageId || `legacy_${item.index || 0}`,
          sentCount: null,
          serverTimestamp: null,
          receiveTimestamp: (item.index || 0) * 1000, // 使用索引作为时间戳的近似值
          sortTimestamp: (item.index || 0) * 1000,
          index: item.index !== undefined ? item.index : -1,
          blob: item.blob,
        };
      }
      // 旧格式：直接是 blob
      const now = Date.now();
      return {
        messageId: `legacy_blob_${now}`,
        sentCount: null,
        serverTimestamp: null,
        receiveTimestamp: now,
        sortTimestamp: now,
        index: -1,
        blob: item,
      };
    })
    .sort((a, b) => {
      // ✅ 优先级1：优先使用 sentCount 排序（从1开始递增，有序且唯一）
      const sentCountA = a.sentCount !== null && a.sentCount !== undefined ? parseInt(a.sentCount, 10) : null;
      const sentCountB = b.sentCount !== null && b.sentCount !== undefined ? parseInt(b.sentCount, 10) : null;
      
      if (sentCountA !== null && sentCountB !== null) {
        // 两个都有 sentCount，直接按 sentCount 排序
        return sentCountA - sentCountB;
      } else if (sentCountA !== null) {
        // 只有 A 有 sentCount，A 优先
        return -1;
      } else if (sentCountB !== null) {
        // 只有 B 有 sentCount，B 优先
        return 1;
      }

      // ✅ 优先级2：如果都没有 sentCount，回退到时间戳排序（兼容旧逻辑）
      const timestampA =
        a.sortTimestamp || a.serverTimestamp || a.receiveTimestamp || 0;
      const timestampB =
        b.sortTimestamp || b.serverTimestamp || b.receiveTimestamp || 0;
      if (timestampA !== timestampB) {
        return timestampA - timestampB;
      }

      // ✅ 优先级3：如果时间戳相同，回退到索引排序（兼容旧逻辑）
      if (a.index >= 0 && b.index >= 0) {
        return a.index - b.index;
      }
      return 0;
    });

  const firstSentCount = sortedAudioBlobs[0]?.sentCount !== null && sortedAudioBlobs[0]?.sentCount !== undefined 
    ? parseInt(sortedAudioBlobs[0].sentCount, 10) 
    : null;
  const lastSentCount = sortedAudioBlobs[sortedAudioBlobs.length - 1]?.sentCount !== null && sortedAudioBlobs[sortedAudioBlobs.length - 1]?.sentCount !== undefined
    ? parseInt(sortedAudioBlobs[sortedAudioBlobs.length - 1].sentCount, 10)
    : null;
  const firstTimestamp =
    sortedAudioBlobs[0]?.sortTimestamp ||
    sortedAudioBlobs[0]?.serverTimestamp ||
    sortedAudioBlobs[0]?.receiveTimestamp ||
    0;
  const lastTimestamp =
    sortedAudioBlobs[sortedAudioBlobs.length - 1]?.sortTimestamp ||
    sortedAudioBlobs[sortedAudioBlobs.length - 1]?.serverTimestamp ||
    sortedAudioBlobs[sortedAudioBlobs.length - 1]?.receiveTimestamp ||
    0;

  // ✅ 优化：统计使用 sentCount 和时间戳的片段数量
  const sentCountCount = sortedAudioBlobs.filter(
    (blob) => blob.sentCount !== null && blob.sentCount !== undefined
  ).length;
  const serverTimestampCount = sortedAudioBlobs.filter(
    (blob) => blob.serverTimestamp
  ).length;
  const receiveTimestampCount = sortedAudioBlobs.length - serverTimestampCount;

  if (sentCountCount > 0) {
  } else {
  }

  // ✅ 优化：如果部分片段没有 sentCount，输出警告
  if (sentCountCount > 0 && sentCountCount < sortedAudioBlobs.length) {
  }


  // 检查是否有缺失的片段
  checkMissingChunks();

  // ✅ 按 sessionId 分组：不同 session 不合并，按 session 顺序依次入队
  const groupsBySession = new Map();
  for (const item of sortedAudioBlobs) {
    const sid = item.sessionId ?? "default";
    if (!groupsBySession.has(sid)) groupsBySession.set(sid, []);
    groupsBySession.get(sid).push(item);
  }
  const sessionOrder = [...groupsBySession.entries()]
    .map(([sid, blobs]) => ({
      sessionId: sid,
      minReceive: Math.min(...blobs.map((b) => b.receiveTimestamp || 0)),
      blobs,
    }))
    .sort((a, b) => a.minReceive - b.minReceive);

  const totalSize = sessionOrder.reduce((s, { blobs }) => s + blobs.reduce((sum, b) => sum + (b.blob?.size || 0), 0), 0);

  const webAudioHasContent = false; // 已移除 Web Audio TTS，统一使用 HTML5 Audio
  if (webAudioHasContent) {
  } else if (!isPlayingAudio && totalSize > 0) {
    if (hasQueue) {
      initAudioPlayer();
      playNextAudio();
    } else {
      for (let i = 0; i < sessionOrder.length; i++) {
        const { blobs, minReceive } = sessionOrder[i];
        const validBlobs = blobs.filter((b) => b.blob && b.blob.size > 0);
        if (validBlobs.length === 0) continue;
        const sentCounts = validBlobs.map((item) => item.sentCount != null ? parseInt(item.sentCount, 10) : null);
        console.log("[拼接音频 handleAudioComplete] sentCount 序列:", sentCounts);
        const blobsForMerge = validBlobs.map((item) => item.blob);
        const mergedBlob = blobsForMerge.length === 1 ? blobsForMerge[0] : new Blob(blobsForMerge, { type: "audio/opus; codecs=opus" });
        enqueueWebAudioTtsBlob(mergedBlob, minReceive);
      }
    }
  } else if (isPlayingAudio) {
  } else if (totalSize === 0) {
  }

  // 清空当前消息的音频片段缓存（如果有待处理的sessionSummary或正在等待更多音频，不清空）
  if (!pendingSessionSummary && !isWaitingForMoreAudio) {
  allAudioBlobsForCurrentMessage = [];
  } else if (isWaitingForMoreAudio) {
  }

  // 重置当前消息索引（如果有待处理的sessionSummary或正在等待更多音频，不重置）
  if (!pendingSessionSummary && !isWaitingForMoreAudio) {
  currentAiMessageIndex = -1;
  } else if (isWaitingForMoreAudio) {
  }

  // 允许录音
  isFinishSuccess.value = true;

  // 重置文本跟踪（如果有待处理的sessionSummary或正在等待更多音频，不重置）
  if (!pendingSessionSummary && !isWaitingForMoreAudio) {
  sentTextTotal.value = "";
  audioReceivedTextLength.value = 0;
  isTtsTextAllSent.value = false;
  } else if (isWaitingForMoreAudio) {
  }

  // 音频处理完成后，等待音频播放完成后再启动自动监听
  // 注意：这里不立即启动监听，而是等待 setPlayingAudioState(false) 时启动
  // 这样可以确保只有在音频真正播放完成且状态为"倾听中"时才启动监听

  // ✅ 修改：不再发送 finish（已在文本发送完毕时发送）
  // 收到 complete 消息代表音频接收完毕，直接拼接播放即可
}

// ✅ 按 sentCount 排序后直接 Blob 拼接入队；每次 flush 合并所有 pending，不按「连续 sentCount」分割，避免跳过片段
function mergeAndPlayPendingBlobs(flushAll = false) {
  if (isTemplateSwitching.value || pendingAudioBlobs.length === 0) return;
  if (isAudioBlockedWhileScreenOff) return;
  if (isTtsHardInterruptedWhileScreenOff) return;
  if (isManualStop || isStoppingAudio) return;
  if (pendingMergeTimeout) {
    clearTimeout(pendingMergeTimeout);
    pendingMergeTimeout = null;
  }

  // ✅ 防乱序：仅首批（队列空且未播放）时，若缺 sentCount=1 则暂不 flush，避免先播中间再播开头
  if (!flushAll) {
    const isFirstBatch = audioQueue.length === 0 && !isPlayingAudio;
    if (isFirstBatch) {
      const hasSentCount = pendingAudioBlobs.some((p) => p.sentCount != null);
      const minSentCount = hasSentCount
        ? Math.min(...pendingAudioBlobs.map((p) => (p.sentCount != null ? parseInt(p.sentCount, 10) : Infinity)).filter((n) => n !== Infinity))
        : null;
      if (minSentCount != null && minSentCount > 1) return;
      const hasIndex = pendingAudioBlobs.some((p) => p.index != null && p.index >= 0);
      const minIndex = hasIndex ? Math.min(...pendingAudioBlobs.map((p) => (p.index != null && p.index >= 0 ? p.index : Infinity)).filter((n) => n !== Infinity)) : null;
      if (minIndex != null && minIndex > 0) return;
    }
  }

  // 排序：sentCount 优先，缺失时用 sortTimestamp/serverTimestamp/receiveTimestamp，最后 index
  const sortBySentCount = (a, b) => {
    const sentCountA = a.sentCount != null ? parseInt(a.sentCount, 10) : null;
    const sentCountB = b.sentCount != null ? parseInt(b.sentCount, 10) : null;
    if (sentCountA != null && sentCountB != null) return sentCountA - sentCountB;
    if (sentCountA != null) return -1;
    if (sentCountB != null) return 1;
    const tsA = a.sortTimestamp || a.serverTimestamp || a.receiveTimestamp || 0;
    const tsB = b.sortTimestamp || b.serverTimestamp || b.receiveTimestamp || 0;
    return tsA - tsB || ((a.index ?? -1) - (b.index ?? -1));
  };

  const groupsBySession = new Map();
  for (const item of pendingAudioBlobs) {
    const sid = item.sessionId ?? "default";
    if (!groupsBySession.has(sid)) groupsBySession.set(sid, []);
    groupsBySession.get(sid).push(item);
  }

  const sessionOrder = [...groupsBySession.entries()]
    .map(([sid, blobs]) => ({
      sessionId: sid,
      minReceive: Math.min(...blobs.map((b) => b.receiveTimestamp || 0)),
      blobs: blobs.sort(sortBySentCount),
    }))
    .sort((a, b) => a.minReceive - b.minReceive);

  let flushedCount = 0;
  const toKeep = []; // 未满一批的 remainder，留待下次合并

  // flushAll 时合并全部；否则每 MERGE_BATCH_SIZE 个拼一次，不满一批的保留
  for (const { minReceive, blobs } of sessionOrder) {
    const validItems = blobs.filter((item) => {
      const blob = typeof item === "object" && item.blob ? item.blob : item;
      return blob && blob.size > 0;
    });
    if (validItems.length === 0) continue;

    if (flushAll) {
      const sentCounts = validItems.map((item) => item.sentCount != null ? parseInt(item.sentCount, 10) : null);
      console.log("[拼接音频] sentCount 序列:", sentCounts);
      const blobsToMerge = validItems.map((item) => (typeof item === "object" && item.blob ? item.blob : item));
      const sortKey = (validItems[0].sentCount != null ? parseInt(validItems[0].sentCount, 10) : null) ?? minReceive;
      const mergedBlob = blobsToMerge.length === 1 ? blobsToMerge[0] : new Blob(blobsToMerge, { type: "audio/opus; codecs=opus" });
      enqueueWebAudioTtsBlob(mergedBlob, sortKey);
      if (currentAiMessageIndex >= 0 && chatList.value?.[currentAiMessageIndex]?.role === "ai") {
        const msg = chatList.value[currentAiMessageIndex];
        if (!msg.audioBlobs) msg.audioBlobs = [];
        msg.audioBlobs.push(mergedBlob);
      }
      flushedCount += validItems.length;
    } else {
      const hasPunctuationBoundaries = validItems.some((item) => item.isAtPunctuation);
      if (hasPunctuationBoundaries) {
        // 按标点边界切分：每句一个片段，停顿自然落在标点处
        let segmentStart = 0;
        for (let i = 0; i < validItems.length; i++) {
          if (validItems[i].isAtPunctuation) {
            const segment = validItems.slice(segmentStart, i + 1);
            if (segment.length > 0) {
              const blobsToMerge = segment.map((item) => (typeof item === "object" && item.blob ? item.blob : item));
              const sortKey = (segment[0].sentCount != null ? parseInt(segment[0].sentCount, 10) : null) ?? minReceive;
              const mergedBlob = blobsToMerge.length === 1 ? blobsToMerge[0] : new Blob(blobsToMerge, { type: "audio/opus; codecs=opus" });
              enqueueWebAudioTtsBlob(mergedBlob, sortKey);
              if (currentAiMessageIndex >= 0 && chatList.value?.[currentAiMessageIndex]?.role === "ai") {
                const msg = chatList.value[currentAiMessageIndex];
                if (!msg.audioBlobs) msg.audioBlobs = [];
                msg.audioBlobs.push(mergedBlob);
              }
              flushedCount += segment.length;
            }
            segmentStart = i + 1;
          }
        }
        if (segmentStart < validItems.length) {
          toKeep.push(...validItems.slice(segmentStart));
        }
      } else {
        const batchSize = (audioQueue.length > 0 || isPlayingAudio) ? SUBSEQUENT_BATCH_SIZE : MERGE_BATCH_SIZE;
        for (let i = 0; i < validItems.length; i += batchSize) {
          const batch = validItems.slice(i, i + batchSize);
          if (batch.length === batchSize) {
            const blobsToMerge = batch.map((item) => (typeof item === "object" && item.blob ? item.blob : item));
            const sortKey = (batch[0].sentCount != null ? parseInt(batch[0].sentCount, 10) : null) ?? minReceive;
            const mergedBlob = new Blob(blobsToMerge, { type: "audio/opus; codecs=opus" });
            enqueueWebAudioTtsBlob(mergedBlob, sortKey);
            if (currentAiMessageIndex >= 0 && chatList.value?.[currentAiMessageIndex]?.role === "ai") {
              const msg = chatList.value[currentAiMessageIndex];
              if (!msg.audioBlobs) msg.audioBlobs = [];
              msg.audioBlobs.push(mergedBlob);
            }
            flushedCount += batch.length;
          } else {
            toKeep.push(...batch);
          }
        }
      }
    }
  }

  pendingAudioBlobs = toKeep;
  pendingMergeCount = Math.max(0, pendingMergeCount - flushedCount);
  allAudioBlobsForCurrentMessage = [...toKeep];
  updateAudioStateRefs();
}

// 将音频片段加入"当前一句"的缓冲（✅ 优化：基于接收时间戳排序，messageId 去重）
function addAudioChunkToSentence(audioBase64, rawMsg = null) {
  if (!audioBase64 || isTemplateSwitching.value) return;
  const chainId = rawMsg?._chainId || null;
  if (chainId && !isVoiceChainActive(chainId)) {
    logChain("audio chunk dropped", { chainId });
    return;
  }
  if (isAudioBlockedWhileScreenOff) return;
  // 熄屏后 TTS 硬中断：阻断所有 TTS chunk 进入合并队列；提示音频模式例外
  if (isTtsHardInterruptedWhileScreenOff && !isTipAudioMode) return;
  if (isManualStop || isStoppingAudio) return; // ✅ 手动暂停时不再接收新片段，防止暂停后自动恢复播放

  // ✅ 修改：如果是提示音频模式，使用独立的收集器（必须在最前面检查）
  if (isTipAudioMode) {
    // ✅ 新增：提取排序信息（参考AI消息的处理逻辑）
    // ✅ 兼容多种字段名：sentCount, sent_count, sequence, order, seq
    const sentCount = rawMsg?.sentCount 
      ? parseInt(rawMsg.sentCount, 10) 
      : rawMsg?.sent_count 
      ? parseInt(rawMsg.sent_count, 10)
      : rawMsg?.sequence
      ? parseInt(rawMsg.sequence, 10)
      : rawMsg?.order
      ? parseInt(rawMsg.order, 10)
      : rawMsg?.seq
      ? parseInt(rawMsg.seq, 10)
      : null;
    const serverTimestamp = rawMsg?.timestamp || rawMsg?.serverTimestamp || null;
    const receiveTimestamp = Date.now();
    const sortTimestamp = serverTimestamp || receiveTimestamp;
    const chunkIndex = rawMsg?.index !== undefined ? parseInt(rawMsg.index, 10) : tipAudioBlobs.length;
    const messageId = rawMsg?.messageId || rawMsg?.message_id || `tip_audio_${Date.now()}_${chunkIndex}`;
    
    // 使用独立的提示音频收集器，不添加到对话框
    base64ToBlobByWorker(audioBase64, (audioBlob, error) => {
      if (error || !audioBlob) {
        return;
      }
      if (isAudioBlockedWhileScreenOff) return;
      
      // ✅ 修改：保存音频片段及其排序信息（参考AI消息的处理逻辑）
      const audioChunkData = {
        messageId: messageId,
        sentCount: sentCount, // ✅ 新增：sentCount 用于排序（优先级最高）
        serverTimestamp: serverTimestamp, // 服务端时间戳（优先）
        receiveTimestamp: receiveTimestamp, // 接收时间戳（回退）
        sortTimestamp: sortTimestamp, // 排序时间戳（服务端优先，否则接收时间）
        index: chunkIndex, // 保留用于兼容
        blob: audioBlob,
      };
      
      tipAudioBlobs.push(audioChunkData);
      
      const timestampInfo = serverTimestamp
        ? `服务端时间: ${new Date(serverTimestamp).toISOString()} (${serverTimestamp})`
        : `接收时间: ${new Date(receiveTimestamp).toISOString()} (${receiveTimestamp})`;
      const sentCountInfo = sentCount !== null ? `sentCount: ${sentCount}` : "sentCount: 无";
      
    });
    return; // ✅ 重要：立即返回，不执行后续逻辑
  }

  // ✅ 提前提取 sentCount，用于判断是否为新音频会话（暂停后下一段录音的 sentCount=1 需放行）
  const sentCount = rawMsg?.sentCount 
    ? parseInt(rawMsg.sentCount, 10) 
    : rawMsg?.sent_count 
    ? parseInt(rawMsg.sent_count, 10)
    : rawMsg?.sequence
    ? parseInt(rawMsg.sequence, 10)
    : rawMsg?.order
    ? parseInt(rawMsg.order, 10)
    : rawMsg?.seq
    ? parseInt(rawMsg.seq, 10)
    : null;

  // 标点边界：服务端 sentenceEnd 或 content 含句末标点，用于在标点处切分音频
  const isAtPunctuation = !!(
    rawMsg?.sentenceEnd ||
    rawMsg?.isSentenceEnd ||
    rawMsg?.is_sentence_end ||
    (rawMsg?.content && PUNCTUATION_REGEX.test(String(rawMsg.content)))
  );

  // 如果当前没有正在处理的消息（currentAiMessageIndex < 0），说明已经停止响应，不再接收新的音频片段
  // ✅ 例外1：sentCount === 1 表示新音频会话开始（如暂停后下一段录音），需放行，后续会重置 currentAiMessageIndex
  // ✅ 例外2：complete 宽限期内仍接受延迟到达的音频（网络抖动时最后一句可能晚于 complete）
  if (currentAiMessageIndex < 0) {
    const isNewAudioSession = sentCount === 1;
    const inGracePeriod = completeMessageReceivedAt > 0 && (Date.now() - completeMessageReceivedAt) < COMPLETE_GRACE_PERIOD_MS;
    if (!isNewAudioSession && !inGracePeriod) {
      return;
    }
    if (isNewAudioSession) {
    } else {
    }
  }

  // ✅ 优先提取 messageId（唯一标识，用于去重）
  const messageId = rawMsg?.messageId || rawMsg?.message_id || null;
  const sessionId = rawMsg?.ttsSessionId ?? rawMsg?.sessionId ?? rawMsg?.session_id ?? ttsWsManager?.ttsSessionId ?? "default";

  // ✅ 关键修复：如果收到 sentCount === 1，说明是新音频的开始，清空所有旧的音频缓存
  // 这样可以避免暂停后再次播放时拼接旧音频片段
  // ✅ 少音频修复：先 flush 当前 pending 入队，再清空，避免上一句末尾在 complete 前被清空导致漏音
  // ✅ 防乱序：若 pending 与当前同 session，说明是同一消息乱序到达（先收到 3、4、5 后收到 1），不 flush，直接追加，等合并时按 sentCount 排序
  if (sentCount === 1) {
    const pendingSameSession = pendingAudioBlobs.some((p) => (p.sessionId ?? "default") === sessionId);
    if (pendingSameSession) {
      // 同 session 乱序到达：不 flush 不清空，继续往下追加 chunk 1，合并时按 sentCount 排序
    } else {
      if (pendingAudioBlobs.length > 0) {
        mergeAndPlayPendingBlobs(true);
      }
      if (pendingMergeTimeout) {
        clearTimeout(pendingMergeTimeout);
        pendingMergeTimeout = null;
      }
      pendingAudioBlobs.forEach(item => {
      if (item.blob && item.blob instanceof Blob) {
        try {
          // 释放 Blob URL（如果有）
          if (item.messageId && item.messageId.startsWith('blob:')) {
            URL.revokeObjectURL(item.messageId);
          }
        } catch (e) {
          // ignore
        }
      }
    });
    pendingAudioBlobs = [];
    
    // 清空完整消息缓存
    allAudioBlobsForCurrentMessage.forEach(item => {
      if (item.blob && item.blob instanceof Blob) {
        try {
          // 释放 Blob URL（如果有）
          if (item.messageId && item.messageId.startsWith('blob:')) {
            URL.revokeObjectURL(item.messageId);
          }
        } catch (e) {
          // ignore
        }
      }
    });
    allAudioBlobsForCurrentMessage = [];
    
    // 清空音频数据映射
    audioChunkDataMap.forEach((value, key) => {
      if (value.blob && value.blob instanceof Blob) {
        try {
          if (key.startsWith('blob:')) {
            URL.revokeObjectURL(key);
          }
        } catch (e) {
          // ignore
        }
      }
    });
    audioChunkDataMap.clear();
    
    // 清空接收时间戳映射
    audioChunkReceiveTimeMap.clear();
    
    // 清空已接收的 messageId
    receivedMessageIds.clear();
    
    // 清空索引映射
    clearAudioChunkIndexTracking();
    }
    
    // ✅ 关键修复：如果之前因为暂停导致 currentAiMessageIndex = -1，收到 sentCount=1 时重新启用音频处理
    if (currentAiMessageIndex < 0 && chatList.value && chatList.value.length > 0) {
      for (let i = chatList.value.length - 1; i >= 0; i--) {
        if (chatList.value[i].role === "ai") {
          currentAiMessageIndex = i;
          break;
        }
      }
    }
  }

  // ✅ 优先使用服务端时间戳（最准确，反映音频实际生成顺序）
  // 支持多种时间戳字段名：timestamp（标准）、serverTimestamp、ts
  const serverTimestamp =
    rawMsg?.timestamp || rawMsg?.serverTimestamp || rawMsg?.ts || null;
  // 暂停后若旧会话 chunk 延迟到达，且服务端时间早于暂停时间，直接丢弃
  if (serverTimestamp && lastPauseTime > 0 && Number(serverTimestamp) < Number(lastPauseTime)) {
    return;
  }
  const receiveTimestamp = Date.now(); // 记录接收时间戳（作为回退）

  // 使用服务端时间戳作为排序依据，如果没有则使用接收时间戳
  const sortTimestamp = serverTimestamp || receiveTimestamp;

  // 如果没有 messageId，生成一个临时 ID（基于时间戳）
  const finalMessageId =
    messageId ||
    `temp_${sortTimestamp}_${Math.random().toString(36).substr(2, 9)}`;

  // 检查是否重复接收（基于 messageId）
  if (receivedMessageIds.has(finalMessageId)) {
    return;
  }

  // 记录已接收的 messageId 和排序时间戳
  receivedMessageIds.add(finalMessageId);
  audioChunkReceiveTimeMap.set(finalMessageId, sortTimestamp);

  // 兼容旧逻辑：尝试从 rawMsg 中获取索引（如果后端提供了）
  let chunkIndex = null;
  if (
    rawMsg &&
    (rawMsg.index !== undefined ||
      rawMsg.chunkIndex !== undefined ||
      rawMsg.sequence !== undefined)
  ) {
    chunkIndex = rawMsg.index ?? rawMsg.chunkIndex ?? rawMsg.sequence;
  } else {
    // 如果后端没有提供索引，使用接收顺序作为索引（兼容旧逻辑）
    chunkIndex = expectedChunkIndex++;
  }

  // ✅ 优化5：使用Worker异步处理Base64转Blob（不阻塞主线程）
  base64ToBlobByWorker(audioBase64, (audioBlob, error) => {
    if (error || !audioBlob) {
      return;
    }

    if (isAudioBlockedWhileScreenOff) return;
    if (isTtsHardInterruptedWhileScreenOff) return;

    // ✅ 修复：暂停后 base64 解码回调延迟到达时，不再入队，避免旧音频在等待新响应时继续播放
    if (isManualStop || isStoppingAudio || isTemplateSwitching.value) return;
    if (lastPauseTime > 0 && receiveTimestamp < lastPauseTime) return; // 暂停前收到的旧片段直接丢弃
    if (currentAiMessageIndex < 0) {
      const inGrace = completeMessageReceivedAt > 0 && (Date.now() - completeMessageReceivedAt) < COMPLETE_GRACE_PERIOD_MS;
      if (!inGrace) return;
    }
    // 不在此处清除 lastPauseTime，否则延迟到达的旧 base64 回调会误入队导致「播放一下旧音频」

    try {
      // 存储音频数据（使用 messageId 作为 key）
      audioChunkDataMap.set(finalMessageId, {
        messageId: finalMessageId,
        blob: audioBlob,
        sentCount: sentCount, // ✅ 新增：sentCount 用于排序（优先级最高）
        serverTimestamp: serverTimestamp, // 服务端时间戳（优先）
        receiveTimestamp: receiveTimestamp, // 接收时间戳（回退）
        sortTimestamp: sortTimestamp, // 排序时间戳（服务端优先，否则接收时间）
        index: chunkIndex, // 保留索引用于兼容
      });

      // 兼容旧逻辑：记录索引（用于向后兼容）
      receivedChunkIndices.add(chunkIndex);
      audioChunkIndexMap.set(chunkIndex, audioBlob);
      maxReceivedChunkIndex = Math.max(maxReceivedChunkIndex, chunkIndex);

      // ✅ 按 sessionId 区分：不同 session 的片段不合并，避免多音轨混播
      const sessionId =
        rawMsg?.ttsSessionId ?? rawMsg?.sessionId ?? rawMsg?.session_id ?? ttsWsManager?.ttsSessionId ?? "default";

      // 1. 缓存到完整消息（用于重播）- 按 sentCount 排序，含 sessionId
      allAudioBlobsForCurrentMessage.push({
        messageId: finalMessageId,
        sessionId,
        sentCount: sentCount,
        serverTimestamp: serverTimestamp,
        receiveTimestamp: receiveTimestamp,
        sortTimestamp: sortTimestamp,
        index: chunkIndex,
        blob: audioBlob,
      });

      // 2. ✅ 关键优化：不再即时播放，先缓存到待合并队列（带 messageId、sentCount、sessionId、isAtPunctuation）
      pendingAudioBlobs.push({
        messageId: finalMessageId,
        sessionId, // 用于合并时按 session 分组，不同 session 不合并
        sentCount: sentCount, // ✅ 新增：sentCount 用于排序（优先级最高）
        serverTimestamp: serverTimestamp, // 服务端时间戳（优先）
        receiveTimestamp: receiveTimestamp, // 接收时间戳（回退）
        sortTimestamp: sortTimestamp, // 排序时间戳（服务端优先，否则接收时间）
        index: chunkIndex, // 保留用于兼容
        blob: audioBlob,
        isAtPunctuation, // 标点边界，用于在标点处切分减少句间卡顿
      });

      // ✅ 收到 TTS 片段即更新播放状态，文本渲染完但音频未播完时仍显示波纹
      updateAudioStateRefs();

      const timestampInfo = serverTimestamp
        ? `服务端时间: ${new Date(
            serverTimestamp
          ).toISOString()} (${serverTimestamp})`
        : `接收时间: ${new Date(
            receiveTimestamp
          ).toISOString()} (${receiveTimestamp})`;
      const sentCountInfo = sentCount !== null ? `sentCount: ${sentCount}` : "sentCount: 无";
      
      // ✅ 调试：输出原始消息，帮助排查 sentCount 问题
      if (sentCount === null && rawMsg) {
        console.warn("⚠️ [排序调试] 未找到 sentCount，原始消息:", rawMsg);
      }

      // ✅ 优化：如果收到 sentCount，优先使用 sentCount 排序
      if (sentCount !== null) {
      } else if (serverTimestamp) {
      } else {
      }

      // 3. ✅ 优化：移除缺失片段检查（减少开销）

      // 4. 清除之前的定时器
      if (pendingMergeTimeout) {
        clearTimeout(pendingMergeTimeout);
        pendingMergeTimeout = null;
      }

      // 首句音频在 complete 前只缓存不播放，避免过早切段导致卡顿
      if (!waitForInitialCompleteBeforePlay) {
        // 尝试立即播放（如果队列为空且已累积满第一条阈值）
        if (audioQueue.length === 0 && !isPlayingAudio && pendingAudioBlobs.length >= FIRST_BATCH_THRESHOLD) {
          mergeAndPlayPendingBlobs();
          if (pendingAudioBlobs.length === 0) {
            resetAudioReceiveTimeout();
            updatePlaybackStatus();
            return;
          }
        }

        // 播放中且已有下一批满 10 个：立即合并入队，减少片段间间隔
        if ((audioQueue.length > 0 || isPlayingAudio) && pendingAudioBlobs.length >= SUBSEQUENT_BATCH_SIZE) {
          mergeAndPlayPendingBlobs();
        }

        // 设置定时器，稍后合并剩余片段
        pendingMergeTimeout = setTimeout(() => {
          pendingMergeTimeout = null;
          setTimeout(() => {
            if (pendingAudioBlobs.length === 0) return;
            // 第一条：未满 30 不合并，等新 chunk 重新设定时器
            const isFirstBatch = audioQueue.length === 0 && !isPlayingAudio;
            if (isFirstBatch && pendingAudioBlobs.length < FIRST_BATCH_THRESHOLD) return;
            mergeAndPlayPendingBlobs();
          }, BASE64_DECODE_WAIT_MS);
        }, MERGE_DELAY_MS);
      }

      // 6. 重置音频接收超时定时器（每次收到音频时刷新倒计时）
      resetAudioReceiveTimeout();

      // 7. 更新播放状态
      updatePlaybackStatus();
    } catch (e) {
    }
  });
}

// 检查缺失的音频片段
function checkMissingChunks() {
  if (maxReceivedChunkIndex < 0) return;

  const missingIndices = [];
  for (let i = 0; i <= maxReceivedChunkIndex; i++) {
    if (!receivedChunkIndices.has(i)) {
      missingIndices.push(i);
    }
  }

  if (missingIndices.length > 0) {
  } else {
  }
}

// 清理音频索引追踪（统一清理函数）
function clearAudioChunkIndexTracking() {
  // 清理旧的数据结构（保留用于兼容）
  audioChunkIndexMap.clear();
  expectedChunkIndex = 0;
  receivedChunkIndices.clear();
  maxReceivedChunkIndex = -1;

  // ✅ 清理新的基于 messageId 和接收时间戳的数据结构
  audioChunkReceiveTimeMap.clear();
  receivedMessageIds.clear();
  audioChunkDataMap.clear();
}

// 处理 complete 消息：调用统一的音频完成处理逻辑
async function handleCompleteMessage() {
  // ✅ 创建对话的初始首句：complete 到了就放开播放
  if (waitForInitialCompleteBeforePlay) {
    waitForInitialCompleteBeforePlay = false;
    if (initialCompleteFallbackTimer) {
      clearTimeout(initialCompleteFallbackTimer);
      initialCompleteFallbackTimer = null;
    }
  }

  // 熄屏后 TTS 硬中断：complete 不进入合并播放/宽限逻辑
  if (isTtsHardInterruptedWhileScreenOff) {
    completeMessageReceivedAt = 0;
    return;
  }


  // ✅ 记录 complete 到达时间，addAudioChunkToSentence 在宽限期内仍接受延迟音频
  completeMessageReceivedAt = Date.now();

  // ✅ 熄屏期间：complete 只更新标记，不触发合并播放，避免碎片音频
  if (isAudioBlockedWhileScreenOff) {
    if (pendingMergeTimeout) {
      clearTimeout(pendingMergeTimeout);
      pendingMergeTimeout = null;
    }
    // 熄屏期间丢弃 complete 对应的宽限期逻辑，避免亮屏后把“离线到达”的 chunk 播放出来
    completeMessageReceivedAt = 0;
    return;
  }

  // ✅ 收到 complete 即取消延迟合并定时器，后续将一次性合并所有剩余内容
  if (pendingMergeTimeout) {
    clearTimeout(pendingMergeTimeout);
    pendingMergeTimeout = null;
  }

  // ✅ 延迟 COMPLETE_INITIAL_WAIT_MS 再处理，避免 complete 早于最后几句的 audio_chunk 到达（平板需更长）
  await new Promise((resolve) => setTimeout(resolve, COMPLETE_INITIAL_WAIT_MS));

  await handleAudioComplete();

  // ✅ 兜底：再等 1000ms 检查是否有延迟到达的音频片段（网络抖动时最后几句可能晚到）
  await new Promise((resolve) => setTimeout(resolve, 1000));
  if (pendingAudioBlobs.length > 0) {
    mergeAndPlayPendingBlobs(true); // complete 后全部 flush，保证不漏
  }

  // ✅ 宽限期结束前多次兜底（平板解码慢，分多次检查确保末尾片段不丢）
  const extraWait = COMPLETE_GRACE_PERIOD_MS - COMPLETE_INITIAL_WAIT_MS - 1000;
  if (extraWait > 0) {
    const stepMs = 500; // 平板部署统一
    let elapsed = 0;
    while (elapsed < extraWait) {
      const wait = Math.min(stepMs, extraWait - elapsed);
      await new Promise((resolve) => setTimeout(resolve, wait));
      elapsed += wait;
      if (pendingAudioBlobs.length > 0) {
        mergeAndPlayPendingBlobs(true);
      }
    }
  }

  // ✅ 宽限期结束，后续延迟到达的 chunk 将被拒绝
  completeMessageReceivedAt = 0;
}

// 切换模板中标志（防止新旧对话同时播放，模板中用于隐藏提示按钮）
const isTemplateSwitching = ref(false);
let skipWelcomeForNextConnection = false; // 模板切换后进入对话时，不播欢迎音、只播新对话首句

// ✅ 切换模板时：先暂停播放，再 finish 关闭，完全舍弃旧 TTS 和播放器，新建（async）
async function cutOffAllForTemplateSwitch() {
  isTemplateSwitching.value = true;
  lastPauseTime = Date.now(); // 拒绝延迟到达的旧 base64 回调，避免与新对话首句混播

  // ========== 0. 先调用暂停播放逻辑，确保旧音频完全停止后再执行后续 ==========
  await stopAudioOnly();

  // ========== 1. 立即停止所有播放和动画（同步） ==========
  stopFrameAnimation();
  stopQueueMonitor();
  if (audioPlayer.value) {
    try {
      audioPlayer.value.pause();
      audioPlayer.value.currentTime = 0;
      audioPlayer.value.src = "";
      if (audioPlayer.value.previousBlobUrl) {
        try { URL.revokeObjectURL(audioPlayer.value.previousBlobUrl); } catch (e) { /* ignore */ }
        audioPlayer.value.previousBlobUrl = null;
      }
    } catch (e) { /* ignore */ }
  }
  audioQueue.length = 0;
  isPlayingAudio = false;
  needsMediaChannelReactivationAfterRecord = false; // 切换模板后不沿用录音后的 2s 延迟，避免首句播放卡顿
  isAudioPlayingBlock = false;
  pendingAudioBlobs = [];
  pendingMergeCount = 0;
  if (pendingMergeTimeout) {
    clearTimeout(pendingMergeTimeout);
    pendingMergeTimeout = null;
  }
  receivedMessageIds.clear();
  audioChunkDataMap.clear();
  audioChunkReceiveTimeMap.clear();
  allAudioBlobsForCurrentMessage = [];
  completeMessageReceivedAt = 0;

  // ========== 2. 先 finish 原 TTS，等待完成后再关闭 ==========
  if (ttsWsManager && ttsWsManager.isReady()) {
    try {
      await ttsWsManager.finish();
      await new Promise((r) => setTimeout(r, 500)); // 等待服务端处理 finish
    } catch (e) {
    }
  }
  if (ttsWsManager) {
    ttsWsManager.close();
    ttsWsManager = null;
  }

  // ========== 3. 清空播放器（已移除 Web Audio TTS，仅 HTML5 Audio） ==========
  if (audioPlayer.value) {
    try {
      audioPlayer.value.pause();
      audioPlayer.value.currentTime = 0;
      audioPlayer.value.src = "";
      if (audioPlayer.value.previousBlobUrl) {
        try { URL.revokeObjectURL(audioPlayer.value.previousBlobUrl); } catch (e) { /* ignore */ }
        audioPlayer.value.previousBlobUrl = null;
      }
    } catch (e) { /* ignore */ }
  }

  // ========== 4. 中止接口、清空状态 ==========
  if (currentSpokenStream) {
    try {
      if (typeof currentSpokenStream.abort === "function") currentSpokenStream.abort();
    } catch (e) { /* ignore */ }
    currentSpokenStream = null;
  }
  if (currentTextToAudioStream) {
    try {
      if (typeof currentTextToAudioStream.abort === "function") currentTextToAudioStream.abort();
    } catch (e) { /* ignore */ }
    currentTextToAudioStream = null;
  }
  interruptAudioAndText();
  ttsSendQueue = [];
  isTtsSending = false;
  sentTextTotal.value = "";
  audioReceivedTextLength.value = 0;
  isTtsTextAllSent.value = false;
  processedTextLength = 0;
  textToAudioRecordIds = [];
  accumulatedText = "";
  renderedTextLength = 0;
  currentRenderingMessageIndex = -1;
  if (ttsFinishTimer) { clearTimeout(ttsFinishTimer); ttsFinishTimer = null; }
  if (audioReceiveTimeoutTimer) { clearTimeout(audioReceiveTimeoutTimer); audioReceiveTimeoutTimer = null; }
  if (template17AudioTimeoutTimer) { clearTimeout(template17AudioTimeoutTimer); template17AudioTimeoutTimer = null; }
  // ✅ 切换模板时必须 close 上下文，否则 resume 时旧 BufferSource 会继续播放导致「后半句播放两次」
  cleanupAudioPlayback();
  clearRecordingObject();
  stopRecording();
  stopVolumeCheck();
  stopAutoVolumeMonitoring();
  if (window.android && typeof window.android.callNative === "function") {
    try { window.android.callNative(JSON.stringify({ func: "getResetAudio" })); } catch (e) { /* ignore */ }
  }
  mediaChannelActivated = false;
  chatList.value = [];
  // ✅ 切换模板时清空提示相关数据
  promptContent.value = "";
  adviceContent.value = "";
  showTipsDialog.value = false;
  clearNoActionTimer(); // 清除闲置语音定时器，避免切换后误触发
  updateAudioStateRefs();
  setPlayingAudioState(false);
  // ✅ 重置暂停相关标记，避免新建对话的音频被误拦截
  isManualStop = false;
  isStoppingAudio = false;
}

// 清理音频播放资源（暂停/切换模板时调用，彻底清空 TTS 和音频）
function cleanupAudioPlayback() {
  // 停止动画
  stopFrameAnimation();
  // 停止文本渲染
  stopTextRendering();

  // ✅ 屏幕熄灭/停止时也要强制停止 Howler.js 播放，避免仅暂停 HTML5 Audio 后仍继续播
  if (currentHowlSound) {
    try {
      currentHowlSound.stop();
      currentHowlSound.unload();
    } catch (e) {
      // ignore
    }
    currentHowlSound = null;
  }

  // ✅ 新增：清理提示音频相关的定时器和状态
  cleanupTipAudio();

  // ✅ 清除闲置语音定时器，避免 cleanup 后 noActionTimer 到期误触发闲置语音（与 TTS 一起播放）
  clearNoActionTimer();

  // 清理事件监听器和超时
  cleanupCurrentLoadListeners();

  // ✅ 已移除 Web Audio TTS，仅 HTML5 Audio
  // ✅ 只使用 HTML5 Audio，清理播放器
  // 清理音频分片超时定时器（已移除 audioFlushTimer，无需清理）

  // 旧的 <audio> 播放器清理（目前主要用于回退或其他路径）
  if (audioPlayer.value) {
    try {
      audioPlayer.value.pause();
      audioPlayer.value.currentTime = 0;
      audioPlayer.value.src = "";
      if (audioPlayer.value.previousBlobUrl) {
        try {
          URL.revokeObjectURL(audioPlayer.value.previousBlobUrl);
        } catch (e) {
          // 忽略释放错误
        }
        audioPlayer.value.previousBlobUrl = null;
      }
    } catch (e) {
    }
  }

  // 释放 MediaSource URL 和队列中的 blob URL
  if (currentMediaSourceUrl) {
    try { URL.revokeObjectURL(currentMediaSourceUrl); } catch (e) { /* ignore */ }
    currentMediaSourceUrl = null;
  }
  currentPlayingBlob = null;
  audioQueue.forEach((item) => {
    if (typeof item === "string" && item && item.startsWith("blob:")) {
      try { URL.revokeObjectURL(item); } catch (e) { /* ignore */ }
    }
  });

  // 清空队列和状态
  audioQueue = [];
  isPlayingAudio = false;
  if (preloadAudio) {
    preloadAudio.src = "";
  }
  pausedForScreenOff = null; // 切换模板时清除熄屏保存的音频状态
  // 清空待合并的音频片段队列（防止暂停后继续播放）
  if (pendingMergeTimeout) {
    clearTimeout(pendingMergeTimeout);
    pendingMergeTimeout = null;
  }
  pendingMergeCount = 0;
  pendingAudioBlobs = [];
  allAudioBlobsForCurrentMessage = [];
  // 清空音频数据映射（防止暂停后继续接收和播放）
  receivedMessageIds.clear();
  audioChunkDataMap.clear();
  audioChunkReceiveTimeMap.clear();
  clearAudioChunkIndexTracking();
  consecutiveFailures = 0;

  // 清理待合并Blob数组和处理锁
  pendingAudioBlobs = [];
  allAudioBlobsForCurrentMessage = []; // 清理当前消息的音频片段缓存
  currentAiMessageIndex = -1; // 重置当前消息索引
  clearAudioChunkIndexTracking();
  isProcessingBlobs = false;
  isConvertingTextToAudio = false; // 重置文本转音频调用锁

  // 清理流式文本转音频相关状态
  processedTextLength = 0;
  textToAudioRecordIds = [];
  currentTextToAudioStream = null;

  // 清理 TTS finish 定时器
  if (ttsFinishTimer) {
    clearTimeout(ttsFinishTimer);
    ttsFinishTimer = null;
  }

  // 清理音频接收超时定时器
  if (audioReceiveTimeoutTimer) {
    clearTimeout(audioReceiveTimeoutTimer);
    audioReceiveTimeoutTimer = null;
  }
  // ✅ 新增：清理模板17的音频超时定时器
  if (template17AudioTimeoutTimer) {
    clearTimeout(template17AudioTimeoutTimer);
    template17AudioTimeoutTimer = null;
  }
  // ✅ 已移除：bufferWaitTimer 是 Web Audio 预解码的定时器，不再需要
  // 重置重试次数
  audioReceiveTimeoutRetryCount = 0;

  // 清理 TTS 发送队列
  ttsSendQueue = [];
  isTtsSending = false;
  ttsLastSendTime = 0;

  // 重置文本-音频跟踪变量
  sentTextTotal.value = "";
  audioReceivedTextLength.value = 0;
  isTtsTextAllSent.value = false;

  // ✅ 重置模板17等状态，防止残留
  isWaitingForMoreAudio = false;
  completeMessageReceivedAt = 0;
  pendingSessionSummary = null;

  // 清理 audioFinishTimer
  if (audioFinishTimer) {
    clearTimeout(audioFinishTimer);
    audioFinishTimer = null;
  }

  // ✅ 仅 finish 当前会话，不关闭连接（保持长连接）；下次播放时新建 TTS 实例并舍弃旧的
  if (ttsWsManager) {
    try {
      if (ttsWsManager.isReady()) ttsWsManager.finish();
    } catch (e) { /* ignore */ }
  }

  // 停止队列监控
  stopQueueMonitor();

  isAudioPlayingBlock = false;
  updateAudioStateRefs();
  updatePlaybackStatus();
}

// 启动队列监控（优化：避免空窗期）
function startQueueMonitor() {
  stopQueueMonitor();
  queueMonitorTimer = setInterval(() => {
    // 若队列有内容但尚未启动播放，自动唤醒播放
    if (!isPlayingAudio && audioQueue.length > 0) {
      initAudioPlayer();
      playNextAudio();
    }
    updatePlaybackStatus();
  }, 100); // 缩短检查间隔减少片段间卡顿
}

// 停止队列监控
function stopQueueMonitor() {
  if (queueMonitorTimer) {
    clearInterval(queueMonitorTimer);
    queueMonitorTimer = null;
  }
}

// 处理剩余的待合并片段（流式接收完成后调用，✅ 优化：统一使用合并函数）
async function flushPendingAudioBlobs() {
  if (pendingAudioBlobs.length === 0) {
    return;
  }

  // ✅ 统一使用合并函数处理（确保逻辑一致，避免重复播放）
  mergeAndPlayPendingBlobs();
}

// 播放第一条 AI 消息的音频（优化：移除audioClose的音频处理，避免重复播放）
async function playFirstAIMessageAudio(text, reportId) {
  if (!text || !aiToken.value) {
    return;
  }

  // 防止重复调用
  if (isConvertingTextToAudio) {
    return;
  }

  // 设置调用锁
  isConvertingTextToAudio = true;

  // 先清理之前的音频播放
  cleanupAudioPlayback();

  // 重置音频播放队列
  audioQueue = [];
  isPlayingAudio = false;
  pendingAudioBlobs = [];

  // 初始化音频播放器（确保事件处理器已设置）
  initAudioPlayer();

  try {
    let recordId = null; // 仅用于关闭服务端连接


    // 调用流式接口，接收音频片段
    await resultByTextToTTs(
      {
        prompt: text,
        reportId: reportId,
        // 可选：请求 Opus 格式（如果服务端支持）
        // audio_format: 'opus'
      },
      (data) => {

        // 检测结束状态（接口明确返回的结束标志）
        if (data && typeof data === "object") {
          // 检查常见的结束状态字段
          if (
            data.done === true ||
            data.finished === true ||
            data.isEnd === true ||
            data.status === "done" ||
            data.status === "finished" ||
            data.end === true
          ) {
          }

          // ✅ 优化：处理流式返回的音频数据（优先使用 audioData，兼容 audioBase64）
          const audioData = data.audioData || data.audioBase64;
          if (audioData) {
            // ✅ 关键优化：传递完整的 data 对象作为 rawMsg，以便提取 timestamp 和 messageId
            addAudioChunkToSentence(audioData, data);
          }

          // 更新recordId，用于关闭服务端连接
          if (data.recordId || data.id || data.record_id) {
            recordId = data.recordId || data.id || data.record_id || recordId;
          }
        } else if (
          data === "[DONE]" ||
          (typeof data === "string" && data.trim() === "[DONE]")
        ) {
          // 兼容字符串形式的结束标志
        }
      },
      aiToken.value
    );

    // 仅调用关闭接口释放服务端资源，不处理任何音频
    if (recordId && aiToken.value) {
      try {
        await audioClose(recordId, aiToken.value);
      } catch (error) {
      }
    } else {
    }

    // 处理剩余的待合并片段
    flushPendingAudioBlobs();

    // 流式接收完成后，若队列有音频未播放，启动播放
    if (audioQueue.length > 0 && !isPlayingAudio) {
      playNextAudio();
    }
  } catch (error) {
    showToast({
      message: "文字转音频失败，请重试",
      type: "fail",
    });
    isPlayingAudio = false;
    stopQueueMonitor();
  }
}

// 选择历史对话
const handleSelectHistory = (item) => {
  currentChatId.value = item.id;
  // 根据选择的对话类型切换到对应的 tab
  const tabMap = {
    对话: 1,
    口语主题对话模拟: 2,
    KET口语考试模拟: 3,
  };
  if (tabMap[item.type || item.title]) {
    promptId.value = tabMap[item.type || item.title];
  }
};

// 删除历史对话
const handleDeleteHistory = (item) => {
  // 可以在这里调用删除接口
  // 组件内部会自动更新列表
};

// 重置所有状态和逻辑（切换年级/模板时调用）
// skipCutOff: 为 true 时跳过 cutOffAllForTemplateSwitch（executePromptSwitch 已调用过）
async function resetAllStatesAndReconnect(skipCutOff = false) {
  
  // 1. 先 finish 再关闭，舍弃旧 TTS 和播放器（年级切换等场景需执行；模板切换时 executePromptSwitch 已调用，可跳过）
  if (!skipCutOff) {
    await cutOffAllForTemplateSwitch();
  }
  
  // 2. 关闭原有对话（如果有）
  if (currentChatId.value && aiToken.value) {
    try {
      await closeChat(currentChatId.value, aiToken.value);
    } catch (e) {
    }
  }
  
  // 3. 清空所有状态变量（含文本渲染状态）
  currentChatId.value = "";
  chatList.value = [];
  accumulatedText = "";
  renderedTextLength = 0;
  isResponding.value = false;
  isInSession.value = false;
  isConvertingVoiceToText.value = false;
  isEnteringConversation.value = false;
  // ✅ 年级切换不会自动进入对话，需手动复位该标记，否则页面会一直显示“加载中”
  isTemplateSwitching.value = false;
  isThemeChat.value = false;
  isFirstUserMessage.value = true;
  isDialogueEnded.value = false;
  shouldSaveRecording = true;
  lastVoiceTime = 0;
  if (currentSpokenStream && typeof currentSpokenStream.abort === "function") {
    currentSpokenStream.abort();
    currentSpokenStream = null;
  } else {
    currentSpokenStream = null;
  }
  audioChunks = [];
  
  // 4. 关闭对话框
  showDialogBox.value = false;
  
  // 5. 清空闲置语音定时器
  if (ttsFinishTimer) {
    clearTimeout(ttsFinishTimer);
    ttsFinishTimer = null;
  }
  if (noActionTimer) {
    clearTimeout(noActionTimer);
    noActionTimer = null;
  }
  clearNoActionTimer();
  
  // 6. 更新音频状态引用
  updateAudioStateRefs();
  
}

// 处理年级选择确认（点击确定按钮后）
const handleGradeChangeConfirm = (gradeInfo) => {
  
  // ✅ 关闭年级选择弹窗
  showGradeDialog.value = false;
  
  // ✅ 如果有当前对话，先显示确认弹窗
  if (currentChatId.value) {
    pendingGradeChange.value = gradeInfo;
    showSwitchConfirmDialog.value = true;
    return;
  }
  
  // ✅ 如果没有当前对话，直接执行切换
  handleGradeChange(gradeInfo);
};

// 处理年级选择（确认后执行）
const handleGradeChange = async (gradeInfo) => {
  // 关闭切换确认弹窗，避免切换完成后仍停留在确认态
  showSwitchConfirmDialog.value = false;
  
  // ✅ 重置所有状态和逻辑
  await resetAllStatesAndReconnect();
  
  // ✅ 更新年级信息（后续页面的 gradeId 都以这个为准）
  gradeId.value = gradeInfo.gradeId;
  gradeName.value = gradeInfo.gradeName;
  // 更新映射表
  gradeListMap.value.set(gradeInfo.gradeId, gradeInfo.gradeName);
};

// 跳转到历史对话
const handleToHistory = (messages) => {
  const parseMsgExt = (msg) => {
    if (!msg || !msg.ext) return null;
    try {
      return typeof msg.ext === "string" ? JSON.parse(msg.ext) : msg.ext;
    } catch (e) {
      return null;
    }
  };

  if (messages && messages.length > 0) {
    historyChatList.value = messages.map((msg) => {
      const rawRole = String(msg.role || "").toLowerCase();
      const normalizedRole = rawRole === "user" ? "user" : "ai";
      const message = {
        role: normalizedRole,
        content: msg.context || msg.content || "",
        renderedContent: "",
        createTime: msg.createTime || "",
      };

      const ext = parseMsgExt(msg);
      if (ext && normalizedRole === "user") {
        message.errorStatus = ext.errorStatus;
        message.score = ext.score;
        message.updateErrorContent = ext.updateErrorContent || "";
        message.promptContent = ext.promptContent || "";
        message.correctedExample = ext.correctedExample || "";
      }
      if (ext && normalizedRole === "ai") {
        message._historyAssistantExt = ext;
      }

      return message;
    });

    // 主题历史接口：纠错字段在紧邻的下一条 assistant 的 ext 上，合并到对应的 user 气泡
    for (let i = 0; i < historyChatList.value.length - 1; i++) {
      const cur = historyChatList.value[i];
      const next = historyChatList.value[i + 1];
      if (cur.role !== "user" || next.role !== "ai" || !next._historyAssistantExt) {
        continue;
      }
      const ext = next._historyAssistantExt;
      if (ext.errorStatus === 0) {
        cur.errorStatus = 0;
        cur.correctedExample =
          ext.correctedExample != null && ext.correctedExample !== undefined
            ? String(ext.correctedExample)
            : "";
        cur.updateErrorContent =
          ext.updateErrorContent != null && ext.updateErrorContent !== undefined
            ? String(ext.updateErrorContent)
            : "";
      } else if (ext.errorStatus === 1) {
        cur.errorStatus = 1;
        if (ext.score !== undefined && ext.score !== null) {
          cur.score = ext.score;
        }
      }
      delete next._historyAssistantExt;
    }

    initHistoryChatList();
  } else {
    historyChatList.value = [];
  }

  showHistoryPage.value = true;
  showHistoryDialog.value = false;
};

// ✅ 优化3：重播指定消息的音频（直接使用完整Blob，和首次播放一致）
async function replayAudioForMessage(messageIndex) {
  const message = chatList.value[messageIndex];
  if (
    !message ||
    message.role !== "ai" ||
    !message.audioBlobs ||
    message.audioBlobs.length === 0
  ) {
    return;
  }


  // 停止当前播放的音频
  stopAIAudioPlayback();

  // 清空队列，准备播放重播的音频（只使用 HTML5 Audio）
  audioQueue = [];

  // ✅ 优化3：优先使用完整Blob（首次播放完成后缓存的是完整Blob，通常只有1个）
  // 直接播放完整Blob，和首次播放逻辑一致，避免分片处理
  if (message.audioBlobs.length === 1) {
    const completeBlob = message.audioBlobs[0];
    if (completeBlob && completeBlob.size > 0) {
      try {
        const blobCopy = completeBlob.slice(
          0,
          completeBlob.size,
          completeBlob.type
        );
        enqueueWebAudioBlob(blobCopy);
        return;
      } catch (e) {
      }
    }
  }

  // 兜底：如果缓存的是多个片段（兼容旧数据），逐个入队
  for (let i = 0; i < message.audioBlobs.length; i++) {
    const blob = message.audioBlobs[i];
    if (blob && blob.size > 0) {
      try {
        const blobCopy = blob.slice(0, blob.size, blob.type);
        enqueueWebAudioBlob(blobCopy);
      } catch (e) {
      }
    } else {
    }
  }

}

// 获取模板列表（使用 aiAuth 获取到的 aiToken）
function fetchPromptList() {
  // 使用 aiAuth 获取到的 aiToken，而不是安卓给的 token
  if (!aiToken.value) {
    return;
  }

  getPromptList(aiToken.value)
    .then(async (res) => {
      if ((res.code === 200 || res.code === 0) && res.data) {
        promptList.value = res.data;
        
        promptId.value = res.data[0].promptId;
        // ✅ 修改：模板列表加载成功后，标记为可以进入对话，显示"进入对话"按钮
        isReadyToEnterConversation.value = true;
        
        // ✅ 修改：模板加载完成后，直接播放提示音频（使用本地文件，不需要TTS）
        // 注意：不在创建对话之前初始化TTS，只有在真正创建对话时才初始化TTS
          // 延迟一下，确保状态已更新
        setTimeout(() => {
          try {
            // 直接播放提示音频（使用本地文件，不需要TTS）
                    playRandomWelcomeTip();
                  } catch (error) {
            }
          }, 500); // 延迟500ms，确保所有状态已初始化
      } else {
        showToast({
          message: "获取模板列表失败，请重试",
          type: "fail",
        });
      }
    })
    .catch((error) => {
      // 检测跨域错误
      if (
        error instanceof TypeError &&
        (error.message.includes("Failed to fetch") ||
          error.message.includes("NetworkError") ||
          error.message.includes("Network request failed"))
      ) {
        showToast({
          message: "网络错误，请检查网络连接",
          type: "fail",
        });
      } else {
        showToast({
          message: "获取模板列表失败，请重试",
          type: "fail",
        });
      }
    });
}

// 供原生调用的函数（与 chat 页面保持一致的 token / aiAuth 逻辑）
function callJS(data) {
  const res = JSON.parse(data);
  // ✅ 处理从安卓读取 ttsSessionId 的回调
  if (res.func == "getDecodeDataMMKV" && res.params && res.params.keyStr === "ttsSessionId") {
    const val = res.params.valueStr;
    lastTtsSessionIdFromAndroid.value = val && String(val).trim() ? String(val).trim() : null;
    return;
  }
  // ✅ 处理从安卓读取 lastFinishedTtsSessionId 的回调
  if (res.func == "getDecodeDataMMKV" && res.params && res.params.keyStr === "lastFinishedTtsSessionId") {
    const val = res.params.valueStr;
    lastFinishedTtsSessionIdFromAndroid.value = val && String(val).trim() ? String(val).trim() : null;
    return;
  }
  if (res.func == "getToken") {
    // ✅ 第一步：保存普通token到本地存储（安卓返回的accessToken）
    localStorage.setItem("token", res.params.accessToken);
    
    // ✅ 从安卓的 getToken 事件中获取 gradeId
    gradeId.value = res.params.gradeId || "1";
    planId.value = res.params.planId;
    tutoringId.value = res.params.tutoringId;
    
    // 保存设备类型
    localStorage.setItem("deviceType", res.params.device);

    // 获取 host（可能是 host、baseUrl、domain 等字段）
    const host =
      res.params.host ||
      res.params.baseUrl ||
      res.params.domain ||
      res.params.hostname ||
      "";
    if (host) {
      // 构建完整的 baseUrl
      const protocol = host.startsWith("http")
        ? ""
        : window.location.protocol === "https:"
        ? "https://"
        : "http://";
      const dynamicBaseUrl = `${protocol}${host}/fzd-ceplatform-englishapp`;
      const dynamicRagBaseUrl = `${protocol}${host}/fzd-ceplatform-rag`;

      // 保存到 localStorage，供 request.js 使用
      localStorage.setItem("dynamicBaseUrl", dynamicBaseUrl);
      localStorage.setItem("dynamicRagBaseUrl", dynamicRagBaseUrl);
      localStorage.setItem("dynamicHost", host);

    }

    // ✅ 第二步：获取年级列表（使用刚刚保存的普通token）
    fetchGradeListData().then(() => {
      // ✅ 根据 gradeId 更新 gradeName（年级列表获取完成后）
      updateGradeNameById(gradeId.value);
    }).catch((err) => {
      // 即使失败也尝试更新 gradeName
      updateGradeNameById(gradeId.value);
    });

    // ✅ 第三步：调用AI服务认证接口获取aiToken（使用刚刚保存的普通token）
    aiAuth()
      .then((authRes) => {
        if (authRes.code === 200 && authRes.data) {
          aiToken.value = authRes.data;
          // 获取模板列表
          fetchPromptList();
          // ✅ 修改：不再在获取token后自动开启录音，等待用户点击"进入对话"按钮
        } else {
          // 如果接口返回失败或没有 data，使用固定的 token 作为兜底
          aiToken.value = FALLBACK_AI_TOKEN;
          fetchPromptList();
        }
      })
      .catch((error) => {
        // 检测跨域错误
        if (
          error instanceof TypeError &&
          (error.message.includes("Failed to fetch") ||
            error.message.includes("NetworkError") ||
            error.message.includes("Network request failed"))
        ) {
          showToast({
            message: "网络错误，请检查网络连接",
            type: "fail",
          });
        } else {
          showToast({
            message: "AI服务认证失败，请重试",
            type: "fail",
          });
        }
        // 认证失败时，使用固定的 token 作为兜底
        aiToken.value = FALLBACK_AI_TOKEN;
        fetchPromptList();
      });
  }
  if (res.func == "getUserInfo") {
    userInfo.value = res.params || null; // 参考 chat 页面，使用 null 作为默认值
  }
  if (res.func == "getShowKeyBoard") {
    if (!res.params.canShow) {
      changeblur();
    } else {
      changefocus();
    }
  }
  if (res.func == "actOnDestroy") {
    // 收到销毁事件，关闭所有音频并清理资源

    // 清理录音资源（包括停止录音、停止音量检测等）
    cleanupRecording();

    // 清理音频播放资源（包括停止播放、清理队列、关闭 WebSocket 等）
    cleanupAudioPlayback();

    // 清理所有状态
    isInSession.value = false;
    isResponding.value = false;
    isConvertingVoiceToText.value = false;
    chatList.value = [];
    currentChatId.value = "";
    // 清空对话ID后，停止自动监听
    stopAutoVolumeMonitoring();
    
    // ✅ 重置主题对话标志
    isThemeChat.value = false;
    isFirstUserMessage.value = true;

  }
  
  // ✅ 监听屏幕关闭事件（actOnPause）- 全部掐断播放并保存状态
  if (res.func == "actOnPause") {
    handleScreenOff();
    isSendButtonProcessing.value = false;
    isManualStop = false;
    isManualStopAudioOnly = false;
  }

  // ✅ 监听屏幕打开事件（actOnResume）- 恢复音频和计时器
  if (res.func == "actOnResume") {
    handleScreenOn();
  }
}

// 请求 token（与 chat 页面保持一致）
function getAndroidData() {
  const tokenRequest = JSON.stringify({
    func: "getToken",
  });
  const msg = JSON.stringify({
    func: "getUserInfo",
  });
  const closeLoading = JSON.stringify({
    func: "canPlayGame",
  });
  if (window.android) {
    window.android.callNative(tokenRequest);
    window.android.callNative(msg);
    window.android.callNative(closeLoading);
  }
}

// 选择模板（有对话时：点击 tab 只弹窗不暂停，确认后才暂停切换；无对话时：直接切换不弹窗）
const handleSelectPrompt = async (item) => {
  // ✅ 如果点击的是当前已选择的tab，直接返回，不弹窗
  if (promptId.value == item.promptId) {
    return;
  }

  // ✅ 有对话时：显示确认弹窗，不暂停音频；确认后才执行 cutOff 切换
  if (currentChatId.value) {
    pendingPromptChange.value = item;
    showSwitchConfirmDialog.value = true;
    return;
  }

  // ✅ 没进入对话时：直接切换模板，不断语音（欢迎音等继续播放）
  promptId.value = item.promptId;
};

// 执行模板切换（确认后执行）
const executePromptSwitch = async (item) => {
  promptId.value = item.promptId;
  // ✅ 1. 先 finish 再关闭，完全舍弃旧 TTS 和播放器
  await cutOffAllForTemplateSwitch();

  // ✅ 2. 重置所有状态（关闭对话、清空状态、清空 chatList），跳过重复的 cutOff
  await resetAllStatesAndReconnect(true);

  // ✅ 3. 延迟后再创建新对话，确保资源完全释放，避免新模版第一句音频卡顿或播放不完整
  await new Promise((r) => setTimeout(r, 800));

  // ✅ 4. 和最初流程一样：重新创建对话（fromTemplateSwitch 确保不播欢迎音、只播新对话首句）
  await handleEnterConversation({ fromTemplateSwitch: true });
};

// 处理切换确认弹窗的确认操作
const handleSwitchConfirm = async () => {
  
  // 处理五轮结束后点击录音
  if (pendingDialogueEndedRecord.value) {
    pendingDialogueEndedRecord.value = false;
    showSwitchConfirmDialog.value = false;
    isDialogueEnded.value = false;
    await resetAllStatesAndReconnect();
    await handleEnterConversation();
    return;
  }
  
  // 处理年级切换
  if (pendingGradeChange.value) {
    const gradeInfo = pendingGradeChange.value;
    pendingGradeChange.value = null;
    await handleGradeChange(gradeInfo);
    return;
  }
  
  // 处理模板切换
  if (pendingPromptChange.value) {
    const item = pendingPromptChange.value;
    pendingPromptChange.value = null;
    showSwitchConfirmDialog.value = false; // 立即关闭弹窗，让用户看到掐断效果
    await executePromptSwitch(item);
    return;
  }
};

// 处理切换确认弹窗的取消操作
const handleSwitchCancel = () => {
  pendingDialogueEndedRecord.value = false;
  pendingGradeChange.value = null;
  pendingPromptChange.value = null;
};

// 发送测试消息
async function handleSendTestMessage() {
  const testMessage = "my name is xiaoming";

  // 检查必要参数
  if (!currentChatId.value || !aiToken.value) {
    showToast("请先创建对话");
    return;
  }

  // 确保对话框已打开，以便用户能看到消息
  if (!showDialogBox.value) {
    showDialogBox.value = true;
    await nextTick();
  }

  // 添加用户消息到聊天列表
  chatList.value.push({
    role: "user",
    content: testMessage,
    renderedContent: renderMath(testMessage),
  });

  // 添加 AI 消息占位符（带 loading 状态）
  const aiMessageIndex = chatList.value.length;
  chatList.value.push({
    role: "ai",
    content: "",
    renderedContent: "",
    loading: true,
    audioBlobs: [], // 用于缓存该消息的所有音频 Blob
  });

  // 滚动到底部
  nextTick(() => {
    scrollBoxToBottom();
    if (showDialogBox.value) {
      scrollBoxToBottom();
    }
  });

  // 调用 sendSpokenMessage 函数，复用原有的完整逻辑（包括 TTS 连接初始化等）
  // 发送消息前，重置 finish 标志（不允许录音，需要等待新的 finish）
  isFinishSuccess.value = false;
  await sendSpokenMessage(testMessage, aiMessageIndex);
}

// 调试快捷发送（点击按钮直接发送，无需麦克风）
async function handleDebugSend(userMessage) {
  clearManualStopFlags();
  if (!currentChatId.value || !aiToken.value) {
    showToast({
      message: "请先点击「进入对话」",
      type: "fail",
    });
    return;
  }
  if (isDialogueEnded.value) {
    showToast({
      message: "对话已结束，请创建新对话",
      type: "fail",
    });
    return;
  }
  if (!showDialogBox.value) {
    showDialogBox.value = true;
    await nextTick();
  }
  chatList.value.push({
    role: "user",
    content: userMessage,
    renderedContent: renderMath(userMessage),
  });
  if (isThemeChat.value) {
    await sendThemeMessage(userMessage);
  } else {
    const aiMessageIndex = chatList.value.length;
    chatList.value.push({
      role: "ai",
      content: "",
      renderedContent: "",
      loading: true,
      audioBlobs: [],
    });
    nextTick(() => {
      scrollBoxToBottom();
      if (showDialogBox.value) scrollBoxToBottom();
    });
    isFinishSuccess.value = false;
    await sendSpokenMessage(userMessage, aiMessageIndex);
  }
  nextTick(() => {
    scrollBoxToBottom();
    if (showDialogBox.value) scrollBoxToBottom();
  });
}

// 返回按钮点击事件
const handleBackClick = () => {
  if (showHistoryPage.value) {
    showHistoryPage.value = false;
    return;
  }
  const quitRequest = JSON.stringify({
    func: "quit",
  });
  if (window.android) {
    window.android.callNative(quitRequest);
  }
};

// 播放前强制停止任何正在进行的录音，并释放录音资源（确保 TTS 走媒体通道）
function stopAnyRecording() {
  if (isInSession.value) {
    shouldSaveRecording = false;
    stopRecording();
  }
  forceReleaseRecordingStreamForPlayback();
}

// 录音结束后释放麦克风流（不重新初始化）
// ✅ 已改为全程保持录音通道：不再释放，避免播放时通道切换导致音量突变
function releaseRecordingStreamWhenIdle() {
  // 释放持久录音流，确保系统退出通话模式，TTS 使用媒体音量
  forceReleaseRecordingStreamForPlayback();
}

// 强制释放录音对象（仅用于闲置语音播放前，因录音占用通话通道会导致音量无法控制）
function forceReleaseRecordingStreamForPlayback() {
  try {
    if (persistentRecordingStream) {
      persistentRecordingStream.getTracks().forEach((track) => {
        try {
          track.stop();
        } catch (e) {
          // ignore
        }
      });
      persistentRecordingStream = null;
    }
    if (persistentAudioContext && persistentAudioContext.state !== "closed") {
      persistentAudioContext.close().catch(() => {});
      persistentAudioContext = null;
    }
    persistentAnalyser = null;
    microphoneInitialized = false;
  } catch (e) {
  }
}

// 清除录音对象（切换模板/年级时调用，释放麦克风等资源，不重新初始化）
function clearRecordingObject() {
  try {
    stopVolumeCheck();
    stopAutoVolumeMonitoring();
    if (mediaRecorder && mediaRecorder.state === "recording") {
      try {
        mediaRecorder.stop();
      } catch (e) {
      }
    }
    mediaRecorder = null;
    if (persistentRecordingStream) {
      persistentRecordingStream.getTracks().forEach((track) => {
        try {
          track.stop();
        } catch (e) {
          // ignore
        }
      });
      persistentRecordingStream = null;
    }
    if (persistentAudioContext && persistentAudioContext.state !== "closed") {
      persistentAudioContext.close().catch(() => {});
      persistentAudioContext = null;
    }
    persistentAnalyser = null;
    microphoneInitialized = false;
    initMicrophonePromise = null; // 清除待完成的初始化 Promise，避免复用旧流
    audioChunks = [];
    lastVoiceTime = 0;
  } catch (e) {
  }
}

// 清理录音资源（参考 VoicePop 的实现）
// 重新加载所有录音相关的资源
async function reloadRecordingResources() {
  // 1. 停止音量检测和自动监听
  stopVolumeCheck();
  stopAutoVolumeMonitoring();

  // 2. 停止录音
  stopRecording();

  // 3. 清理旧的录音流
  if (persistentRecordingStream) {
    try {
      persistentRecordingStream.getTracks().forEach((track) => {
        track.stop();
      });
    } catch (e) {
    }
    persistentRecordingStream = null;
  }

  // 4. 清理旧的音频上下文和分析器
  if (persistentAudioContext && persistentAudioContext.state !== "closed") {
    try {
      await persistentAudioContext.close();
    } catch (e) {
    }
    persistentAudioContext = null;
  }
  persistentAnalyser = null;

  // 5. 重置初始化标志
  microphoneInitialized = false;

  // 6. 清理录音数据
  audioChunks = [];
  lastVoiceTime = 0;

  // 7. 重新初始化麦克风流
  await initMicrophoneStream();
}

function cleanupRecording() {
  // 停止音量检测
  stopVolumeCheck();

  // 停止自动监听
  stopAutoVolumeMonitoring();

  // 使用统一的 stopRecording 函数（参考 VoicePop）
  stopRecording();

  // 重置保存标记（参考 VoicePop）
  shouldSaveRecording = true;

  if (currentSpokenStream && typeof currentSpokenStream.abort === "function") {
    currentSpokenStream.abort();
    currentSpokenStream = null;
  }

  audioChunks = [];
  isResponding.value = false;
  isInSession.value = false;
  isConvertingVoiceToText.value = false;
  lastVoiceTime = 0;

  // 停止文本渲染
  stopTextRendering();

  // 清理音频播放资源
  cleanupAudioPlayback();

  // 清理 TTS finish 定时器
  if (ttsFinishTimer) {
    clearTimeout(ttsFinishTimer);
    ttsFinishTimer = null;
  }

  // 清理 TTS WebSocket 连接
  if (ttsWsManager) {
    ttsWsManager.close();
    ttsWsManager = null;
  }
}

// ===== 自动音量监听相关函数 =====
// ✅ 已禁用：不再使用音量监听，改为播放完音频后直接开启录音

// 启动自动音量监听（已禁用）
async function startAutoVolumeMonitoring() {
  // ✅ 已禁用：不再使用音量监听，改为播放完音频后直接开启录音
  return;
}

// 开始自动音量检测（已禁用）
function startAutoVolumeCheck() {
  // ✅ 已禁用：不再使用音量监听
  return;
}

// 从自动监听启动录音（音量达到阈值时，已禁用）
async function startRecordingFromAuto() {
  // ✅ 已禁用：不再使用音量监听，改为播放完音频后直接开启录音
  return;
}

// 已移除：不再自动转文本发送，改为点击按钮才转文本发送

// 停止自动音量监听
function stopAutoVolumeMonitoring() {
  isAutoVolumeMonitoring = false;
  isAutoVolumeMonitoringRef.value = false;

  if (autoVolumeCheckTimer) {
    clearInterval(autoVolumeCheckTimer);
    autoVolumeCheckTimer = null;
  }

  if (autoVolumeTimeoutTimer) {
    clearTimeout(autoVolumeTimeoutTimer);
    autoVolumeTimeoutTimer = null;
  }

  if (autoVolumeSource) {
    autoVolumeSource.disconnect();
    autoVolumeSource = null;
  }

  if (autoVolumeAnalyser) {
    autoVolumeAnalyser = null;
  }

  if (autoVolumeContext && autoVolumeContext.state !== "closed") {
    autoVolumeContext.close().catch(() => {});
    autoVolumeContext = null;
  }

  if (autoVolumeStream) {
    autoVolumeStream.getTracks().forEach((track) => track.stop());
    autoVolumeStream = null;
  }

  // 停止自动录音（如果正在录音）
  if (
    autoRecordingMediaRecorder &&
    autoRecordingMediaRecorder.state !== "inactive"
  ) {
    autoRecordingMediaRecorder.stop();
    autoRecordingMediaRecorder = null;
  }
  autoRecordingChunks = [];

}

// 初始化麦克风流（提升到模块作用域，供其他函数调用）
async function initMicrophoneStream() {
  // ✅ 先关闭已有的录音对象，再创建新的（避免切换模板后残留旧流导致重复占用麦克风）
  if (persistentRecordingStream || mediaRecorder) {
    clearRecordingObject();
  }
  if (microphoneInitialized) {
    return;
  }
  if (initMicrophonePromise) {
    return initMicrophonePromise;
  }

  initMicrophonePromise = (async () => {
  try {
    // 直接获取并保持流，不先检查权限再关闭
    persistentRecordingStream = await navigator.mediaDevices.getUserMedia({
      audio: {
        sampleRate: 16000,
        channelCount: 1,
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
        // ✅ 修复：禁用监听音频（monitoring），避免产生无法控制的音频输出
        // 在某些设备上，录音流可能会产生监听音频，这里明确禁用
        suppressLocalAudioPlayback: true, // 禁用本地音频播放（如果支持）
      },
    });

    // ✅ 平板部署：不在 init 时创建 analyser，延后到 startRecording 中（避免 MediaRecorder 录到静音）

    microphoneInitialized = true;
    // 注：不在此处 resume webAudioTtsContext，否则会继续播放暂停前已调度的 buffer

    // ✅ 修改：移除自动开启录音逻辑，改为只能通过长按按钮开启录音
  } catch (error) {
    
    // 检查是否是权限被拒绝
    const isUserNotAllow =
      error.name === "NotAllowedError" || error.name === "PermissionDeniedError";
    if (isUserNotAllow) {
      // 不设置 errorMsg，不提示用户，静默失败
      throw error;
    }
    
    // 其他错误也抛出
    throw error;
  }
  })().finally(() => {
    initMicrophonePromise = null;
  });
  return initMicrophonePromise;
}

// pagehide 事件处理函数（目前仅作为占位，避免自动关闭对话）
let pagehideHandler = null;

// ✅ 平板部署：优化已统一应用
function applyTabletOptimizations() {
  // 注：平板参数已统一，此处仅保留占位
}

// ✅ 新增：Web Audio API 音频合并（更高效）
async function mergeAudioWithWebAudio(blobs) {
  if (!blobs || blobs.length === 0) {
    throw new Error("Blob数组为空");
  }
  
  if (blobs.length === 1) {
    return blobs[0];
  }

  // 创建音频上下文
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();

  // 解码所有音频
  const audioBuffers = await Promise.all(
    blobs.map(async (blob) => {
      const arrayBuffer = await blob.arrayBuffer();
      return await audioContext.decodeAudioData(arrayBuffer);
    })
  );

  // 计算总长度
  const totalLength = audioBuffers.reduce((sum, buffer) => sum + buffer.length, 0);
  const sampleRate = audioBuffers[0].sampleRate;
  const numberOfChannels = audioBuffers[0].numberOfChannels;

  // 创建新的音频缓冲区
  const mergedBuffer = audioContext.createBuffer(
    numberOfChannels,
    totalLength,
    sampleRate
  );

  // 合并音频数据
  let offset = 0;
  for (const buffer of audioBuffers) {
    for (let channel = 0; channel < numberOfChannels; channel++) {
      const channelData = buffer.getChannelData(channel);
      mergedBuffer.getChannelData(channel).set(channelData, offset);
    }
    offset += buffer.length;
  }

  // 转换为WAV格式
  const wavBlob = await audioBufferToWav(mergedBuffer);

  // 清理
  audioContext.close();

  return wavBlob;
}

// ✅ 新增：AudioBuffer转WAV格式
async function audioBufferToWav(audioBuffer) {
  const numberOfChannels = audioBuffer.numberOfChannels;
  const sampleRate = audioBuffer.sampleRate;
  const length = audioBuffer.length * numberOfChannels * 2;
  
  const buffer = new ArrayBuffer(44 + length);
  const view = new DataView(buffer);
  
  // WAV文件头
  writeString(view, 0, 'RIFF');
  view.setUint32(4, 36 + length, true);
  writeString(view, 8, 'WAVE');
  writeString(view, 12, 'fmt ');
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, numberOfChannels, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * numberOfChannels * 2, true);
  view.setUint16(32, numberOfChannels * 2, true);
  view.setUint16(34, 16, true);
  writeString(view, 36, 'data');
  view.setUint32(40, length, true);
  
  // 写入音频数据
  const channels = [];
  for (let i = 0; i < numberOfChannels; i++) {
    channels.push(audioBuffer.getChannelData(i));
  }
  
  let offset = 44;
  for (let i = 0; i < audioBuffer.length; i++) {
    for (let channel = 0; channel < numberOfChannels; channel++) {
      const sample = Math.max(-1, Math.min(1, channels[channel][i]));
      view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
      offset += 2;
    }
  }
  
  return new Blob([buffer], { type: 'audio/wav' });
}

onMounted(async () => {
  // ✅ 挂载后初始化播放状态 refs，避免首次渲染时状态不一致导致 Vue 内部错误
  nextTick(() => {
    updateAudioStateRefs();
    updatePlaybackStatus();
  });

  // ✅ 设备检测和优化配置输出（所有设备统一应用优化配置）
  const deviceType = "平板";

  // ✅ Android平板音频通道修复：设置全局监听器
  setupAndroidAudioListeners();

  // 设置 callJS 函数供原生调用
  window.callJS = callJS;

  // ✅ 请求从安卓读取 ttsSessionId 和 lastFinishedTtsSessionId（用于新建对话时判断是否需补发 finish）
  loadTtsSessionIdFromAndroid();
  loadLastFinishedTtsSessionIdFromAndroid();

  // ✅ 优化5：初始化音频处理Worker（主线程减负）
  initAudioWorker();

  // ✅ 打印设备状态（用于排查平板跳过等问题）
  logDeviceStatus();

  // ✅ 新增：应用平板设备优化
  applyTabletOptimizations();

  // 初始化历史对话数据的 renderedContent
  initHistoryChatList();

  // 预加载动画帧图片
  preloadImages();

  // ✅ 修改：不再在页面加载时自动初始化录音流
  // 改为等待用户点击"进入对话"按钮后再初始化，以满足浏览器必须点击逻辑

  // ===== 本地调试模式：开发环境下直接使用固定的 aiToken =====
  if (process.env.NODE_ENV === "development") {
    // 直接设置 aiToken（用于本地调试）
    aiToken.value = FALLBACK_AI_TOKEN;

    // 设置默认用户信息（用于本地调试）
    userInfo.value = {
      nickname: "测试用户",
      grade: "1",
    };

    // 设置默认的 gradeId、planId、tutoringId（用于本地调试）
    gradeId.value = "1";
    gradeName.value = "一年级"; // 设置默认年级名称
    planId.value = "test-plan-id";
    tutoringId.value = "test-tutoring-id";

    // ✅ 获取年级列表（页面初始化时调用）
    fetchGradeListData();

    // 直接获取模板列表
    fetchPromptList();

  } else {
    // 生产环境：请求 token -> 内部会通过 callJS 回调进行 aiAuth
    // ✅ 注意：getAndroidData() 会立即调用，不依赖用户交互
    
    getAndroidData();

    // 设置超时检查：如果 5 秒后还没有获取到 aiToken，使用固定 token 作为兜底
    setTimeout(() => {
      if (!aiToken.value) {
        aiToken.value = FALLBACK_AI_TOKEN;
        // 设置默认用户信息（用于兜底）
        if (!userInfo.value || Object.keys(userInfo.value).length === 0) {
          userInfo.value = {
            nickname: "用户",
            grade: "1",
          };
        }
        if (!gradeId.value) {
          gradeId.value = "1";
          gradeName.value = "一年级"; // 设置默认年级名称
        } else {
          // 如果已经有 gradeId，更新对应的 gradeName
          updateGradeNameById(gradeId.value);
        }
        if (!planId.value) {
          planId.value = "fallback-plan-id";
        }
        if (!tutoringId.value) {
          tutoringId.value = "fallback-tutoring-id";
        }
        // 获取模板列表
        fetchPromptList();
      }
    }, 5000);
  }

  // 初始化 FFmpeg（异步加载，不阻塞主流程）
  if (ENABLE_SILENCE_TRIM) {
    initFFmpeg().catch((err) => {
    });
  }
});

onUnmounted(() => {
  invalidateVoiceChain();
  abortMp3ToTextRequest();
  abortThemeChatRequest();
  // 停止录音波浪可视化
  stopRecordingWaveVisualization();
  // 清除15秒无操作定时器
  clearNoActionTimer();
  // 移除 pagehide 和 beforeunload 事件监听器
  if (pagehideHandler) {
    window.removeEventListener("pagehide", pagehideHandler);
    window.removeEventListener("beforeunload", pagehideHandler);
    pagehideHandler = null;
  }

  // ✅ 优化5：清理音频处理Worker
  if (audioWorker) {
    audioWorker.terminate();
    audioWorker = null;
    workerResultMap.clear();
  }

  // 清理动画
  stopFrameAnimation();

  // ✅ 优化：清理持久化的录音流和音频上下文
  if (persistentRecordingStream) {
    persistentRecordingStream.getTracks().forEach((track) => track.stop());
    persistentRecordingStream = null;
  }

  if (persistentAudioContext && persistentAudioContext.state !== "closed") {
    persistentAudioContext.close().catch(() => {});
    persistentAudioContext = null;
    persistentAnalyser = null;
  }

  // 清理录音资源
  cleanupRecording();
  
  // 清除15秒无操作定时器
  clearNoActionTimer();
});
</script>

<style src="./index.scss" scoped lang="scss"></style>
